(function () {
  'use strict';

  angular
    .module('app.core', [
    ]);

  angular
    .module('fileUpload', ['ngFileUpload']);

  angular
    .module('app', [
      'app.core',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'daterangepicker',
      'pascalprecht.translate',
      'fileUpload',
      'angular-uuid',
      'angular-sly'
    ]);

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/cine/cine.html","<div id=cine><div class=\"menu-bar padding--0_5 display__flex flex-justify-content-center flex-align-item-center\"><odec-bar-menu ng-if=\"cineController.menuData && cineController.menuData.length > 1\" odec-bar-menu-data=cineController.menuData odec-bar-menu-selected=cineController.id></odec-bar-menu></div><odec-view-data-loader odec-view-data-loader-loading=cineController.loading></odec-view-data-loader><!--CHARTS--><div class=\"habito-asistencia display__flex margin-top--0_5 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=\"!cineController.dobleDonutWidget.loading && cineController.dobleDonutWidget.outer.data\" title-header=\"\'hábito de asistencia\'\" extra-options=\"{boldWords:[\'hábito\']}\" copy-to-clipboard-data=cineController.dobleDonutWidget copy-to-clipboard-format-fn=cineController.dobleDonutWidget.dobleDonutWidgetFormatFn></odec-widget-header><odec-no-data ng-if=\"!cineController.dobleDonutWidget.loading && !cineController.dobleDonutWidget.outer.data\"></odec-no-data><odec-view-data-loader odec-view-data-loader-loading=cineController.dobleDonutWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=\"!cineController.dobleDonutWidget.loading && cineController.dobleDonutWidget.outer.data\"><odec-d3-donut-doble ng-if=\"!cineController.dobleDonutWidget.loading && cineController.dobleDonutWidget.outer.data\" legend=cineController.dobleDonutWidget.outer.legend outer=cineController.dobleDonutWidget.outer.data inner=cineController.dobleDonutWidget.inner></odec-d3-donut-doble></div></div></div><div class=\"penetracion-targets padding-top--1 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!cineController.penWidget.loading title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\" copy-to-clipboard-data=cineController.penWidget copy-to-clipboard-format-fn=cineController.penWidget.penWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=cineController.penWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!cineController.penWidget.loading><div class=\"sexo display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!cineController.penWidget.sexo></odec-no-data><odec-d3-sex-widget ng-if=cineController.penWidget.sexo data=cineController.penWidget.sexo></odec-d3-sex-widget></div><div class=\"edad display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!cineController.penWidget.edad></odec-no-data><odec-d3-column options={numColumnLegend:4} series=cineController.penWidget.edad ng-if=cineController.penWidget.edad></odec-d3-column></div><div class=\"indice-socioeconomico display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!cineController.penWidget.iso></odec-no-data><odec-d3-column series=cineController.penWidget.iso ng-if=cineController.penWidget.iso></odec-d3-column></div></div></div></div><div class=\"perfil-targets display__flex padding--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!cineController.perWidget.loading title-header=\"\'perfil por targets\'\" extra-options=\"{boldWords:[\'perfil\']}\" copy-to-clipboard-data=cineController.perWidget copy-to-clipboard-format-fn=cineController.perWidget.perWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=cineController.perWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!cineController.perWidget.loading><div class=sexo><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!cineController.perWidget.sexo></odec-no-data><odec-d3-target-sex-donut ng-if=cineController.perWidget.sexo odec-d3-target-sex-donut-data=cineController.perWidget.sexo></odec-d3-target-sex-donut></div><div class=edad><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!cineController.perWidget.edad></odec-no-data><odec-d3-target-donut ng-if=cineController.perWidget.edad odec-d3-target-donut-data=cineController.perWidget.edad odec-d3-target-donut-icon=\"\'CINE.svg\'\"></odec-d3-target-donut></div><div class=indice-socioeconomico><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!cineController.perWidget.iso></odec-no-data><odec-d3-target-donut ng-if=cineController.perWidget.iso odec-d3-target-donut-data=cineController.perWidget.iso odec-d3-target-donut-icon=\"\'CINE.svg\'\"></odec-d3-target-donut></div></div></div></div></div>");
$templateCache.put("app/cockpit/cockpit.html","<div id=cockpit class=cockpit-content><div class=\"widget-item margin-top--2 display__flex flex-direction-column\"><odec-widget-header ng-if=!cockpit.audience.loading title-header=\"\'audiencia general de medios\'\" extra-options=\"{boldWords:[\'audiencia\']}\" copy-to-clipboard-data=cockpit.audience.data copy-to-clipboard-format-fn=cockpit.audience.formatFn></odec-widget-header><div class=widget-content><odec-widget-audience odec-widget-audience-data=cockpit.audience.data ng-if=cockpit.audience.data></odec-widget-audience><odec-view-data-loader ng-if=\"cockpit.audience.loading && !cockpit.audience.data\" odec-view-data-loader-loading=\"cockpit.audience.loading && !cockpit.audience.data\"></odec-view-data-loader><odec-no-data ng-if=\"!cockpit.audience.loading && !cockpit.audience.data\"></odec-no-data></div></div><!-- <div class=\"widget-item margin-top--2\">\n        <odec-widget-share-bar></odec-widget-share-bar>\n    </div> --><div class=\"widget-item margin-top--2\"><odec-widget-header ng-if=!cockpit.evoPenWidget.loading title-header=cockpit.evoPenWidget.title extra-options=\"{boldWords:[\'evolución\',\'penetración\']}\" copy-to-clipboard-data=cockpit.evoPenWidget.data copy-to-clipboard-format-fn=cockpit.evoPenWidget.formatFn></odec-widget-header><div class=widget-content><odec-view-data-loader ng-if=\"cockpit.evoPenWidget.loading && !cockpit.evoPenWidget.data\" odec-view-data-loader-loading=\"cockpit.evoPenWidget.loading && !cockpit.evoPenWidget.data\"></odec-view-data-loader><odec-no-data ng-if=\"!cockpit.evoPenWidget.loading && !cockpit.evoPenWidget.data\"></odec-no-data><odec-widget-evo-pen ng-if=\"!cockpit.evoPenWidget.loading && cockpit.evoPenWidget.data\" data=cockpit.evoPenWidget.data></odec-widget-evo-pen></div></div></div>");
$templateCache.put("app/diarios/diarios.html","<div id=diarios><div class=\"menu-bar padding--0_5 display__flex flex-justify-content-center flex-align-item-center\"><odec-bar-menu ng-if=\"diariosController.menuData && diariosController.menuData.length > 1\" odec-bar-menu-data=diariosController.menuData odec-bar-menu-selected=diariosController.id></odec-bar-menu></div><odec-view-data-loader odec-view-data-loader-loading=diariosController.loading></odec-view-data-loader><!--CHARTS--><div class=\"ranking-audience-penetration display__flex padding-top--0_5 padding-left--1 padding-right--1\"><div class=\"share padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=\"diariosController.rankWidget.rankDiar && !diariosController.rankWidget.loading\" title-header=\"\'ranking de diarios\'\" extra-options=\"{boldWords:[\'diarios\']}\" copy-to-clipboard-data=diariosController.rankWidget copy-to-clipboard-format-fn=diariosController.rankWidget.rankWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=diariosController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!diariosController.rankWidget.rankDiar && !diariosController.rankWidget.loading\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"diariosController.rankWidget.rankDiar && !diariosController.rankWidget.loading\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL LECTORES DIARIOS</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Lectores/Día (000)</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ diariosController.rankWidget.rankTotal | number }}</p></div></div><div class=legend-notes><p class=\"display__flex flex-justify-content-start flex-align-item-start\">Fuente: Acumulado</p><p class=\"display__flex flex-justify-content-start flex-align-item-start\">(*)Se publica de lunes a sábado</p><p class=\"display__flex flex-justify-content-start flex-align-item-start\">(**)Se publica de lunes a viernes</p></div><odec-d3-bar ng-if=diariosController.rankWidget.rankDiar series=diariosController.rankWidget.rankDiar separe=true></odec-d3-bar></div></div></div><div class=\"audience-penetration display__flex flex-direction-column\"><div class=\"audience-type padding-bottom--0_5\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"diariosController.audienceWidget.data && !diariosController.audienceWidget.loading\" title-header=\"\'audiencia por tipo de diario\'\" extra-options=\"{boldWords:[\'audiencia\']}\" copy-to-clipboard-data=diariosController.audienceWidget.data copy-to-clipboard-format-fn=diariosController.audienceWidget.audienceWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=diariosController.audienceWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!diariosController.audienceWidget.data && !diariosController.audienceWidget.loading\"></odec-no-data><odec-d3-column-thematic ng-if=\"diariosController.audienceWidget.data && !diariosController.audienceWidget.loading\" series=diariosController.audienceWidget.data></odec-d3-column-thematic></div></div><div class=\"penetracion-targets padding-top--0_5\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=!diariosController.penWidget.loading title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\" copy-to-clipboard-data=diariosController.penWidget copy-to-clipboard-format-fn=diariosController.penWidget.penWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=diariosController.penWidget.loading></odec-view-data-loader><div class=\"charts display__flex flex-direction-column\" ng-if=!diariosController.penWidget.loading><div class=\"sexo display__flex flex-direction-column padding--0_5\"><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!diariosController.penWidget.sexo></odec-no-data><odec-d3-sex-widget ng-if=diariosController.penWidget.sexo data=diariosController.penWidget.sexo></odec-d3-sex-widget></div><div class=\"edad display__flex flex-direction-column padding--0_5\"><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!diariosController.penWidget.edad></odec-no-data><odec-d3-column options={numColumnLegend:4} series=diariosController.penWidget.edad ng-if=diariosController.penWidget.edad></odec-d3-column></div><div class=\"indice-socioeconomico display__flex flex-direction-column padding--0_5\"><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!diariosController.penWidget.iso></odec-no-data><odec-d3-column series=diariosController.penWidget.iso ng-if=diariosController.penWidget.iso></odec-d3-column></div></div></div></div></div></div><div class=\"perfil-targets display__flex padding--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=!diariosController.perWidget.loading title-header=\"\'perfil por targets\'\" extra-options=\"{boldWords:[\'perfil\']}\" copy-to-clipboard-data=diariosController.perWidget copy-to-clipboard-format-fn=diariosController.perWidget.perWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=diariosController.perWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!diariosController.perWidget.loading><div class=sexo><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!diariosController.perWidget.sexo></odec-no-data><odec-d3-target-sex-donut ng-if=diariosController.perWidget.sexo odec-d3-target-sex-donut-data=diariosController.perWidget.sexo></odec-d3-target-sex-donut></div><div class=edad><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!diariosController.perWidget.edad></odec-no-data><odec-d3-target-donut ng-if=diariosController.perWidget.edad odec-d3-target-donut-data=diariosController.perWidget.edad odec-d3-target-donut-icon=\"\'DIARIOS.svg\'\"></odec-d3-target-donut></div><div class=indice-socioeconomico><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!diariosController.perWidget.iso></odec-no-data><odec-d3-target-donut ng-if=diariosController.perWidget.iso odec-d3-target-donut-data=diariosController.perWidget.iso odec-d3-target-donut-icon=\"\'DIARIOS.svg\'\"></odec-d3-target-donut></div></div></div></div></div>");
$templateCache.put("app/exterior/exterior.html","<div id=exterior><div class=\"menu-bar padding--0_5 display__flex flex-justify-content-center flex-align-item-center\"><odec-bar-menu ng-if=\"exteriorController.menuData && exteriorController.menuData.length > 1\" odec-bar-menu-data=exteriorController.menuData odec-bar-menu-selected=exteriorController.id></odec-bar-menu></div><!--CHARTS--><div class=\"ranking display__flex padding-top--0_5 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"exteriorController.rankWidget.rankEx && !exteriorController.rankWidget.loading\" title-header=\"\'ranking tipología de soportes de exterior\'\" extra-options=\"{boldWords:[\'ranking\']}\" copy-to-clipboard-data=exteriorController.rankWidget copy-to-clipboard-format-fn=exteriorController.rankWidget.rankWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=exteriorController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=!exteriorController.rankWidget.rankEx></odec-no-data><div class=\"charts display__flex flex-direction-column padding-top--0_5\" ng-if=\"exteriorController.rankWidget.rankEx && !exteriorController.rankWidget.loading\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex flex-align-item-end\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL SEMANA</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Nº individuos que han visto publicidad en la última semana en..(000)</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ exteriorController.rankWidget.rankTotal | number }}</p></div></div><odec-d3-bar series=exteriorController.rankWidget.rankEx></odec-d3-bar></div></div></div><div class=\"penetracion-targets padding-top--1 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=!exteriorController.penWidget.loading title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\" copy-to-clipboard-data=exteriorController.penWidget copy-to-clipboard-format-fn=exteriorController.penWidget.penWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=exteriorController.penWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!exteriorController.penWidget.loading><div class=\"sexo display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!exteriorController.penWidget.sexo></odec-no-data><odec-d3-sex-widget ng-if=exteriorController.penWidget.sexo data=exteriorController.penWidget.sexo></odec-d3-sex-widget></div><div class=\"edad display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!exteriorController.penWidget.edad></odec-no-data><odec-d3-column options={numColumnLegend:4} series=exteriorController.penWidget.edad ng-if=exteriorController.penWidget.edad></odec-d3-column></div><div class=\"indice-socioeconomico display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!exteriorController.penWidget.iso></odec-no-data><odec-d3-column series=exteriorController.penWidget.iso ng-if=exteriorController.penWidget.iso></odec-d3-column></div></div></div></div><div class=\"perfil-targets display__flex padding--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!exteriorController.perWidget.loading title-header=\"\'perfil por targets\'\" extra-options=\"{boldWords:[\'perfil\']}\" copy-to-clipboard-data=exteriorController.perWidget copy-to-clipboard-format-fn=exteriorController.perWidget.perWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=exteriorController.perWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!exteriorController.perWidget.loading><div class=sexo><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!exteriorController.perWidget.sexo></odec-no-data><odec-d3-target-sex-donut ng-if=exteriorController.perWidget.sexo odec-d3-target-sex-donut-data=exteriorController.perWidget.sexo></odec-d3-target-sex-donut></div><div class=edad><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!exteriorController.perWidget.edad></odec-no-data><odec-d3-target-donut ng-if=exteriorController.perWidget.edad odec-d3-target-donut-data=exteriorController.perWidget.edad odec-d3-target-donut-icon=\"\'EXTERIOR.svg\'\"></odec-d3-target-donut></div><div class=indice-socioeconomico><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!exteriorController.perWidget.iso></odec-no-data><odec-d3-target-donut ng-if=exteriorController.perWidget.iso odec-d3-target-donut-data=exteriorController.perWidget.iso odec-d3-target-donut-icon=\"\'EXTERIOR.svg\'\"></odec-d3-target-donut></div></div></div></div></div>");
$templateCache.put("app/internet/internet.html","<div id=internet><div class=\"menu-bar padding--0_5 display__flex flex-justify-content-center flex-align-item-center\"><odec-bar-menu ng-if=\"internetController.menuData && internetController.menuData.length > 1\" odec-bar-menu-data=internetController.menuData odec-bar-menu-selected=internetController.id></odec-bar-menu></div><!--CHARTS--><div class=\"ranking display__flex padding-top--0_5 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"internetController.rankWidget.rankInter && !internetController.rankWidget.loading\" title-header=\"\'ranking tipología de soportes de internet\'\" extra-options=\"{boldWords:[\'ranking\']}\" copy-to-clipboard-data=internetController.rankWidget copy-to-clipboard-format-fn=internetController.rankWidget.rankWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=internetController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!internetController.rankWidget.rankInter && !internetController.rankWidget.loading\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"internetController.rankWidget.rankInter && !internetController.rankWidget.loading\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">Últimos 30 días</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Visitantes únicos (000)</p></div></div></div><odec-d3-bar series=internetController.rankWidget.rankInter decimal=1></odec-d3-bar></div></div></div><div class=\"ranking display__flex padding-top--1 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=\"!internetController.evoChartWidget.loading && internetController.evoChartWidget.data.series\" title-header=\"\'evolución del uso de internet ayer\'\" extra-options=\"{boldWords:[\'internet\']}\" copy-to-clipboard-data=internetController.evoChartWidget.data copy-to-clipboard-format-fn=internetController.evoChartWidget.evoChartWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=internetController.evoChartWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!internetController.evoChartWidget.loading && !internetController.evoChartWidget.data.series\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"!internetController.evoChartWidget.loading && internetController.evoChartWidget.data.series\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">DATOS POR OLA</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Individuos que accedieron ayer a Internet</p></div></div></div><odec-highcharts id=combo-dual-axes ng-if=internetController.evoChartWidget.data.series odec-highcharts-config=internetController.evoChartConfig odec-highcharts-data=internetController.evoChartWidget.data.series odec-highcharts-categories=internetController.evoChartWidget.data.categories></odec-highcharts></div></div></div><div class=\"penetracion-targets padding-top--1 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=!internetController.penWidget.loading title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\" copy-to-clipboard-data=internetController.penWidget copy-to-clipboard-format-fn=internetController.penWidget.penWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=internetController.penWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!internetController.penWidget.loading><div class=\"sexo display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!internetController.penWidget.sexo></odec-no-data><odec-d3-sex-widget ng-if=internetController.penWidget.sexo data=internetController.penWidget.sexo></odec-d3-sex-widget></div><div class=\"edad display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!internetController.penWidget.edad></odec-no-data><odec-d3-column options={numColumnLegend:4} series=internetController.penWidget.edad ng-if=internetController.penWidget.edad></odec-d3-column></div><div class=\"indice-socioeconomico display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!internetController.penWidget.iso></odec-no-data><odec-d3-column series=internetController.penWidget.iso ng-if=internetController.penWidget.iso></odec-d3-column></div></div></div></div><div class=\"perfil-targets display__flex padding--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!internetController.perWidget.loading title-header=\"\'perfil por targets\'\" extra-options=\"{boldWords:[\'perfil\']}\" copy-to-clipboard-data=internetController.perWidget copy-to-clipboard-format-fn=internetController.perWidget.perWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=internetController.perWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!internetController.perWidget.loading><div class=sexo><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!internetController.perWidget.sexo></odec-no-data><odec-d3-target-sex-donut ng-if=internetController.perWidget.sexo odec-d3-target-sex-donut-data=internetController.perWidget.sexo></odec-d3-target-sex-donut></div><div class=edad><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!internetController.perWidget.edad></odec-no-data><odec-d3-target-donut ng-if=internetController.perWidget.edad odec-d3-target-donut-data=internetController.perWidget.edad odec-d3-target-donut-icon=\"\'INTERNET.svg\'\"></odec-d3-target-donut></div><div class=indice-socioeconomico><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!internetController.perWidget.iso></odec-no-data><odec-d3-target-donut ng-if=internetController.perWidget.iso odec-d3-target-donut-data=internetController.perWidget.iso odec-d3-target-donut-icon=\"\'INTERNET.svg\'\"></odec-d3-target-donut></div></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=login-wrapper><div class=login-wrapper--inner><form><div class=\"logo-wrapper text-center margin-top--2\"><img src=assets/images/aimc_logo.svg height=100></div><div class=\"login-form margin-left--1_5 margin-right--1_5\"><div class=\"margin-top--1_5 login-input\"><input type=text name=username placeholder=Usuario autofocus ng-model=login.username autocomplete=off></div><div class=\"margin-top--1 login-input\"><input #password type=password name=password placeholder=Contraseña ng-model=login.password autocomplete=off></div></div><div class=\"login-errors margin--0_5 margin-left--2\" ng-if=login.errorMessage><span class=\"label text-error message_wrapped\"><small>{{login.errorMessage}}</small></span></div><div class=\"text-center margin-left--1_5 margin-right--1_5 margin-top--1_5\"><odec-loading-button class=padding--0_5 ng-click=login.login(login.username,login.password) odec-loading-button-loading=login.loading><span>Iniciar Sesión</span></odec-loading-button></div><div class=text-center><a class=forgot ng-href={{login.forgotpass}}><i class=\"helppage-icon icon-size-lg icon-help margin-right--0_5\"></i> <span>¿Recordar Contraseña?</span></a></div><div class=\"link-row margin--1\"><div class=\"help-link margin--0_5\"><a ui-sref=helppage class=link-row-item><i class=\"helppage-icon icon-size-lg icon-info2 margin-right--0_5\"></i> <span>Ayuda</span></a></div><div class=margin--0_5><a ui-sref=privacypage class=link-row-item><i class=\"helppage-icon icon-size-lg icon-lock margin-right--0_5\"></i> <span>Privacidad</span></a></div></div></form></div></div>");
$templateCache.put("app/main/main.html","<odec-layout-ui><div class=main-content ng-class=\"{\'production-date\': main.puppeter}\"><odec-header class=no-print ng-class=\"{\'opened-filter-header\': main.filterOpened}\"><div class=header-logos><a href=https://www.aimc.es class=header-logos-item><img ng-src=assets/images/headerlogo1.svg src=assets/images/headerlogo1.svg height=100% width=100%></a><a href=https://www.aimc.es class=\"header-logos-item mobile-hide\"><img ng-src=assets/images/texto-logo.svg src=assets/images/texto-logo.svg height=100% width=100%></a></div><ul class=header-nav><li class=\"header-nav-item header-actions\"><div class=\"header-nav-notifications header-actions-item text-center padding-left--0_5\"><button class=\"wave-menu-button header-nav-item-toggle\" uib-tooltip=\"Selector de olas\" tooltip-placement=bottom ng-click=\"main.filterOpened = !main.filterOpened\"><div class=wave-selection-trigger><span class=vas>{{main.waves.selected.year}}-{{main.waves.selected.wave | waveToOla}}</span> <i class=\"icon-size-xl icon-arrow_drop_down\"></i></div></button></div><div class=\"header-nav-notifications header-actions-item text-center\" uib-tooltip=Inicio tooltip-placement=bottom><a ui-sref=main.cockpit class=header-nav-notifications-item><i class=\"icon-size-lg icon-aimc-home\"></i></a></div></li></ul></odec-header><div class=content-wrapper><odec-jerarquic-filter ng-if=main.filterOpened odec-jerarquic-filter-opened=main.filterOpened odec-jerarquic-filter-waves=main.waves></odec-jerarquic-filter><div ui-view=content></div></div></div></odec-layout-ui>");
$templateCache.put("app/politicaPrivacidad/politicaPrivacidad.html","<div class=politicaPrivacidad-wrapper><h1>¿Quién es el responsable del tratamiento de sus datos?</h1><p><strong>ASOCIACIÓN PARA LA INVESTIGACIÓN DE MEDIOS DE COMUNICACIÓN (AIMC)</strong></p><p>CIF: G-78982733</p><p>Domicilio: Calle Basílica 19, 8ºA, 28020, Madrid</p><p>Teléfono: 91 570 11 74</p><p>Mail: <a href=mailto:lopd@aimc.es>lopd@aimc.es</a></p><p>Nos reservamos el derecho a modificar o adaptar la presente Política de Privacidad en cualquier momento. Le recomendamos revisar la misma en nuestra página web (<a href=https://www.aimc.es>https://www.aimc.es</a>) para mantenerse actualizado.</p><h2>+APLICACIÓN AIMC-EGM</h2><p>Esta aplicación consiste en la visualización de los datos del estudio EGM que lleva a cabo el Responsable del Tratamiento.</p><p>En la aplicación existen dos tipos de perfiles:</p><ol><li>Usuarios que se registran en la aplicación y acceden al contenido restringido.</li><li>Usuarios que no se registran en la aplicación y únicamente acceden al contenido público.</li></ol><p>Si quiere conocer más información acerca del EGM, puede consultar el siguiente enlace: <a href=https://www.aimc.es/egm/que-es-el-egm/ >https://www.aimc.es/egm/que-es-el-egm/</a></p><p>Le informamos que el tratamiento de sus datos personales a través de la aplicación no conlleva la cesión de datos a terceros, salvo por obligación legal, y, en su caso, los terceros debidamente autorizados para ello a través de correspondientes contratos podrán acceder a los datos personales facilitados con el fin de ejecutar las obligaciones a las que se comprometen.</p><p>El Responsable del Tratamiento no realiza elaboración de perfiles del usuario, ni se procesan los datos para la segmentación, personalización de contenidos o recomendaciones. Además, tampoco se llevan a cabo transferencias internacionales de datos, ya que los datos se encuentran alojados en España.</p><h3>¿Qué datos vamos a tratar?</h3><p>Trataremos únicamente los datos necesarios para el registro en la propia aplicación y para acceder al contenido restringido. Los datos necesarios para el registro de usuario son datos identificativos, específicamente nombre y apellidos y correo electrónico.</p><p>Cabe destacar que, si un usuario solo accede a contenidos públicos, la aplicación no recogerá ningún dato personal del mismo, ya que para ello no es necesario el registro del usuario.</p><h3>¿Con qué finalidades vamos a tratar sus datos personales?</h3><p>El tratamiento de los datos personales se lleva a cabo exclusivamente para permitir al usuario el acceso a las funciones avanzadas de la aplicación, por las cuales el usuario puede acceder a contenidos restringidos del estudio EGM.</p><p>El Responsable llevará a cabo un registro de los accesos de los usuarios registrados en la aplicación para acceder a los servicios avanzados. Los datos que se recogen en el registro de accesos son el id interno de los usuarios y la fecha del inicio de la sesión, con la finalidad de garantizar la seguridad y el correcto funcionamiento de la aplicación, así como para fines estadísticos que permitan mejorar la experiencia del usuario y optimizar los servicios ofrecidos, siempre respetando la privacidad y confidencialidad de los datos.</p><h3>¿Cuál es la legitimación para el tratamiento de sus datos?</h3><p>La existencia de una relación contractual entre las partes.</p><h3>¿Durante cuánto tiempo vamos a mantener los datos personales?</h3><p>Hasta la baja del usuario en la aplicación. Cuando el usuario elimina su cuenta personal, los datos de este se suprimen de forma permanente, no almacenando estos datos en los sistemas de la aplicación. Además, cabe destacar que no se mantiene ningún registro histórico de usuarios eliminados.</p><h3>INFORMACIÓN ADICIONAL SOBRE LOS TRATAMIENTOS DE SUS DATOS:</h3><h4>¿Incluimos datos personales de terceras personas?</h4><p>No, como norma general sólo tratamos los datos que nos facilitan los titulares. Si nos aporta datos de terceros, deberá con carácter previo informar y solicitar su consentimiento a dichas personas, o de lo contrario nos exime de cualquier responsabilidad por el incumplimiento de este requisito.</p><h4>¿Y datos de menores?</h4><p>No tratamos datos de menores de 14 años. Por tanto, absténgase de facilitarlos si no tiene esa edad o, en su caso, de facilitar datos de terceros que no tengan la citada edad. AIMC se exime de cualquier responsabilidad por el incumplimiento de esta previsión.</p><h4>¿Qué medidas de seguridad aplicamos?</h4><p>Puedes estar tranquilo: Hemos adoptado un nivel óptimo de protección de los datos personales que manejamos y hemos instalado todos los medios y medidas técnicas a nuestra disposición según el estado de la tecnología para evitar la pérdida, mal uso, alteración, acceso no autorizado y robo.</p><h4>¿A qué destinatarios se comunicarán sus datos?</h4><p>Sus datos no se cederán a terceros, salvo obligación legal. No obstante lo anterior, sus datos podrán ser comunicados a la Agencia Estatal de la Administración Tributaria y a bancos y entidades financieras para el cobro del servicio prestado o producto adquirido, así como a los encargados del tratamiento necesarios para la ejecución del acuerdo, con quienes suscribiremos el correspondiente acuerdo de encargo en los términos del art. 28 del RGPD.</p><h3>¿Qué Derechos tiene?</h3><ul><li>A acceder a sus datos personales.</li><li>A solicitar la rectificación de sus datos si estos son inexactos.</li><li>A solicitar la supresión de sus datos.</li><li>A retirar los consentimientos otorgados.</li><li>A solicitar la limitación del tratamiento de sus datos.</li><li>A no ser objeto de decisiones automatizadas.</li><li>A portar sus datos, que le serán facilitados en un formato estructurado, de uso común o lectura mecánica.</li><li>A presentar una reclamación ante la Agencia Española de Protección de Datos (<a href=https://www.aepd.es>www.aepd.es</a>)</li></ul><p>Si modifica algún dato, le agradecemos que nos lo comunique para mantenerlos actualizados.</p><h3>¿Cómo ejercer sus derechos?</h3><p>Tenemos formularios para el ejercicio de sus derechos, puede pedirlos por email o, si lo prefiere, puede usar los elaborados por la Agencia Española de Protección de Datos o terceros.</p><p>Los formularios pueden ser presentados presencialmente, enviados por carta o por mail en la dirección del Responsable, disponible al inicio de este texto.</p><h3>¿Cuánto tardamos en contestar al Ejercicio de derechos?</h3><p>Un mes desde la recepción, prorrogable por dos meses adicionales, siempre que el ejercicio del derecho lo requiera debido a su complejidad, notificándoselo en tiempo y forma.</p><h3>¿Tratamos cookies?</h3><p>Si usamos otro tipo de cookies que no sean las necesarias, podrá consultar la <a href=#>Política de Cookies</a> en el enlace correspondiente, disponible en el inicio de nuestra web.</p></div>");
$templateCache.put("app/radio/radio.html","<div id=radio><div class=\"menu-bar padding--0_5 display__flex flex-justify-content-center flex-align-item-center\"><odec-bar-menu ng-if=\"radioController.menuData && radioController.menuData.length > 1\" odec-bar-menu-data=radioController.menuData odec-bar-menu-selected=radioController.id></odec-bar-menu></div><odec-view-data-loader odec-view-data-loader-loading=radioController.loading></odec-view-data-loader><!--CHARTS--><div class=\"ranking-audience-listeners display__flex margin-top--0_5 padding-left--1 padding-right--1\"><div class=\"share padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!radioController.ranking.loading title-header=\"\'cadenas de radio\'\" show-filters=true filter-id=\"\'radioRanking\'\" filters=radioController.filters.w1 copy-to-clipboard-data=radioController.ranking copy-to-clipboard-format-fn=radioController.ranking.rankWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=radioController.ranking.loading></odec-view-data-loader><odec-no-data ng-if=\"!radioController.ranking.loading && !radioController.ranking.generalista.series\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"!radioController.ranking.loading && radioController.ranking.generalista.series.length > 0\"><!-- TOTAL CADENAS --><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL RADIO</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">{{ radioController.filters.w1[0].selected.subtitle }}</p></div><!-- VALUE --><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ radioController.ranking.total | number }}</p></div></div><!-- RANKING GENERALISTAS --><div class=mid-chart-title>RANKING <b>{{ radioController.filters.w1[0].selected.title }} RADIOS GENERALISTAS</b></div><div class=\"info-chart flex-direction-column display__flex flex-justify-content-between\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL RADIO GENERALISTA</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">{{ radioController.filters.w1[0].selected.subtitle }}</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ radioController.ranking.generalista.total | number }}</p></div></div><!-- CHART --><odec-d3-bar class=chart-generalistas ng-if=\"radioController.ranking.generalista.series.length > 0\" series=radioController.ranking.generalista.series decimal=\"radioController.filters.w1[0].selected.id === \'sh\' && 1\"></odec-d3-bar><!-- RANKING TEMATICAS --><div class=mid-chart-title>RANKING <b>{{ radioController.filters.w1[0].selected.title }} RADIOS TEMÁTICAS</b></div><div class=\"info-chart flex-direction-column display__flex flex-justify-content-between\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL RADIO TEMÁTICA</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">{{ radioController.filters.w1[0].selected.subtitle }}</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ radioController.ranking.tematica.total | number }}</p></div></div><!-- CHART --><odec-d3-bar class=chart-tematicas series=radioController.ranking.tematica.series decimal=\"radioController.filters.w1[0].selected.id === \'sh\' && 1\"></odec-d3-bar></div></div></div><!-- PANEL DERECHO --><div class=\"audience-penetration display__flex flex-direction-column\"><!-- OYENTES 1 --><div class=\"audience-type padding-bottom--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=!radioController.audience.loading title-header=\"\'oyentes\'\" filter-id=\"\'radioAudience\'\" filters=radioController.filters.w2 extra-options=\"{boldWords:[\'oyentes\']}\" copy-to-clipboard-data=radioController.audience copy-to-clipboard-format-fn=radioController.audience.audienceWidgetFormatFn></odec-widget-header><p class=\"subtitle padding-top--0_5\" ng-if=\"!radioController.audience.loading && radioController.audience.series\">RADIO TEMÁTICA POR CONTENIDOS</p><odec-no-data ng-if=\"!radioController.audience.loading && !radioController.audience.series\"></odec-no-data><odec-view-data-loader odec-view-data-loader-loading=radioController.audience.loading></odec-view-data-loader><odec-d3-column-thematic ng-if=\"!radioController.audience.loading && radioController.audience.series\" series=radioController.audience.series></odec-d3-column-thematic></div></div><!-- PENETRACION --><div class=penetracion-targets><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!radioController.penWidget.loading title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\" copy-to-clipboard-data=radioController.penWidget copy-to-clipboard-format-fn=radioController.penWidget.penWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=radioController.penWidget.loading></odec-view-data-loader><div class=\"charts display__flex flex-direction-column\" ng-if=!radioController.penWidget.loading><div class=\"sexo display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!radioController.penWidget.sexo></odec-no-data><odec-d3-sex-widget ng-if=radioController.penWidget.sexo data=radioController.penWidget.sexo></odec-d3-sex-widget></div><div class=\"edad display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!radioController.penWidget.edad></odec-no-data><odec-d3-column options={numColumnLegend:4} series=radioController.penWidget.edad ng-if=radioController.penWidget.edad></odec-d3-column></div><div class=\"indice-socioeconomico display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!radioController.penWidget.iso></odec-no-data><odec-d3-column series=radioController.penWidget.iso ng-if=radioController.penWidget.iso></odec-d3-column></div></div></div></div><!--  \n                OYENTES 2\n                <div class=\"audience-type padding-top--0_5\">\n                    <div class=\"card display__flex flex-direction-column padding--0_5\">\n                        <odec-widget-header title-header=\"\'audiencia por tipo de diario\'\" show-filters=\"false\" filters=\"radioController.filters.w1\"\n                            show-snapshot=\"false\" show-info=\"true\" extra-options=\"{boldWords:[\'penetración\']}\">\n                        </odec-widget-header>\n                        <odec-d3-column-thematic></odec-d3-column-thematic>\n                    </div>\n                </div>   --></div></div><!-- PENETRACION --><!-- <div class=\"penetracion-targets padding-top--1 padding-left--1 padding-right--1\">\n            <div class=\"card display__flex flex-direction-column padding--0_5\">\n              <odec-widget-header title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\">\n              </odec-widget-header>\n              <odec-view-data-loader odec-view-data-loader-loading=\"radioController.penWidget.loading\"></odec-view-data-loader>\n              <div class=\"charts display__flex\" ng-if=\"!radioController.penWidget.loading\">\n                <div class=\"sexo display__flex flex-direction-column\">\n                  <p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p>\n                  <odec-d3-sex-widget \n                    ng-if=\"radioController.penWidget.sexo\"\n                    data=\"radioController.penWidget.sexo\">\n                  </odec-d3-sex-widget>\n                </div>\n                <div class=\"edad display__flex flex-direction-column\">\n                  <p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p>\n                  <odec-d3-column \n                    options=\"{numColumnLegend:4}\" \n                    series = \"radioController.penWidget.edad\"\n                    ng-if=\"radioController.penWidget.edad\">\n                  </odec-d3-column>\n                </div>\n                <div class=\"indice-socioeconomico display__flex flex-direction-column\">\n                  <p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p>\n                  <odec-d3-column \n                    series=\"radioController.penWidget.iso\" \n                    ng-if=\"radioController.penWidget.iso\">\n                  </odec-d3-column>\n                </div>\n              </div>\n            </div>\n          </div> --><!-- PERFIL --><div class=\"perfil-targets display__flex padding--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=!radioController.perWidget.loading title-header=\"\'perfil por targets\'\" extra-options=\"{boldWords:[\'perfil\']}\" copy-to-clipboard-data=radioController.perWidget copy-to-clipboard-format-fn=radioController.perWidget.perWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=radioController.perWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!radioController.perWidget.loading><div class=sexo><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!radioController.perWidget.sexo></odec-no-data><odec-d3-target-sex-donut ng-if=radioController.perWidget.sexo odec-d3-target-sex-donut-data=radioController.perWidget.sexo></odec-d3-target-sex-donut></div><div class=edad><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!radioController.perWidget.edad></odec-no-data><odec-d3-target-donut ng-if=radioController.perWidget.edad odec-d3-target-donut-data=radioController.perWidget.edad odec-d3-target-donut-icon=\"\'RADIO.svg\'\"></odec-d3-target-donut></div><div class=indice-socioeconomico><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!radioController.perWidget.iso></odec-no-data><odec-d3-target-donut ng-if=radioController.perWidget.iso odec-d3-target-donut-data=radioController.perWidget.iso odec-d3-target-donut-icon=\"\'RADIO.svg\'\"></odec-d3-target-donut></div></div></div></div></div>");
$templateCache.put("app/revistas/revistas.html","<div id=revistas><div class=\"menu-bar padding--0_5 display__flex flex-justify-content-center flex-align-item-center\"><odec-bar-menu ng-if=\"revistasController.menuData && revistasController.menuData.length > 1\" odec-bar-menu-data=revistasController.menuData odec-bar-menu-selected=revistasController.id></odec-bar-menu></div><!--CHARTS--><div class=\"share-and-ranking display__flex margin-top--0_5 padding-left--1 padding-right--1\"><div class=\"share padding-right--0_5\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankMen\" title-header=\"\'ranking de revistas mensuales\'\" extra-options=\"{boldWords:[\'revistas mensuales\']}\" copy-to-clipboard-data=revistasController.rankWidget copy-to-clipboard-format-fn=revistasController.rankWidget.rankMenWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=revistasController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!revistasController.rankWidget.loading && !revistasController.rankWidget.rankMen\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankMen\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL LECTORES REVISTAS MENSUALES</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Lectores/Mes (000)</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ revistasController.rankWidget.totalMen | number }}</p></div></div><div class=legend-notes><p class=\"display__flex flex-justify-content-start flex-align-item-start\">Fuente: Acumulado</p></div><odec-d3-bar ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankMen\" series=revistasController.rankWidget.rankMen></odec-d3-bar></div></div></div><div class=\"ranking-group padding-left--0_5\"><div class=card><div ng-style=\"revistasController.rankWidget.rankTrim ? {\'height\': \'28%\'} : {\'height\': \'45%\'}\" class=\"display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankSem\" title-header=\"\'ranking de revistas semanales\'\" extra-options=\"{boldWords:[\'revistas semanales\']}\" copy-to-clipboard-data=revistasController.rankWidget copy-to-clipboard-format-fn=revistasController.rankWidget.rankSemWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=revistasController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!revistasController.rankWidget.loading && !revistasController.rankWidget.rankSem\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankSem\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL LECTORES REVISTAS SEMANALES</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Lectores/semana (000)</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ revistasController.rankWidget.totalSem | number }}</p></div></div><div class=legend-notes><p class=\"display__flex flex-justify-content-start flex-align-item-start\">Fuente: Acumulado</p></div><odec-d3-bar class=margin-top--0_5 series=revistasController.rankWidget.rankSem></odec-d3-bar></div></div><div ng-style=\"revistasController.rankWidget.rankTrim ? {\'height\': \'20%\'} : {\'height\': \'25%\'}\" class=\"display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankQuin\" title-header=\"\'ranking de revistas quincenales\'\" extra-options=\"{boldWords:[\'revistas quincenales\']}\"></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=revistasController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!revistasController.rankWidget.loading && !revistasController.rankWidget.rankQuin\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankQuin\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"extra-info bold--700 display__flex flex-justify-content-end flex-align-item-end\">TOTAL LECTORES REVISTAS QUINCENALES</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Lectores/Quincena (000)</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ revistasController.rankWidget.totalQuin | number }}</p></div></div><div class=legend-notes><p class=\"display__flex flex-justify-content-start flex-align-item-start\">Fuente: Acumulado</p></div><odec-d3-bar class=margin-top--0_5 series=revistasController.rankWidget.rankQuin></odec-d3-bar></div></div><div ng-style=\"revistasController.rankWidget.rankTrim ? {\'height\': \'28%\'} : {\'height\': \'30%\'}\" class=\"display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankBim\" title-header=\"\'ranking de revistas bimestrales\'\" extra-options=\"{boldWords:[\'revistas bimestrales\']}\"></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=revistasController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!revistasController.rankWidget.loading && !revistasController.rankWidget.rankBim\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankBim\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL LECTORES REVISTAS BIMESTRALES</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Lectores/Bimestre (000)</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ revistasController.rankWidget.totalBim | number }}</p></div></div><div class=legend-notes><p class=\"display__flex flex-justify-content-start flex-align-item-start\">Fuente: Acumulado</p></div><odec-d3-bar class=margin-top--0_5 series=revistasController.rankWidget.rankBim></odec-d3-bar></div></div><div ng-if=revistasController.rankWidget.rankTrim ng-style=\"revistasController.rankWidget.rankTrim ? {\'height\': \'25%\'} : {\'height\': \'0px\'}\" class=\"rank-trim display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankTrim\" title-header=\"\'ranking de revistas trimestrales\'\" extra-options=\"{boldWords:[\'revistas trimestrales\']}\"></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=revistasController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!revistasController.rankWidget.loading && !revistasController.rankWidget.rankTrim\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"!revistasController.rankWidget.loading && revistasController.rankWidget.rankTrim\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL LECTORES REVISTAS TRIMESTRALES</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Lectores/Trimestre (000)</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ revistasController.rankWidget.totalTrim | number }}</p></div></div><div class=legend-notes><p class=\"display__flex flex-justify-content-start flex-align-item-start\">Fuente: Acumulado</p></div><odec-d3-bar class=margin-top--0_5 series=revistasController.rankWidget.rankTrim></odec-d3-bar></div></div></div></div></div><div class=\"penetracion-targets padding-top--1 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\" copy-to-clipboard-data=revistasController.penWidget copy-to-clipboard-format-fn=revistasController.penWidget.penWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=revistasController.penWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!revistasController.penWidget.loading><div class=\"sexo display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!revistasController.penWidget.sexo></odec-no-data><odec-d3-sex-widget ng-if=revistasController.penWidget.sexo data=revistasController.penWidget.sexo></odec-d3-sex-widget></div><div class=\"edad display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!revistasController.penWidget.edad></odec-no-data><odec-d3-column options={numColumnLegend:4} series=revistasController.penWidget.edad ng-if=revistasController.penWidget.edad></odec-d3-column></div><div class=\"indice-socioeconomico display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!revistasController.penWidget.iso></odec-no-data><odec-d3-column series=revistasController.penWidget.iso ng-if=revistasController.penWidget.iso></odec-d3-column></div></div></div></div><div class=\"perfil-targets display__flex padding--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header title-header=\"\'perfil por targets\'\" extra-options=\"{boldWords:[\'perfil\']}\" copy-to-clipboard-data=revistasController.perWidget copy-to-clipboard-format-fn=revistasController.perWidget.perWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=revistasController.perWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!revistasController.perWidget.loading><div class=sexo><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!revistasController.perWidget.sexo></odec-no-data><odec-d3-target-sex-donut ng-if=revistasController.perWidget.sexo odec-d3-target-sex-donut-data=revistasController.perWidget.sexo></odec-d3-target-sex-donut></div><div class=edad><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!revistasController.perWidget.edad></odec-no-data><odec-d3-target-donut ng-if=revistasController.perWidget.edad odec-d3-target-donut-data=revistasController.perWidget.edad odec-d3-target-donut-icon=\"\'REVISTAS.svg\'\"></odec-d3-target-donut></div><div class=indice-socioeconomico><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!revistasController.perWidget.iso></odec-no-data><odec-d3-target-donut ng-if=revistasController.perWidget.iso odec-d3-target-donut-data=revistasController.perWidget.iso odec-d3-target-donut-icon=\"\'REVISTAS.svg\'\"></odec-d3-target-donut></div></div></div></div></div>");
$templateCache.put("app/snapshots/snapshots.html","<div id=snapshots><div class=\"container-fluid padding--1_5\"><div class=\"snapshots-collections-actions padding-bottom--2 row\"><div class=col-md-6><button class=\"btn btn-md btn-action\" ng-disabled=!snapshots.lastState.state.name ng-click=snapshots.goBack() uib-tooltip=Atrás><i class=\"icon-size-lg icon-arrow_back text-system\"></i></button></div><div class=\"col-md-6 text-right\" ng-if=\"snapshots.snapshotsCollection.length > 0\"><button class=\"btn btn-md btn-action\" ng-disabled=snapshots.exportingPPT ng-click=snapshots.createPPT(snapshots.snapshotsCollection) uib-tooltip=\"Descargar PowerPoint\"><i class=\"icon-size-lg icon-ppt-business-presentation-file-format-symbol text-system\"></i> <i ng-if=snapshots.exportingPPT class=\"icon-size-md icon-spinner22 animated-spin margin-left--0_5\"></i></button> <button class=\"btn btn-md btn-action\" ng-click=snapshots.clearAll() uib-tooltip=\"Eliminar todos\"><i class=\"icon-size-lg icon-times text-system\"></i></button></div></div><div ng-if=\"!snapshots.snapshotsCollection.length > 0\" class=\"text-center padding--2\"><span><i class=\"icon-size-xl icon-notification margin-right--0_5\"></i></span><span class=warning-message>No hay capturas disponibles</span></div><div class=\"snapshots-miniatures-wrapper panel-like-borders row\" ng-if=\"snapshots.snapshotsCollection.length > 0\"><div class=\"col-md-12 snapshots-collection-strip padding--1\" odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#AA142D><div class=snapshots-miniatures-horizontal-scroller><a class=\"snapshots-miniature margin-left--1\" ng-repeat=\"snap in snapshots.snapshotsCollection track by $index\" ng-click=\"snapshots.selectedImage = snap;snapshots.selectedImage.index = $index;\"><img ng-src={{snap.image}} alt=\"\"></a></div></div></div><div class=margin-top--1 ng-if=\"snapshots.snapshotsCollection.length > 0\"><p>* Selecciona una imagen para editarla</p></div><div class=\"margin-top--2 separator-bottom\" ng-if=snapshots.selectedImage><p>Editar captura</p></div><div class=\"snapshots-image-viz margin-top--2 row\" ng-if=snapshots.selectedImage><div class=col-md-8><img ng-src={{snapshots.selectedImage.image}} class=snapshots-image-full alt=\"\"></div><div class=\"col-md-4 row\"><form name=snapshotsForm><div class=\"col-md-12 form-group\"><label class=control-label>Título</label><input type=text class=\"form-control material-input\" ng-model=snapshots.selectedImage.title></div><div class=\"col-md-12 form-group\"><label class=control-label>Filtro</label><input type=text class=\"form-control material-input\" ng-model=snapshots.selectedImage.filter></div><div class=\"col-md-12 form-group\"><label class=control-label>Descripción</label><input type=text name=\"\" class=\"form-control material-input\" ng-model=snapshots.selectedImage.description></div><div class=\"col-md-12 text-right padding--1\"><button class=\"btn btn-md btn-action\" ng-if=snapshotsForm.$dirty ng-click=snapshots.update(snapshots.selectedImage) uib-tooltip=Guardar><i class=\"icon-size-lg icon-save text-system\"></i></button> <button class=\"btn btn-md btn-action\" ng-click=snapshots.remove(snapshots.selectedImage) uib-tooltip=Eliminar><i class=\"icon-size-lg icon-bin text-system\"></i></button></div></form></div></div></div></div>");
$templateCache.put("app/suplementos/suplementos.html","<div id=suplementos><div class=\"menu-bar padding--0_5 display__flex flex-justify-content-center flex-align-item-center\"><odec-bar-menu ng-if=\"suplementosController.menuData && suplementosController.menuData.length > 1\" odec-bar-menu-data=suplementosController.menuData odec-bar-menu-selected=suplementosController.id></odec-bar-menu></div><!--CHARTS--><div class=\"ranking display__flex padding-top--0_5 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"suplementosController.rankWidget.rankSup && !suplementosController.rankWidget.loading\" title-header=\"\'ranking de suplementos\'\" extra-options=\"{boldWords:[\'ranking\']}\" copy-to-clipboard-data=suplementosController.rankWidget copy-to-clipboard-format-fn=suplementosController.rankWidget.rankWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=suplementosController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!suplementosController.rankWidget.rankSup && !suplementosController.rankWidget.loading\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"suplementosController.rankWidget.rankSup && !suplementosController.rankWidget.loading\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL LECTORES DE SUPLEMENTOS</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Lectores/Semana (000)</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{ suplementosController.rankWidget.rankTotal | number }}</p></div></div><div class=legend-notes><p class=\"display__flex flex-justify-content-start flex-align-item-start\">Fuente: Acumulado</p><p class=\"display__flex flex-justify-content-start flex-align-item-start\">(*)Se publica de lunes a sábado</p><p class=\"display__flex flex-justify-content-start flex-align-item-start\">(**)Se publica de lunes a viernes</p></div><odec-d3-bar series=suplementosController.rankWidget.rankSup></odec-d3-bar></div></div></div><div class=\"penetracion-targets padding-top--1 padding-left--1 padding-right--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!suplementosController.penWidget.loading title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\" copy-to-clipboard-data=suplementosController.penWidget copy-to-clipboard-format-fn=suplementosController.penWidget.penWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=suplementosController.penWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!suplementosController.penWidget.loading><div class=\"sexo display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!suplementosController.penWidget.sexo></odec-no-data><odec-d3-sex-widget ng-if=suplementosController.penWidget.sexo data=suplementosController.penWidget.sexo></odec-d3-sex-widget></div><div class=\"edad display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!suplementosController.penWidget.edad></odec-no-data><odec-d3-column options={numColumnLegend:4} series=suplementosController.penWidget.edad ng-if=suplementosController.penWidget.edad></odec-d3-column></div><div class=\"indice-socioeconomico display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!suplementosController.penWidget.iso></odec-no-data><odec-d3-column series=suplementosController.penWidget.iso ng-if=suplementosController.penWidget.iso></odec-d3-column></div></div></div></div><div class=\"perfil-targets display__flex padding--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!suplementosController.perWidget.loading title-header=\"\'perfil por targets\'\" extra-options=\"{boldWords:[\'perfil\']}\" copy-to-clipboard-data=suplementosController.perWidget copy-to-clipboard-format-fn=suplementosController.perWidget.perWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=suplementosController.perWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!suplementosController.perWidget.loading><div class=sexo><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!suplementosController.perWidget.sexo></odec-no-data><odec-d3-target-sex-donut ng-if=suplementosController.perWidget.sexo odec-d3-target-sex-donut-data=suplementosController.perWidget.sexo></odec-d3-target-sex-donut></div><div class=edad><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!suplementosController.perWidget.edad></odec-no-data><odec-d3-target-donut ng-if=suplementosController.perWidget.edad odec-d3-target-donut-data=suplementosController.perWidget.edad odec-d3-target-donut-icon=\"\'SUPLEMENTOS.svg\'\"></odec-d3-target-donut></div><div class=indice-socioeconomico><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!suplementosController.perWidget.iso></odec-no-data><odec-d3-target-donut ng-if=suplementosController.perWidget.iso odec-d3-target-donut-data=suplementosController.perWidget.iso odec-d3-target-donut-icon=\"\'SUPLEMENTOS.svg\'\"></odec-d3-target-donut></div></div></div></div></div>");
$templateCache.put("app/television/television.html","<div id=television><div class=\"menu-bar padding--0_5 display__flex flex-justify-content-center flex-align-item-center\"><odec-bar-menu ng-if=\"televisionController.menuData && televisionController.menuData.length > 1\" odec-bar-menu-data=televisionController.menuData odec-bar-menu-selected=televisionController.id></odec-bar-menu></div><!--CHARTS--><div class=\"share-and-ranking display__flex margin-top--0_5 padding-left--1 padding-right--1\"><div class=\"share padding-right--0_5\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-justify-content-center flex-align-item-center\"><odec-widget-header ng-if=\"televisionController.rankWidget.reachData && !televisionController.rankWidget.loading\" title-header=\"\'Ranking de cadenas de televisión\'\" extra-options=\"{boldWords:[\'televisión\']}\" filter-id=\"\'tvRanking\'\" filters=televisionController.filters.w1 copy-to-clipboard-data=televisionController.rankWidget copy-to-clipboard-format-fn=televisionController.rankWidget.mainTvRankFormatFn></odec-widget-header><odec-no-data ng-if=\"!televisionController.rankWidget.loading && !televisionController.rankWidget.reachData\"></odec-no-data><odec-view-data-loader odec-view-data-loader-loading=televisionController.rankWidget.loading></odec-view-data-loader><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"televisionController.rankWidget.reachData && !televisionController.rankWidget.loading\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">{{ televisionController.filters.w1[0].selected.title }}</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">{{ televisionController.filters.w1[0].selected.subtitle }}</p></div><p class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{televisionController.rankWidget.reachTotal | number }}</p></div></div><odec-d3-bar series=televisionController.rankWidget.reachData decimal=\"televisionController.filters.w1[0].selected.id === \'sh\' && 1\"></odec-d3-bar></div></div></div><div class=\"ranking padding-left--0_5\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=\"televisionController.rankWidget.temPagoData && televisionController.rankWidget.temRestoData && !televisionController.rankWidget.loading\" title-header=\"\'Ranking de cadenas de televisión\'\" show-filters=false show-snapshot=false show-info=true extra-options=\"{boldWords:[\'televisión\']}\" copy-to-clipboard-data=televisionController.rankWidget copy-to-clipboard-format-fn=televisionController.rankWidget.temTvRankFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=televisionController.rankWidget.loading></odec-view-data-loader><odec-no-data ng-if=\"!televisionController.rankWidget.loading && !televisionController.rankWidget.temPagoData && !televisionController.rankWidget.temRestoData\"></odec-no-data><div class=\"charts display__flex flex-direction-column padding--0_5\" ng-if=\"televisionController.rankWidget.temPagoData && televisionController.rankWidget.temRestoData && !televisionController.rankWidget.loading\"><div class=\"info-chart display__flex\"><div class=\"title-info-chart display__flex\"><div class=\"title display__flex flex-direction-column\"><p class=\"bold--700 display__flex flex-direction-column flex-align-item-end\">TOTAL AUDIENCIA CADENAS DE TELEVISIÓN</p><p class=\"subtitle display__flex flex-direction-column flex-align-item-end\">Audiencia ultimos 30 días (000)</p></div><div class=\"value-title bold--700 display__flex flex-align-item-start flex-justify-content-end\">{{televisionController.rankWidget.tematicasTotal | number }}</div></div></div><div class=\"header-title-chart display__flex flex-direction-column\"><p class=\"title bold--700\">CANALES TEMÁTICOS DE PAGO</p><div class=\"fuente-legend display__flex\"><p class=empty></p><p class=\"legend text-right\">Audiencia últimos 30 días</p></div></div><odec-d3-bar series=televisionController.rankWidget.temPagoData></odec-d3-bar><div class=\"header-title-chart display__flex flex-direction-column margin-top--2\"><p class=\"title bold--700\">RESTO CANALES TEMÁTICOS</p><div class=\"fuente-legend display__flex\"><p class=empty></p><p class=\"legend text-right\">Audiencia últimos 30 días</p></div></div><odec-d3-bar series=televisionController.rankWidget.temRestoData></odec-d3-bar></div></div></div></div><div class=\"penetracion-targets padding-top--1 padding-left--1 padding-right--1 flex-align-item-center flex-justify-content-center\"><div class=\"card display__flex flex-direction-column padding--0_5\"><odec-widget-header ng-if=!televisionController.penWidget.loading title-header=\"\'penetración por targets\'\" extra-options=\"{boldWords:[\'penetración\']}\" copy-to-clipboard-data=televisionController.penWidget copy-to-clipboard-format-fn=televisionController.penWidget.penWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=televisionController.penWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!televisionController.penWidget.loading><div class=\"sexo display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!televisionController.penWidget.sexo></odec-no-data><odec-d3-sex-widget ng-if=televisionController.penWidget.sexo data=televisionController.penWidget.sexo></odec-d3-sex-widget></div><div class=\"edad display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!televisionController.penWidget.edad></odec-no-data><odec-d3-column options={numColumnLegend:4} ng-if=televisionController.penWidget.edad series=televisionController.penWidget.edad></odec-d3-column></div><div class=\"indice-socioeconomico display__flex flex-direction-column\"><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!televisionController.penWidget.iso></odec-no-data><odec-d3-column ng-if=televisionController.penWidget.iso series=televisionController.penWidget.iso></odec-d3-column></div></div></div></div><div class=\"perfil-targets display__flex padding--1\"><div class=\"card display__flex flex-direction-column padding--0_5 flex-align-item-center flex-justify-content-center\"><odec-widget-header ng-if=!televisionController.perWidget.loading title-header=\"\'perfil por targets\'\" extra-options=\"{boldWords:[\'perfil\']}\" copy-to-clipboard-data=televisionController.perWidget copy-to-clipboard-format-fn=televisionController.perWidget.perWidgetFormatFn></odec-widget-header><odec-view-data-loader odec-view-data-loader-loading=televisionController.perWidget.loading></odec-view-data-loader><div class=\"charts display__flex\" ng-if=!televisionController.perWidget.loading><div class=sexo><p class=\"subtitle bold--700 padding-top--0_5\">POR SEXO</p><odec-no-data ng-if=!televisionController.perWidget.sexo></odec-no-data><odec-d3-target-sex-donut ng-if=televisionController.perWidget.sexo odec-d3-target-sex-donut-data=televisionController.perWidget.sexo></odec-d3-target-sex-donut></div><div class=edad><p class=\"subtitle bold--700 padding-top--0_5\">POR EDAD</p><odec-no-data ng-if=!televisionController.perWidget.edad></odec-no-data><odec-d3-target-donut ng-if=televisionController.perWidget.edad odec-d3-target-donut-data=televisionController.perWidget.edad odec-d3-target-donut-icon=\"\'TELEVISION.svg\'\"></odec-d3-target-donut></div><div class=indice-socioeconomico><p class=\"subtitle bold--700 padding-top--0_5\">POR ÍNDICE SOCIOECONÓMICO</p><odec-no-data ng-if=!televisionController.perWidget.iso></odec-no-data><odec-d3-target-donut ng-if=televisionController.perWidget.iso odec-d3-target-donut-data=televisionController.perWidget.iso odec-d3-target-donut-icon=\"\'TELEVISION.svg\'\"></odec-d3-target-donut></div></div></div></div></div>");
$templateCache.put("app/components/layout-ui/layoutUi.html","<div class=main-page><ng-transclude ng-class=\"{\'sidebar--open\':vm.opened}\"></ng-transclude></div>");
$templateCache.put("app/components/odecButtonExpandable/odecButtonExpandable.html","<div class=btn-expandable ng-class=\"{\'opened\':odecButtonExpandable.odecButtonExpandableOpened}\"><a href ng-click=odecButtonExpandable.toggleOpen()><i class=\"icon-size-xl icon-search3\"></i></a><div class=btn-expandable-zone ng-transclude></div></div>");
$templateCache.put("app/components/odecBarMenu/odecBarMenu.html","<div class=\"odec-bar-menu padding--1\"><div ng-repeat=\"item in odecBarMenu.menuItems track by $index\" class=menu-item ng-class=\"{\'item-selected\': item.name === odecBarMenu.odecBarMenuSelected}\" ng-style=\"{\'width\': item.menuWidth}\" ng-click=odecBarMenu.goToModule(item.name) ng-mouseenter=\"odecBarMenu.onMouseEnterItem($event, item.name)\" ng-mouseleave=\"odecBarMenu.onMouseLeaveItem($event, item.name)\"><odec-svg-switch odec-svg-switch-name=item.name></odec-svg-switch><div class=menu-item-bar></div><div class=menu-item-label ng-if=\"item.name === odecBarMenu.showItem\"><span>{{item.value | number:1}}%</span> <span class=bold--700>{{item.text}}</span></div></div></div>");
$templateCache.put("app/components/odecCopyToClipboard/odecCopyToClipboard.html","<a class=padding-right--0_5 ng-click=odecCopyToClipboard.copyToClipboard()><i class=\"icon-size-lg icon-paste2 pointer\" tooltip-placement=left-bottom uib-tooltip-html=odecCopyToClipboard.copyText></i> </a>");
$templateCache.put("app/components/odecFilter/odecFilter.html","<div class=filter-view ng-class=\"{\'filter-hidebar\': odecFilter.hideFilterBar}\" ng-class=\"{\'opened\':odecFilter.opened}\"><span ng-if=!odecFilter.hideFilterBar><odec-filter-pills odec-filter-pills-collection=odecFilter.pillsCollection></odec-filter-pills><button href class=filter-view-toggle ng-click=odecFilter.open()><i class=\"icon-size-xl icon-filter_list\" uib-tooltip=\"{{\'FILTER_OPEN\'|translate}}\"></i></button></span><div class=filter-view-content ng-if=odecFilter.opened odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#AA142D odec-scrollable-show={{odecFilter.opened}}><div class=filter-group ng-repeat=\"group in odecFilter.displayer track by $index\" ng-if=\"group.data.length>0\"><div class=filter-group-header><span>{{group.viewLabel|translate}}</span> <i ng-if=odecFilter.loading class=\"icon-size-md icon-spinner22 animated-spin\"></i></div><div class=filter-group-body><div class=filter-group-body-item><div class=\"filter-group-body-item-rendered-wrapper padding--0_5\" ng-repeat=\"child in group.data track by $index\"><div odec-renderer odec-renderer-config=child odec-renderer-disabled=odecFilter.loading></div></div></div></div></div><div class=\"filter-group filter-view-content-action-buttons margin--1_5 text-right\"><button class=\"btn btn-md btn-action\" ng-click=odecFilter.applyFilter(true)><i class=\"icon-check icon-size-lg\"></i></button></div></div></div>");
$templateCache.put("app/components/odecJerarquicFilter/odecJerarquicFilter.html","<div class=\"wave-selector-view display__flex\" ng-class=\"{\'filter-opened\': odecJerarquicFilter.odecJerarquicFilterOpened}\"><div class=\"filter-logo padding--2 display__flex flex-align-item-center\"><img ng-src=assets/images/egm-logo.svg height=100% width=100%></div><div class=\"filter-waves display__flex padding--2\"><div class=\"year-list padding--2\"><div class=\"year-item display__flex flex-direction-column\" ng-repeat=\"year in odecJerarquicFilter.waves.data\"><button class=\"wave-year-button padding--0_5\" ng-class=\"{\'selected\': year.year === odecJerarquicFilter.waves.selected.year}\" ng-click=\"odecJerarquicFilter.waves.selected = year\">{{year.year}}</button></div><a href=\"http://www.aimc.es/?page_id=15515\" class=.older-waves><b>Olas anteriores</b></a></div><div class=\"year-list display__flex flex-direction-column padding--2\"><div class=wave-item ng-repeat=\"wave in odecJerarquicFilter.waves.selected.availableWaves\"><button class=\"wave-year-button padding--0_5\" ng-click=odecJerarquicFilter.changeWave(wave) ng-class=\"{\'selected\': wave === odecJerarquicFilter.waves.selected.wave}\">{{wave}}</button></div></div><div><button class=close-button uib-tooltip=\"Cerrar Filtro\" tooltip-placement=bottom ng-click=odecJerarquicFilter.closeFilter()><i class=\"icon-size-xl icon-close\"></i></button></div></div></div>");
$templateCache.put("app/components/odecLanguageSelector/odecLanguageSelector.html","<div class=\"header-nav-notifications header-nav-item-dropdown language-selector\" uib-dropdown><a href class=header-nav-notifications-item uib-dropdown-toggle><img ng-src=./assets/images/flags/{{odecLanguageSelector.languageSelector.language.selected.image}} alt=\"\"> <small ng-if=!odecLanguageSelector.languageSelector.isLoading class=hidden-xs>{{odecLanguageSelector.languageSelector.language.selected.lang | translate}} </small><span ng-if=odecLanguageSelector.languageSelector.isLoading><i class=\"icon-size icon-spinner22 animated-spin\"></i></span></a><ul class=\"dropdown-menu dropdown-menu-right flags\" uib-dropdown-menu aria-labelledby=simple-dropdown><li class=dropdown-menu-header>{{odecLanguageSelector.languageSelector.status.label | translate}}</li><!-- LIST --><ul ng-if=\"odecLanguageSelector.languageSelector.status.label===\'HOME_SELECT_COUNTRY\'\" id=langs class=\"country-grid dropdown-list normal-list text-center\"><li uib-tooltip={{country.country}} ng-repeat=\"country in odecLanguageSelector.languageSelector.language.list track by $index\" ng-click=odecLanguageSelector.languageSelector.countrySelectionChange($event,country)><a href><img ng-src=./assets/images/flags/{{country.image}} style=max-height:14px alt=\"\"></a></li></ul><ul ng-if=\"odecLanguageSelector.languageSelector.status.label===\'HOME_SELECT_LANGUAGE\'\" id=langs class=\"lang-grid dropdown-list normal-list text-center\"><li class=\"bordered-b padding--0_5\"><a href class=\"d-block text-right\" ng-click=odecLanguageSelector.languageSelector.returnCountrySelection();$event.stopPropagation()><i class=\"icon-size-lg icon-close\"></i></a></li><li ng-repeat=\"language in odecLanguageSelector.languageSelector.filteredLanguageList track by $index\" class=\"variant-selector padding--0_5\"><a href translate ng-click=odecLanguageSelector.languageSelector.languageSelectionChange(language)>{{language.lang}}</a></li></ul></ul></div>");
$templateCache.put("app/components/odecLoadingButton/odecLoadingButton.html","<button class=\"btn btn-action no-padding\" ng-disabled=odecLoadingButton.odecLoadingButtonLoading><ng-transclude class=button-text></ng-transclude><i ng-if=odecLoadingButton.odecLoadingButtonLoading class=\"icon-size-md icon-spinner22 animated-spin margin-left--0_5\"></i></button>");
$templateCache.put("app/components/odecModal/odecModal.html","<!-- BUTTON, ANCHOR, ... --><ng-transclude></ng-transclude><!-- MODAL TEMPLATE --><script type=text/ng-template id=odecModal.html><div class=\"modal-header\">\n        <h2 class=\"modal-title\">{{modalCtrl.headerTitle | translate}}</h2>\n    </div>\n    <div class=\"modal-body\">\n        <div>{{modalCtrl.bodyMessage | translate}}</div>\n        <!-- Additional data to show -->\n        <div ng-if=\"modalCtrl.showData\" class=\"margin-top--1\">\n            <!-- Wait dialog for async data (if is defined but no lenght) -->\n            <div ng-if=\"modalCtrl.showData.length === 0\">\n                <i class=\"icon-spinner22 animated-spin\"></i>\n            </div>\n            <!-- END wait dialog -->\n            <div ng-repeat=\"data in modalCtrl.showData track by $index\">\n                <span>{{data.key | translate}}</span>\n                <span><b>{{data.value}}</b></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-md btn-system no-print icon-size-lg\" \n                type=\"button\" \n                ng-click=\"modalCtrl.closeModal()\">\n                <i class=\"icon-close2\"></i>\n        </button>\n        <button class=\"btn btn-md btn-system no-print icon-size-lg\" \n                type=\"button\"\n                ng-click=\"modalCtrl.accept()\">\n                <i class=\"icon-check2\"></i>\n        </button>\n    </div></script>");
$templateCache.put("app/components/odecNoDataDisplay/odecNoDataDisplay.html","<div id=no-data-display><!-- VALUE --><div class=wrapper><div class=\"display__flex flex-justify-content-center flex-align-item-center\"><!-- ICON --><div class=margin-right--0_5><i class=\"icon-size-xl {{ displayCtrl.message.icon }}\"></i></div><!-- KEY --><div class=text-center>{{ displayCtrl.message.key }}</div></div></div></div>");
$templateCache.put("app/components/odecPanel/odecPanel.html","<div class=\"panel panel-like-borders\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/odecSelect2/odecSelect2.html","<select style=width:100%></select>");
$templateCache.put("app/components/odecNoData/odecNoData.html","<div class=\"display__flex flex-justify-content-center flex-align-item-center padding--2\"><!-- <span><i class=\"icon-size-xl icon-notification margin-right--0_5\"></i></span><b>Datos no disponibles</b> --></div>");
$templateCache.put("app/components/odecSnapshotButton/odecSnapshotButton.html","<button class=\"btn btn-md btn-transparent no--padding {{odecSnapshotButton.odecSnapshotButtonTargetOptions.extraCss}}\" uib-tooltip=\"Realizar captura\" ng-click=odecSnapshotButton.createSnapshot()><i class=\"icon-size-lg icon-camera2\"></i></button>");
$templateCache.put("app/components/odecStarRenderer/odecStarRenderer.html","<p><span ng-repeat=\"item in odecStarRenderer.full | lodashRange\"><i class=\"icon-size-xl icon-star-full text-accent\"></i></span> <span ng-repeat=\"item in odecStarRenderer.partial | lodashRange\"><i class=\"icon-size-xl icon-star-half2 text-accent\"></i></span> <span ng-repeat=\"item in odecStarRenderer.empty| lodashRange\"><i class=\"icon-size-xl icon-star-empty text-accent\"></i></span></p>");
$templateCache.put("app/components/odecSelectionPills/odecSelectionPills.html","<a ng-repeat=\"label in odecSelectionPills.odecSelectionPillsCollection track by $index\" href class=\"label bg-grey-dark padding--0_5 margin--0_5 display__inline-block\" ng-click=odecSelectionPills.onSelection(label)>{{label.text|translate}}<i ng-if=label.isSelected class=\"icon-checkmark padding-left--0_5 text-success\"></i></a>");
$templateCache.put("app/components/odecStationSelector/odecStationSelector.html","<div class=wrapper><div class=inner><div class=opener ng-class=\"{\'opened\': stationSelector.menu.opened}\" ng-click=stationSelector.menu.toggle()><img ng-src={{stationSelector.menu.selected.img}} alt={{stationSelector.menu.selected.label}}></div><div ng-class=\"{\'loader\': stationSelector.stationSelectorLoading}\" ng-style=\"{\'border-top-color\': stationSelector.menu.selected.color}\"></div><div class=menu ng-class=\"{\'opened\': stationSelector.menu.opened}\"><div ng-repeat=\"station in stationSelector.menu.stationsData track by $index\" class=\"menu-item item-{{$index + 1}}\" ng-click=stationSelector.menu.selectItem(station,true)><img ng-src={{station.img}} alt={{station.label}}></div></div></div></div>");
$templateCache.put("app/components/odecSvgSwitch/odecSvgSwitch.html","<div ng-switch=odecSvgSwitch.odecSvgSwitchName class=menu-item-logo><svg ng-switch-when=television xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 39.35 28.62\"><defs><style>.cls-1{fill:#ccc;}</style></defs><title>TV</title><g id=Capa_2 data-name=\"Capa 2\"><g id=Capa_1-2 data-name=\"Capa 1\"><path class=cls-1 d=M17.65,8.85H15.24v7.92a1.48,1.48,0,0,1-.3,1,1,1,0,0,1-.79.33,1,1,0,0,1-.8-.34,1.42,1.42,0,0,1-.31-1V8.85H10.63a1.19,1.19,0,0,1-.84-.25.87.87,0,0,1-.28-.66.86.86,0,0,1,.29-.67A1.26,1.26,0,0,1,10.63,7h7a1.22,1.22,0,0,1,.85.25.92.92,0,0,1,0,1.32A1.23,1.23,0,0,1,17.65,8.85Z /><path class=cls-1 d=M21.71,8.29l2.47,7.31,2.47-7.36c.13-.39.23-.66.29-.81A1.12,1.12,0,0,1,27.26,7a1,1,0,0,1,.61-.18A1.08,1.08,0,0,1,28.4,7a1.06,1.06,0,0,1,.38.38.9.9,0,0,1,.13.47,1.45,1.45,0,0,1,0,.35c0,.13-.07.25-.11.37l-.14.38L26,16.06c-.09.27-.18.53-.28.78a2.75,2.75,0,0,1-.33.64,1.44,1.44,0,0,1-.49.46,1.5,1.5,0,0,1-.76.18,1.46,1.46,0,0,1-.75-.18,1.38,1.38,0,0,1-.5-.46,3,3,0,0,1-.33-.65c-.09-.24-.19-.5-.28-.77L19.66,9c0-.13-.09-.25-.14-.38s-.08-.26-.12-.4a1.78,1.78,0,0,1,0-.36,1,1,0,0,1,.3-.7,1,1,0,0,1,.77-.31.91.91,0,0,1,.8.35A5.24,5.24,0,0,1,21.71,8.29Z /><path class=cls-1 d=M37.05,1.88H2.3a.42.42,0,0,0-.42.42V23.47a.42.42,0,0,0,.42.42H37.05a.42.42,0,0,0,.42-.42V2.3A.42.42,0,0,0,37.05,1.88Zm-.42,21.18H2.71V2.71H36.63Z /><path class=cls-1 d=M37.51,0H1.83A1.83,1.83,0,0,0,0,1.83V23.94a1.83,1.83,0,0,0,1.83,1.83h12.4l-.67,1.6H10.91a.63.63,0,1,0,0,1.25H28.44a.63.63,0,0,0,0-1.25H25.78l-.66-1.6H37.51a1.84,1.84,0,0,0,1.84-1.83V1.83A1.84,1.84,0,0,0,37.51,0ZM24.43,27.37H14.92l.66-1.6h8.19Zm13.66-3.43a.58.58,0,0,1-.58.58H1.83a.58.58,0,0,1-.58-.58V1.83a.58.58,0,0,1,.58-.58H37.51a.58.58,0,0,1,.58.58Z /></g></g></svg> <svg ng-switch-when=radio xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 34.77 30.44\"><defs><style>.cls-1{fill:#cdcccc;}</style></defs><title>radio</title><g id=Capa_2 data-name=\"Capa 2\"><g id=Capa_1-2 data-name=\"Capa 1\"><g id=_5 data-name=5><path class=cls-1 d=M12,21.74H5.43a1.09,1.09,0,0,0,0,2.18H12a1.09,1.09,0,0,0,0-2.18Zm0-4.34H5.43a1.09,1.09,0,0,0,0,2.17H12a1.09,1.09,0,1,0,0-2.17ZM30.43,6.53H28.15L16.7.14a1.12,1.12,0,0,0-1.49.38A1,1,0,0,0,15.61,2l8.27,4.58H4.35A4.35,4.35,0,0,0,0,10.88V26.09a4.35,4.35,0,0,0,4.35,4.35H30.43a4.34,4.34,0,0,0,4.34-4.35V10.88A4.34,4.34,0,0,0,30.43,6.53ZM32.6,26.09a2.17,2.17,0,0,1-2.17,2.17H4.35a2.18,2.18,0,0,1-2.18-2.17V10.88A2.19,2.19,0,0,1,4.35,8.7H30.43a2.18,2.18,0,0,1,2.17,2.18ZM22.82,12a6.52,6.52,0,1,0,6.52,6.52A6.52,6.52,0,0,0,22.82,12Zm0,10.87a4.35,4.35,0,1,1,4.35-4.35A4.35,4.35,0,0,1,22.82,22.83ZM12,13.05H5.43a1.09,1.09,0,0,0,0,2.17H12a1.09,1.09,0,1,0,0-2.17Z /></g></g></g></svg> <svg ng-switch-when=revistas xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 30.33 33.96\"><defs><style>.cls-1{fill:#ccc;}</style></defs><title>REVISTAS</title><g id=Capa_2 data-name=\"Capa 2\"><g id=Capa_1-2 data-name=\"Capa 1\"><path class=cls-1 d=M28.33,0H25.58a.66.66,0,0,0-.66.66.66.66,0,0,0,.66.67h2.75A.68.68,0,0,1,29,2V29.26a.68.68,0,0,1-.68.68h-.21V4.69a2,2,0,0,0-2-2h-24L3.19,1.33H20.34A.67.67,0,0,0,21,.66.67.67,0,0,0,20.34,0H2.59l0,0h0l0,0,0,0,0,0,0,0,0,0,0,0h0L.15,2.93h0l0,0V3s0,0,0,0l0,0v.09s0,0,0,0V33.29A.67.67,0,0,0,.66,34H7.71a.67.67,0,0,0,0-1.33h-2c.3-2.57,2.25-6.26,4.24-6.26h9.3c2,0,3.93,3.69,4.24,6.26H13A.67.67,0,1,0,13,34H26.11a2,2,0,0,0,2-2v-.68h.21a2,2,0,0,0,2-2V2A2,2,0,0,0,28.33,0ZM14.56,25A4.08,4.08,0,1,1,18.64,21,4.08,4.08,0,0,1,14.56,25ZM26.79,32a.67.67,0,0,1-.68.68H24.78a11.93,11.93,0,0,0-1.5-4.48c-1.16-2-2.6-3.11-4.07-3.11H18.1A5.41,5.41,0,1,0,11,25H9.91C8.44,25,7,26.14,5.84,28.15a12,12,0,0,0-1.51,4.48h-3V4H26.11a.67.67,0,0,1,.68.67Z /><path class=cls-1 d=M14.8,12.82,13.32,8.3a.67.67,0,0,0-.63-.46.68.68,0,0,0-.63.46l-1.48,4.52a.67.67,0,0,0,.43.84.66.66,0,0,0,.83-.42l.12-.36h1.46l.12.36a.65.65,0,0,0,.63.45l.21,0A.67.67,0,0,0,14.8,12.82Zm-2.4-1.27.29-.91.3.91Z /><path class=cls-1 d=M10.05,8.5V8.2l0,0,0,0v0l0,0v0l0,0h0l0,0,0,0,0,0,0,0h0l-.06,0h0l-.09,0a.47.47,0,0,0-.17,0H9.14l0,0h0l0,0H9L9,8,9,8,9,8l0,0h0l0,0,0,0,0,0,0,0h0L6.89,11.65,5,8.19H5v0l0,0,0,0,0,0,0,0h0l0,0V8l0,0,0,0h0l0,0h0l0,0H4.39a.57.57,0,0,0-.18,0h0l-.06,0h0l-.06,0h0L4,8,4,8,4,8l0,0h0l0,0,0,0,0,0v0l0,0,0,0v.08s0,0,0,0V8.5h0V13a.66.66,0,0,0,1.32,0V11.08l1.26,2.26h0l0,.06v0l0,.06h0l0,0,0,0,0,0h0l0,0,0,0,.05,0h0l.07,0H7l.07,0h0l.06,0,0,0,0,0h0l0,0,0,0,0,0h0l.06-.06v0l0-.06h0l1.26-2.26V13a.66.66,0,1,0,1.32,0V8.52h0Z /><path class=cls-1 d=M18.93,10h-.68a.67.67,0,0,0,0,1.33h0v1.06h-.49a1.59,1.59,0,0,1,0-3.18h1.16a.66.66,0,1,0,0-1.32H17.77a2.91,2.91,0,0,0,0,5.82h1.16a.67.67,0,0,0,.66-.66V10.63A.67.67,0,0,0,18.93,10Z /><path class=cls-1 d=M23.73,12.36H22l2.28-3.48v0a.08.08,0,0,0,0,0l0,0V8.51h0V8.38h0a.94.94,0,0,0-.06-.15v0h0A1.15,1.15,0,0,0,24.17,8l0,0h0l0,0h0l0,0,0,0H20.78a.67.67,0,1,0,0,1.33H22.5l-2.27,3.47h0v0l0,0v0l0,0v.12s0,0,0,0V13h0v.1a.6.6,0,0,0,.06.19v0h0a.55.55,0,0,0,.14.17l0,0h0l0,0h0l.07,0h0l.08,0h3.14a.67.67,0,0,0,0-1.33Z /><path class=cls-1 d=M8.43,22.9,4.26,20.81a.66.66,0,0,0-1,.6v4.17a.69.69,0,0,0,.31.57.73.73,0,0,0,.35.09.66.66,0,0,0,.3-.07l4.17-2.08a.66.66,0,0,0,0-1.19ZM4.62,24.51v-2l2,1Z /><path class=cls-1 d=M23.83,22.32h-.38V19.06a.65.65,0,0,0-.34-.58.67.67,0,0,0-.67,0l-1,.61a.65.65,0,0,0-.21.91.66.66,0,0,0,.87.24v2.07h-.39a.67.67,0,0,0,0,1.33h2.1a.67.67,0,0,0,0-1.33Z /><path class=cls-1 d=M22.3,0h0a.67.67,0,0,0,0,1.33h0A.67.67,0,0,0,23,.66.67.67,0,0,0,22.3,0Z /><path class=cls-1 d=M9.67,32.63h0a.67.67,0,1,0,0,1.33h0a.67.67,0,0,0,0-1.33Z /></g></g></svg> <svg ng-switch-when=internet xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 40.07 27.33\"><defs><style>.cls-1{fill:#ccc;}</style></defs><title>INTERNET</title><g id=Capa_2 data-name=\"Capa 2\"><g id=Capa_1-2 data-name=\"Capa 1\"><path class=cls-1 d=M8.13,10.82,9.06,14l.84-3c.1-.31.16-.52.21-.63a.74.74,0,0,1,.24-.33.91.91,0,0,1,1,0,.88.88,0,0,1,.25.34,5.07,5.07,0,0,1,.2.62l.85,3,.94-3.19a4.82,4.82,0,0,1,.15-.5.69.69,0,0,1,.2-.28.62.62,0,0,1,.39-.11.64.64,0,0,1,.44.17.55.55,0,0,1,.19.42,2.13,2.13,0,0,1-.16.67l-1.17,3.42c-.1.29-.18.5-.23.62a1,1,0,0,1-.27.35.74.74,0,0,1-.49.15.73.73,0,0,1-.51-.16.92.92,0,0,1-.27-.4,6.26,6.26,0,0,1-.2-.61l-.81-2.78-.79,2.78a3.76,3.76,0,0,1-.34.88.73.73,0,0,1-.65.29.84.84,0,0,1-.4-.09.75.75,0,0,1-.27-.26,1.86,1.86,0,0,1-.19-.4c-.06-.16-.1-.28-.14-.37L6.92,11.19a2.18,2.18,0,0,1-.17-.67.57.57,0,0,1,.18-.41.61.61,0,0,1,.45-.18.5.5,0,0,1,.48.2A3.25,3.25,0,0,1,8.13,10.82Z /><path class=cls-1 d=M16.83,10.82,17.76,14l.85-3c.09-.31.16-.52.2-.63a.85.85,0,0,1,.25-.33.74.74,0,0,1,.49-.15.75.75,0,0,1,.5.15.91.91,0,0,1,.26.34c.05.12.11.32.2.62l.85,3,.94-3.19a4.82,4.82,0,0,1,.15-.5.67.67,0,0,1,.19-.28.66.66,0,0,1,.4-.11.64.64,0,0,1,.44.17.55.55,0,0,1,.19.42,2.46,2.46,0,0,1-.16.67l-1.17,3.42c-.1.29-.18.5-.23.62a1,1,0,0,1-.27.35.74.74,0,0,1-.49.15.73.73,0,0,1-.51-.16.94.94,0,0,1-.28-.4c-.06-.15-.12-.36-.19-.61l-.82-2.78-.79,2.78a3,3,0,0,1-.34.88.7.7,0,0,1-.64.29.82.82,0,0,1-.4-.09.75.75,0,0,1-.27-.26,1.87,1.87,0,0,1-.2-.4c-.05-.16-.1-.28-.13-.37l-1.15-3.42a2.29,2.29,0,0,1-.18-.67.54.54,0,0,1,.19-.41.61.61,0,0,1,.45-.18.52.52,0,0,1,.48.2A2.86,2.86,0,0,1,16.83,10.82Z /><path class=cls-1 d=M25.54,10.82,26.47,14l.85-3c.09-.31.16-.52.2-.63a.77.77,0,0,1,.25-.33.74.74,0,0,1,.49-.15.76.76,0,0,1,.5.15.88.88,0,0,1,.25.34c0,.12.12.32.21.62l.84,3,1-3.19a4.82,4.82,0,0,1,.15-.5.67.67,0,0,1,.19-.28.62.62,0,0,1,.39-.11.68.68,0,0,1,.45.17.59.59,0,0,1,.19.42,2.22,2.22,0,0,1-.17.67l-1.16,3.42a5.89,5.89,0,0,1-.24.62.87.87,0,0,1-.26.35.9.9,0,0,1-1,0,1,1,0,0,1-.27-.4c-.06-.15-.12-.36-.19-.61l-.82-2.78-.79,2.78a3.36,3.36,0,0,1-.34.88.71.71,0,0,1-.64.29.82.82,0,0,1-.4-.09.86.86,0,0,1-.28-.26,2.49,2.49,0,0,1-.19-.4c-.06-.16-.1-.28-.13-.37l-1.16-3.42a2.53,2.53,0,0,1-.17-.67.57.57,0,0,1,.18-.41.64.64,0,0,1,.45-.18.5.5,0,0,1,.48.2A2.44,2.44,0,0,1,25.54,10.82Z /><path class=cls-1 d=M33.36,15.73a.79.79,0,0,1-.55-.21.73.73,0,0,1-.24-.58.78.78,0,0,1,.22-.55.8.8,0,0,1,1.12,0,.71.71,0,0,1,.23.55.73.73,0,0,1-.23.58A.79.79,0,0,1,33.36,15.73Z /><path class=cls-1 d=M35.5,1.93H4.57a1,1,0,0,0-1,1V21.21a1,1,0,0,0,1,1H35.5a1,1,0,0,0,1-1V2.92a1,1,0,0,0-1-1Zm.14,19.28a.13.13,0,0,1-.14.13H4.57a.13.13,0,0,1-.13-.13V2.92a.13.13,0,0,1,.13-.13H35.5a.13.13,0,0,1,.14.13Z /><path class=cls-1 d=M39.43,22.84h-1V2.45A2.45,2.45,0,0,0,36,0H4.1A2.45,2.45,0,0,0,1.65,2.45V22.84h-1a.64.64,0,0,0-.64.64v1.77a2.08,2.08,0,0,0,2.08,2.08H38a2.08,2.08,0,0,0,2.08-2.08V23.48A.64.64,0,0,0,39.43,22.84ZM2.94,2.45A1.16,1.16,0,0,1,4.1,1.29H36a1.17,1.17,0,0,1,1.17,1.16V22.84H2.94V2.45ZM18.15,24.13h3.77v.33a.28.28,0,0,1-.27.28H18.42a.28.28,0,0,1-.27-.28v-.33Zm20.64,1.12a.8.8,0,0,1-.8.8H2.08a.79.79,0,0,1-.79-.8V24.13h16v.33a1.13,1.13,0,0,0,1.13,1.13h3.23a1.13,1.13,0,0,0,1.13-1.13v-.33h16v1.12Z /></g></g></svg> <svg ng-switch-when=diarios xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 34.77 32.18\"><defs><style>.cls-1{fill:#ccc;}</style></defs><title>DIARIOS</title><g id=Capa_2 data-name=\"Capa 2\"><g id=Capa_1-2 data-name=\"Capa 1\"><path class=cls-1 d=M33,0H7.58A1.76,1.76,0,0,0,5.82,1.76V4.42H1.76A1.76,1.76,0,0,0,0,6.17V28.76a3.42,3.42,0,0,0,3.4,3.42h18a.51.51,0,0,0,0-1H5.85a3.4,3.4,0,0,0,1-2.4V16.85a.51.51,0,1,0-1,0V28.76a2.4,2.4,0,0,1-2.39,2.4h0A2.41,2.41,0,0,1,1,28.76V6.17a.74.74,0,0,1,.74-.73H5.82V15a.51.51,0,1,0,1,0V1.76A.74.74,0,0,1,7.58,1H33a.74.74,0,0,1,.74.74v27a2.41,2.41,0,0,1-2.41,2.4h-8a.51.51,0,0,0,0,1h8a3.42,3.42,0,0,0,3.42-3.42v-27A1.75,1.75,0,0,0,33,0Z /><path class=cls-1 d=M11.16,20.33h7a1.21,1.21,0,0,0,1.2-1.21v-7a1.2,1.2,0,0,0-1.2-1.2h-7a1.2,1.2,0,0,0-1.2,1.2v7A1.21,1.21,0,0,0,11.16,20.33ZM11,12.13a.19.19,0,0,1,.19-.18h7a.18.18,0,0,1,.18.18v7a.19.19,0,0,1-.18.19h-7a.2.2,0,0,1-.19-.19Z /><path class=cls-1 d=M21.2,12h9.46a.51.51,0,1,0,0-1H21.2a.51.51,0,0,0,0,1Z /><path class=cls-1 d=M21.2,16.14h9.46a.51.51,0,0,0,0-1H21.2a.51.51,0,1,0,0,1Z /><path class=cls-1 d=M21.2,20.33h9.46a.51.51,0,0,0,.51-.51.51.51,0,0,0-.51-.51H21.2a.51.51,0,0,0-.51.51A.51.51,0,0,0,21.2,20.33Z /><path class=cls-1 d=M10.46,24.51h20.2a.51.51,0,1,0,0-1H10.46a.51.51,0,0,0,0,1Z /><path class=cls-1 d=M10.46,28.7h20.2a.51.51,0,0,0,.51-.51.51.51,0,0,0-.51-.51H10.46a.5.5,0,0,0-.5.51A.5.5,0,0,0,10.46,28.7Z /><path class=cls-1 d=M10,8.32V2.94a.26.26,0,0,1,.16-.25.74.74,0,0,1,.38-.09.78.78,0,0,1,.45.11,1.25,1.25,0,0,1,.35.46l1.6,3.1V2.93a.27.27,0,0,1,.16-.25.94.94,0,0,1,.76,0,.27.27,0,0,1,.16.25V8.32a.27.27,0,0,1-.16.25.76.76,0,0,1-.38.09.64.64,0,0,1-.62-.34L11.05,5V8.32a.28.28,0,0,1-.17.25.72.72,0,0,1-.37.09.74.74,0,0,1-.38-.09A.27.27,0,0,1,10,8.32Z /><path class=cls-1 d=M15,8.32V2.94a.27.27,0,0,1,.14-.25.58.58,0,0,1,.33-.09h2.95a.27.27,0,0,1,.25.14.57.57,0,0,1,.09.32.59.59,0,0,1-.09.34.27.27,0,0,1-.25.14H16.06V5.2h1.26a.3.3,0,0,1,.25.13.53.53,0,0,1,.09.3.47.47,0,0,1-.08.29.28.28,0,0,1-.26.13H16.06V7.72h2.35a.27.27,0,0,1,.25.14.62.62,0,0,1,.09.34.57.57,0,0,1-.09.32.26.26,0,0,1-.25.14H15.46a.58.58,0,0,1-.33-.09A.27.27,0,0,1,15,8.32Z /><path class=cls-1 d=M19.29,3a.34.34,0,0,1,.22-.3A.9.9,0,0,1,20,2.6q.3,0,.36.21l1.31,4.5.7-2.89c0-.2.23-.29.53-.29s.47.09.52.29l.71,2.89,1.31-4.5q.06-.21.36-.21a.87.87,0,0,1,.46.13.34.34,0,0,1,.21.4L24.81,8.35c-.09.24-.32.36-.71.36a1.1,1.1,0,0,1-.45-.09.45.45,0,0,1-.24-.27l-.53-2.24-.54,2.24a.45.45,0,0,1-.24.27,1.17,1.17,0,0,1-.9,0A.44.44,0,0,1,21,8.35L19.31,3.13A.36.36,0,0,1,19.29,3Z /><path class=cls-1 d=M26.74,7.71a.69.69,0,0,1,.14-.39.41.41,0,0,1,.33-.19.45.45,0,0,1,.25.1l.26.23a1.39,1.39,0,0,0,.37.23,1.32,1.32,0,0,0,.53.1,1.12,1.12,0,0,0,.66-.18.61.61,0,0,0,.27-.54.69.69,0,0,0-.15-.44A1.12,1.12,0,0,0,29,6.3c-.15-.08-.33-.17-.52-.25l-.56-.27a4,4,0,0,1-.53-.33A1.5,1.5,0,0,1,27,5a1.76,1.76,0,0,1-.14-.71,1.67,1.67,0,0,1,.18-.79,1.34,1.34,0,0,1,.47-.53,2.42,2.42,0,0,1,.64-.27,2.84,2.84,0,0,1,.72-.09l.46,0a3.52,3.52,0,0,1,.51.1,1,1,0,0,1,.44.21.44.44,0,0,1,.17.34.73.73,0,0,1-.12.38.36.36,0,0,1-.31.2,1.42,1.42,0,0,1-.41-.16,1.78,1.78,0,0,0-.74-.16,1.21,1.21,0,0,0-.69.17.57.57,0,0,0-.05.89,1.53,1.53,0,0,0,.5.29l.64.28c.23.12.44.24.64.37a1.58,1.58,0,0,1,.49.58,1.87,1.87,0,0,1,.2.88,1.59,1.59,0,0,1-.55,1.31,2.11,2.11,0,0,1-1.43.47,2.65,2.65,0,0,1-1.35-.33C26.93,8.2,26.74,8,26.74,7.71Z /></g></g></svg> <svg ng-switch-when=cine xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 31.38 27.45\"><defs><style>.cls-1{fill:#ccc;}</style></defs><title>CINE</title><g id=Capa_2 data-name=\"Capa 2\"><g id=Capa_1-2 data-name=\"Capa 1\"><g id=_3 data-name=3><path class=cls-1 d=M29.41,11.77l-5.88,3.92a3.9,3.9,0,0,0-1.38-3,6.84,6.84,0,1,0-8.31-1h-3.6a5.88,5.88,0,1,0-8.2.5,3.9,3.9,0,0,0-2,3.42v7.84a3.92,3.92,0,0,0,3.92,3.92H19.61a3.91,3.91,0,0,0,3.92-3.92v-1l5.88,4.9a2,2,0,0,0,2-2V13.73A2,2,0,0,0,29.41,11.77ZM2,7.84a3.92,3.92,0,1,1,3.92,3.93A3.93,3.93,0,0,1,2,7.84ZM21.57,23.53a2,2,0,0,1-2,2H3.92a2,2,0,0,1-2-2V15.69a2,2,0,0,1,2-2H19.61a2,2,0,0,1,2,2ZM18.63,11.78a4.92,4.92,0,1,1,4.91-4.92A4.91,4.91,0,0,1,18.63,11.78ZM29.41,25.49l-5.88-4.9V17.65l5.88-3.92Z /></g></g></g></svg> <svg ng-switch-when=exterior xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 31.38 31.38\"><defs><style>.cls-1{fill:#ccc;}</style></defs><title>EXTERIOR</title><g id=Capa_2 data-name=\"Capa 2\"><g id=Capa_1-2 data-name=\"Capa 1\"><path class=cls-1 d=M14.22,18.49l-.41-1.08H10.34l-.41,1.1a3.44,3.44,0,0,1-.41.86A.63.63,0,0,1,9,19.6a.82.82,0,0,1-.58-.24.76.76,0,0,1-.25-.54,1.13,1.13,0,0,1,.06-.36c0-.13.1-.3.19-.52l2.19-5.55c.06-.16.14-.35.22-.57a2.91,2.91,0,0,1,.28-.56,1.12,1.12,0,0,1,.39-.36,1.22,1.22,0,0,1,1.59.35,2.12,2.12,0,0,1,.25.47c.07.16.16.38.26.66l2.24,5.51a2.84,2.84,0,0,1,.26.92.78.78,0,0,1-.25.54.8.8,0,0,1-.6.25,1,1,0,0,1-.35-.07.78.78,0,0,1-.24-.2,1.51,1.51,0,0,1-.21-.39C14.34,18.77,14.27,18.62,14.22,18.49Zm-3.43-2.38h2.56l-1.29-3.52Z /><path class=cls-1 d=M18.41,10.91h2.25a6,6,0,0,1,1.51.16,2.88,2.88,0,0,1,1.15.62,4.3,4.3,0,0,1,1.33,3.47,6.73,6.73,0,0,1-.13,1.4,4,4,0,0,1-.42,1.15,3.45,3.45,0,0,1-.71.91,2.94,2.94,0,0,1-.76.5,3.51,3.51,0,0,1-.87.26,6.9,6.9,0,0,1-1.06.07H18.45a1.5,1.5,0,0,1-.72-.14.68.68,0,0,1-.31-.4,2.53,2.53,0,0,1-.07-.68V12a1.11,1.11,0,0,1,.25-.81A1.11,1.11,0,0,1,18.41,10.91Zm.67,1.37v5.8h1.31a6,6,0,0,0,.68,0,1.88,1.88,0,0,0,.5-.11,1.24,1.24,0,0,0,.46-.27,3.13,3.13,0,0,0,.87-2.52,3.78,3.78,0,0,0-.38-1.9,1.73,1.73,0,0,0-.95-.8,4.77,4.77,0,0,0-1.35-.17Z /><path class=cls-1 d=M30.46,22.13a.92.92,0,0,0,.92-.92V4.6a.92.92,0,0,0-.92-.92H25.8V2.76a2.76,2.76,0,1,0-5.51,0v.92H17.53V2.76a2.76,2.76,0,0,0-5.52,0v.92H9.26V2.76a2.76,2.76,0,0,0-5.52,0v.92H.92A.92.92,0,0,0,0,4.6V21.21a.92.92,0,0,0,.92.92h12V26a4.6,4.6,0,0,0-3.58,3.58H.92a.92.92,0,0,0,0,1.84H30.46a.92.92,0,1,0,0-1.84H22A4.6,4.6,0,0,0,18.45,26V22.13ZM22.13,2.76a.92.92,0,1,1,1.84,0v.92H22.13Zm-8.28,0a.92.92,0,0,1,1.84,0v.92H13.85Zm-8.27,0a.92.92,0,0,1,1.84,0v.92H5.58ZM20.13,29.54H11.25a2.76,2.76,0,0,1,2.6-1.84h3.68A2.76,2.76,0,0,1,20.13,29.54Zm-5.36-3.67V22.13h1.84v3.74ZM1.84,20.29V5.52H7.42V7.36H6.5a.92.92,0,1,0,0,1.83h3.67a.92.92,0,1,0,0-1.83H9.26V5.52h6.43V7.36h-.92a.92.92,0,1,0,0,1.83h3.68a.92.92,0,1,0,0-1.83h-.92V5.52H24V7.36h-.92a.92.92,0,1,0,0,1.83h3.67a.92.92,0,1,0,0-1.83H25.8V5.52h3.74V20.29Z /></g></g></svg> <svg ng-switch-when=suplementos xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 27.47 36.6\"><defs><style>.cls-1{fill:#ccc;}</style></defs><title>SUPLEMENTOS</title><g id=Capa_2 data-name=\"Capa 2\"><g id=Capa_1-2 data-name=\"Capa 1\"><path class=cls-1 d=M26.86,3H7.27A3.66,3.66,0,0,0,0,3.64V33.55H.05A3.67,3.67,0,0,0,3.66,36.6H20.75a.61.61,0,0,0,.61-.61V34.16h5.5a.61.61,0,0,0,.61-.61V3.64A.61.61,0,0,0,26.86,3ZM1.22,3.64a2.44,2.44,0,1,1,4.88,0V30.22a3.64,3.64,0,0,0-4.88,0ZM20.14,35.38H3.66A2.44,2.44,0,1,1,6.1,32.94v.61a.61.61,0,0,0,.61.61H20.14Zm6.11-2.44H7.32V4.25H26.25Z /><path class=cls-1 d=M24.42,5.47H9.16a.61.61,0,0,0-.61.61v6.11a.61.61,0,0,0,.61.61H24.42a.62.62,0,0,0,.61-.61V6.08A.62.62,0,0,0,24.42,5.47Zm-.61,6.11h-14V6.69h14Z /><path class=cls-1 d=M16.48,14H9.16a.61.61,0,0,0-.61.61v6.71a.61.61,0,0,0,.61.61h7.32a.61.61,0,0,0,.61-.61V14.63A.61.61,0,0,0,16.48,14Zm-.61,6.71H9.77V15.24h6.1Z /><path class=cls-1 d=M24.42,23.18H17.09a.61.61,0,0,0-.61.61v7.32a.61.61,0,0,0,.61.61h7.33a.61.61,0,0,0,.61-.61V23.79A.61.61,0,0,0,24.42,23.18Zm-.61,7.32H17.7V24.4h6.11Z /><rect class=cls-1 x=18.31 y=14.63 width=6.71 height=1.22 /><rect class=cls-1 x=18.31 y=17.07 width=6.71 height=1.22 /><rect class=cls-1 x=18.31 y=19.51 width=6.71 height=1.22 /><rect class=cls-1 x=8.55 y=23.18 width=6.71 height=1.22 /><rect class=cls-1 x=8.55 y=25.62 width=6.71 height=1.22 /><rect class=cls-1 x=8.55 y=28.06 width=6.71 height=1.22 /><rect class=cls-1 x=8.55 y=30.5 width=6.71 height=1.22 /></g></g></svg></div>");
$templateCache.put("app/components/odecToggle/odecToggle.html","<div class=odecToggle ng-class=\"{\'ok\': odecToggle.odecToggleActive, \'no\':!odecToggle.odecToggleActive}\"><div ng-click=odecToggle.onClick() class=selector></div></div>");
$templateCache.put("app/components/odecTransitionPage/odecTransitionPage.html","<div class=transitionPage ng-class=\"{\'entering\':odecTransitionPage.loading}\"><img src=./assets/images/loader_img.gif alt=loader></div>");
$templateCache.put("app/components/odecViewDataLoader/odecViewDataLoader.html","<div class=\"loading-bar-wrapper margin-top--0_5\" ng-if=odecViewDataLoader.odecViewDataLoaderLoading><div class=\"loader-bar-animated text-center\"><i class=\"icon-size-xl icon-spinner22 animated-spin\"></i></div></div>");
$templateCache.put("app/components/odecWaveSelector/odecWaveSelector.html","<div class=wrap><div class=frame ng-class=\"{ \'loading\': waveSelector.odecLoading }\"><ul class=slidee><li ng-repeat=\"wave in waveSelector.odecWavesData\" sly-horizontal-repeat sly-options=waveSelector.sly.config sly-callback=waveSelector.sly.callback><div class=\"pill {{waveSelector.odecStationSelected.cssClass}}\">{{wave.wave | quarterWave}}</div></li></ul></div><div ng-class=\"{ \'arrows-disabled\': waveSelector.odecLoading }\" class=\"indicator prev-button prevPage\"><i ng-class=\"{ \'icon-navigate_before\': waveSelector.sly.showPrevButton }\"></i></div><div ng-class=\"{ \'arrows-disabled\': waveSelector.odecLoading }\" class=\"indicator next-button nextPage\"><i ng-class=\"{ \'icon-navigate_next\': waveSelector.sly.showNextButton }\"></i></div><!--<div id=\"scrollbar\" class=\"scrollbar\">\n        <div class=\"handle\"></div> \n    </div>--></div>");
$templateCache.put("app/components/d3/odecD3Bar/odecD3Bar.html","");
$templateCache.put("app/components/d3/odecD3ColumnThematic/odecD3ColumnThematic.html","");
$templateCache.put("app/components/d3/odecD3Column/odecD3Column.html","");
$templateCache.put("app/components/d3/odecD3DonutDoble/odecD3DonutDoble.html","");
$templateCache.put("app/components/d3/odecD3SexWidget/odecD3SexWidget.html","");
$templateCache.put("app/components/d3/odecD3Progress/odecD3Progress.html","");
$templateCache.put("app/components/d3/odecD3StackedBar/odecD3StackedBar.html","<div class=odec-d3-stacked-bar><div class=labels></div><div class=d3-chart-share></div><div class=\"legend padding--1\"><div ng-repeat=\"item in odecD3StackedBar.legend track by $index\" class=\"legend-item margin-left--1\"><span><i class=icon-circle ng-style=\"{\'color\': item.color}\"></i> </span><span><p class=\"legend-item-text margin-left--0_5\">{{item.name}}</p></span></div></div></div>");
$templateCache.put("app/components/d3/odecD3TargetDonut/odecD3TargetDonut.html","");
$templateCache.put("app/components/d3/odecD3TargetSexDonut/odecD3TargetSexDonut.html","");
$templateCache.put("app/components/layout-ui/odecFooter/odecFooter.html","<footer><ng-transclude></ng-transclude></footer>");
$templateCache.put("app/components/layout-ui/odecHeader/odecHeader.html","<header class=card><ng-transclude></ng-transclude></header>");
$templateCache.put("app/components/layout-ui/odecMenuLink/odecMenuLink.html","<li ng-if=odecMenuLink.odecMenuLinkVisible class=sidebar-nav-submenu-item><a href ng-click=odecMenuLink.onClick($event)>{{odecMenuLink.odecMenuLinkLabel|translate}}</a></li>");
$templateCache.put("app/components/layout-ui/odecMenuList/odecMenuList.html","<ul class=\"sidebar-nav margin-top--1\"><odec-menu-list-item ng-repeat=\"menuItem in odecMenuList.data.odecMenuListCollection track by $index\" ng-if=menuItem.visible odec-menu-list-item-icon=menuItem.icon odec-menu-list-item-label=menuItem.label odec-menu-list-item-selected=menuItem.selected odec-menu-list-item-submenu-childs=menuItem.child ng-click=odecMenuList.onSelect($event,menuItem)></odec-menu-list-item></ul>");
$templateCache.put("app/components/layout-ui/odecMenuListItem/odecMenuListItem.html","<li class=sidebar-nav-item ng-class=\"{\'sidebar-nav-item--opened\':vm.odecMenuListItemSelected}\"><a href=\"\" class=sidebar-nav-toggle ng-click=vm.odecMenuListItemSelectedOnSelect()><i class=\"sidebar-nav-toggle-icon icon-size-lg {{vm.odecMenuListItemIcon}}\"></i><span class=sidebar-nav-toggle-description>{{vm.odecMenuListItemLabel|translate}}</span></a><odec-submenu-list><odec-menu-link ng-repeat=\"link in vm.odecMenuListItemSubmenuChilds track by $index\" odec-menu-link-label=link.label odec-menu-link-state=link.state odec-menu-link-url=link.url odec-menu-link-visible=link.visible></odec-menu-link></odec-submenu-list></li>");
$templateCache.put("app/components/layout-ui/odecSidebar/odecSidebar.html","<div class=\"sidebar no-print\" odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#AA142D odec-scrollable-show={{odecSidebar.odecSidebarOpened}}><div class=sidebar-logo><img ng-src=assets/images/logocope-web.png alt=\"\"></div><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/layout-ui/odecSidebarOverlay/odecSidebarOverlay.html","<div class=sidebar-overlay ng-if=odecSidebarOverlay.odecSidebarOverlayOpened ng-click=odecSidebarOverlay.closeOverlay({value:false})></div>");
$templateCache.put("app/components/layout-ui/odecSidebarToggle/odecSidebarToggle.html","<button class=btn-menu ng-click=odecSidebarToggle.clicked({value:true})><i class=\"icon-menu5 icon-size-xl\"></i></button>");
$templateCache.put("app/components/layout-ui/odecSubmenuList/odecSubmenuList.html","<ul class=sidebar-nav-submenu><ng-transclude></ng-transclude></ul>");
$templateCache.put("app/components/odecFilter/odecFilterPills/odecFilterPills.html","<div class=\"filter-view-pills padding--0_5 margin-right--2_5\"><span class=filter-view-pills-item ng-repeat=\"pill in odecFilterPills.odecFilterPillsCollection track by $index\">{{pill.label|translate}}: {{pill.value}}</span></div>");
$templateCache.put("app/components/odecPanel/odecPanelBodyBar/odecPanelBodyBar.html","<div class=panel-body-actions><div class=row><div class=col-md-6><ul class=\"panel-body-actions-list panel-body-actions-list--left\"><li class=panel-body-actions-list-item><odec-button-expandable odec-button-expandable-opened=false odec-button-expandable-closable=true><input type=text autofocus ng-model=odecPanelBodyBar.odecPanelBodyBarSearchText ng-attr-placeholder={{odecPanelBodyBar.odecPanelBodyBarSearchPlaceholder|translate}}></odec-button-expandable></li></ul></div><div class=col-md-6><ul class=\"panel-body-actions-list panel-body-actions-list--right\" ng-transclude=exports></ul></div></div><div class=row ng-transclude=multiwaveexport></div></div>");
$templateCache.put("app/components/odecPanel/odecPanelBody/odecPanelBody.html","<div class=panel-body ng-if=!odecPanelBody.odecPanelCtrl.isCollapsed><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/odecPanel/odecPanelFooter/odecPanelFooter.html","<div class=panel-footer ng-if=!odecPanelFooter.odecPanelCtrl.isCollapsed><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/odecPanel/odecPanelHeader/odecPanelHeader.html","<header class=panel-heading ng-class=\"{\'notools\':noTools}\"><div class=\"widget-tools no-snapshot\"><a href class=widget-tools-item ng-click=odecPanelHeader.odecPanelCtrl.collapse() ng-if=odecPanelHeader.odecPanelHeaderConfig.isCollapsable><i class=\"icon-size-lg icon-keyboard_arrow_down\" uib-tooltip=\"{{\'WIDGET_HIDE\'|translate}}\" ng-if=!odecPanelHeader.odecPanelCtrl.isCollapsed></i> <i class=\"icon-size-lg icon-keyboard_arrow_up\" uib-tooltip=\"{{\'WIDGET_SHOW\'|translate}}\" ng-if=odecPanelHeader.odecPanelCtrl.isCollapsed></i> </a><a href class=widget-tools-item ng-if=odecPanelHeader.odecPanelHeaderConfig.isClosable ng-click=odecPanelHeader.odecPanelCtrl.close()><i class=\"icon-size-lg icon-close\" uib-tooltip=\"{{\'WIDGET_CLOSE\'|translate}}\"></i> </a><span ng-if=odecPanelHeader.odecPanelHeaderConfig.moreActions class=\"widget-tools-item widget-tools-dropdown\" uib-dropdown><a href class=widget-tools-item-toggle uib-dropdown-toggle><i class=\"icon-size-lg icon-more_vert\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=simple-dropdown><li ng-repeat=\"action in odecPanelHeader.odecPanelHeaderConfig.moreActions track by $index\" ng-class=\"{\'divider\':action.type === \'divider\'}\"><a href ng-if=\"action.type === \'action\'\" ng-click=\"action[\'method\']()\">{{action.text|translate}}</a></li></ul></span></div><div class=widget-header-titles><p class=title>{{odecPanelHeader.odecPanelHeaderConfig.title|translate}} <i ng-class=\"{\'fa fa-circle-o-notch fa-spin\':isLoading}\"></i></p><p class=subtitle ng-repeat=\"subtitle in odecPanelHeader.odecPanelHeaderConfig.subtitle track by $index\">{{subtitle|translate}}</p></div></header>");
$templateCache.put("app/components/odecPanel/odecPanelBodyBarActionButton/odecPanelBodyBarActionButton.html","<a href=\"\" ng-click=odecPanelBodyBarActionButton.onButtonClick($event)><i class=\"icon-size-xl {{odecPanelBodyBarActionButton.icon}}\" uib-tooltip=\"{{odecPanelBodyBarActionButton.odecPanelBodyBarActionButtonTooltip | translate }}\"></i> </a>");
$templateCache.put("app/components/odecSnapshotButton/odecSnapshotModal/odecSnapshotModal.html","<div class=\"odecSnapshotModal ng-animate-slide\" ng-if=odecSnapshotModal.visible><div class=odecSnapshotModalScroll odec-scrollable odec-scrollable-autohide=true odec-scrollable-color=#AA142D><div class=\"odecSnapshotModal-wrapper margin-top--2\"><div class=\"odecSnapshotModal-actions text-center\"><button class=\"btn btn-md btn-action\" ng-click=odecSnapshotModal.doSnapshot() uib-tooltip=Confirmar><i class=\"icon-size-lg icon-check text-system\"></i></button> <button class=\"btn btn-md btn-transparent\" ng-click=odecSnapshotModal.cancelSnapshot() uib-tooltip=Cancelar><i class=\"icon-size-lg icon-times text-danger\"></i></button></div><div class=\"odecSnapshotModal-content margin-top--1\" ng-if=odecSnapshotModal.visible><div class=\"odecSnapshotModal-wrapper display__inline-block horizontal--centered\" ng-bind-html=odecSnapshotModal.content|trustAsHTML></div></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/odecWidgetAudience/odecWidgetAudience.html","<div id=odecWidgetAudience class=odecWidgetAudience><div class=widget-body><div class=\"content padding--0_5\"><div class=\"pie-chart index-pie-chart-{{$index}} padding--1\" ng-repeat=\"chart in odecWidgetAudience.odecWidgetAudienceData track by $index\"><odec-d3-progress odec-d3-progress-options=chart></odec-d3-progress></div></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/odecWidgetEvoPen/odecWidgetEvoPen.html","<div id=odecWidgetEvoPen class=\"odecWidgetEvoPen widget-grid-element\"><div class=widget-body><div class=\"content padding--1\"><odec-highcharts class=chart id=prueba odec-highcharts-config=odecWidgetEvoPen.chartConfig odec-highcharts-data=odecWidgetEvoPen.data.series odec-highcharts-categories=odecWidgetEvoPen.data.categories></odec-highcharts></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/odecWidgetHeader/odecWidgetHeader.html","<div id=odec-header-widget class=display__flex><div class=\"title display__flex\" ng-bind-html=\"odecWidgetHeader.titleHeader | boldWords:odecWidgetHeader.extraOptions.boldWords\"></div><div class=\"actions display__flex flex-justify-content-end\"><div class=\"filters display__flex\" ng-if=odecWidgetHeader.filters><div class=\"filter display__flex flex-justify-content-center\" ng-repeat=\"filterGroup in odecWidgetHeader.filters\" ng-style=\"{\'width\':\'calc(100% /\'+odecWidgetHeader.filters.length+\')\'}\"><odec-filter-header class=padding-right--1 filter=filterGroup filter-id=odecWidgetHeader.filterId></odec-filter-header></div></div><div class=\"extra display__flex flex-justify-content-end flex-align-items-center\"><odec-snapshot-button odec-snapshot-button-target-id=\"\'odecWidgetAudience\'\" ng-if=odecWidgetHeader.show></odec-snapshot-button><odec-copy-to-clipboard ng-if=odecWidgetHeader.copyToClipboardData odec-copy-to-clipboard-data=odecWidgetHeader.copyToClipboardData odec-copy-to-clipboard-format-fn=odecWidgetHeader.copyToClipboardFormatFn></odec-copy-to-clipboard><i class=\"icon-size-lg icon-info2 pointer\" tooltip-placement=left-bottom uib-tooltip-html=odecWidgetHeader.infoText></i></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/odecWidgetShareBar/odecWidgetShareBar.html","<div id=odecWidgetShareBar class=\"odecWidgetShareBar widget-grid-element\"><odec-widget-header title-header=\"\'share general de medios\'\" extra-options=\"{boldWords:[\'share\']}\"></odec-widget-header><div class=widget-body><div class=\"content padding--0_5\"><odec-d3-stacked-bar odec-d3-stacked-bar-options=odecWidgetShareBar.data></odec-d3-stacked-bar></div></div></div>");
$templateCache.put("app/components/odecWidgetCollection/odecWidgetHeader/odecFilterHeader/odecFilterHeader.html","<div id=filter-header-widget class=\"display__flex flex-justify-content-center\"><a href=\"\" class=\"selected display__flex flex-justify-content-center flex-align-item-center\" ng-class=\"{\'block-link\': odecFilterHeader.filter.childs.length <= 1}\" ng-click=odecFilterHeader.clickFilter(odecFilterHeader.selected.text)><span class=\"bold--700 selected-text\">{{odecFilterHeader.selected.text | uppercase}}</span> <i ng-if=\"odecFilterHeader.filter.childs.length > 1\" ng-class=\"{\'icon-caret-down\':!odecFilterHeader.isOpen,\'icon-caret-up\':odecFilterHeader.isOpen}\"></i></a><div class=\"card list-item display__flex flex-direction-column flex-align-item-start flex-justify-content-center\" ng-if=odecFilterHeader.isOpen><a class=padding--0_5 href=\"\" ng-click=odecFilterHeader.onSelectOption(item) ng-repeat=\"item in odecFilterHeader.filter.childs\">{{item.text}}</a></div></div>");}]);
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecFilterHeader', odecFilterHeader);

    odecFilterHeader.$inject = ['$rootScope'];
    function odecFilterHeader($rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/odecWidgetCollection/odecWidgetHeader/odecFilterHeader/odecFilterHeader.html',
            bindToController: true,
            controller: odecWidgetHeaderController,
            controllerAs: 'odecFilterHeader',
            link: link,
            restrict: 'EA',
            scope: {
                filter: '<',
                filterId: '<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecFilterHeader;

            vm.isOpen = false;
            vm.clickFilter = clickFilter;
            vm.onSelectOption = onSelectOption;
            vm.selected = vm.filter.selected || _.chain(vm.filter.childs).map().first().value();

            var filterWatcher = $rootScope.$on('odecFilterHeader:closeAll', function(event,value){
                closeOptions(value);
            });

            /* var changeFilter = $rootScope.$on('odecFilterHeader:selectFilter', function(event,value){
                closeOptions(value);
            }); */

            scope.$on('destroy', function(){
                filterWatcher();
            });

            function clickFilter(item){
                $rootScope.$emit('odecFilterHeader:closeAll', item);
                vm.isOpen =  !vm.isOpen;
            }

            function closeOptions(item){
                if(item.title !== vm.filter.title){
                    vm.isOpen = false;
                }
                else{
                    vm.isOpen = vm.isOpen;
                }
            }

            function onSelectOption(item){
                vm.selected = item;
                $rootScope.$emit(vm.filterId ? ('odecFilterHeader:selectFilter:' + vm.filterId+':'+vm.filter.comboId) : 'odecFilterHeader:selectFilter', item);
                closeOptions(item);
            }

            function init() {
            }

            init();
        }
    }
    /* @ngInject */
    function odecWidgetHeaderController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecWidgetShareBar', odecWidgetShareBar);

    odecWidgetShareBar.inject = ['$http'];
    function odecWidgetShareBar($http) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/odecWidgetShareBar/odecWidgetShareBar.html',
            bindToController: true,
            controller: odecWidgetShareBarController,
            controllerAs: 'odecWidgetShareBar',
            link: link,
            restrict: 'EA',
            scope: {
                config: '<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var config = scope.odecWidgetShareBar.config;


        }

        
    }
    /* @ngInject */
    function odecWidgetShareBarController (globalHelpersService, $filter, $http) {
        var vm = this;
        getData();

        function getData() {
            return $http({
                method:'GET',
                url:'./data/audienciaGeneral.json'
            })
            .then(function(data) {
                vm.data = data.data;
              });        
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecWidgetHeader', odecWidgetHeader);

    odecWidgetHeader.$inject = ['stateManagerService'];
    function odecWidgetHeader(stateManagerService) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/odecWidgetCollection/odecWidgetHeader/odecWidgetHeader.html',
            bindToController: true,
            controller: odecWidgetHeaderController,
            controllerAs: 'odecWidgetHeader',
            link: link,
            restrict: 'EA',
            scope: {
                titleHeader:'<',
                showFilters:'<',
                filters:'<',
                filterId: '<',
                showInfo:'<',
                infoText:'<',
                showSnapshot:'<',
                extraOptions:'<',
                copyToClipboardData:'<',
                copyToClipboardFormatFn:'<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
          var vm = scope.odecWidgetHeader;

              var waveCollection = stateManagerService.getState('waveCollection');
              var selectedWave = waveCollection ? waveCollection.selected : null;
              if (!selectedWave) return;

              var translate = (selectedWave.year <= '2023' && selectedWave.wave < '03') ? "semana" : "quincena";

              var staticText = '<div class="padding--0_5">'+
                  '<p class="no-margin text-left"><span class="bold--700"> Diarios: </span> lectores/día</p>'+
                  '<p class="no-margin text-left"><span class="bold--700"> Suplementos: </span> lectores/semana</p>'+
                  '<p class="no-margin text-left"><span class="bold--700"> Revistas: </span> lectores/periodo public.</p>'+
                  '<p class="no-margin text-left"><span class="bold--700"> Radio: </span> oyentes/día</p>'+
                  '<p class="no-margin text-left"><span class="bold--700"> Televisión: </span> espectadores/día</p>'+
                  '<p class="no-margin text-left"><span class="bold--700"> Exterior: </span> soportes vistos/semana</p>'+
                  '<p class="no-margin text-left"><span class="bold--700"> Cine: </span> espectadores/' + translate + '</p>'+
                  '<p class="no-margin text-left"><span class="bold--700"> Internet: </span> usuarios/día</p>'+
                  '<p class="no-margin text-left"></span>@AIMC - Fuente EGM</p>'+
                  '</div>';

              vm.infoText = staticText;
      }

    }
    /* @ngInject */
    function odecWidgetHeaderController () {

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecWidgetEvoPen', odecWidgetEvoPen);

    odecWidgetEvoPen.inject = ['$http'];
    function odecWidgetEvoPen($http) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/odecWidgetEvoPen/odecWidgetEvoPen.html',
            bindToController: true,
            controller: odecWidgetEvoPenController,
            controllerAs: 'odecWidgetEvoPen',
            link: link,
            restrict: 'EA',
            scope: {
                data: '<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecWidgetEvoPen;
            vm.chartData = [];
            vm.chartConfig = {};

            init();

        // private methods
        function init() {
            vm.chartConfig = angular.copy(getConfigColumn());
        }

        function getConfigColumn() {

            return {
                chart: {
                    type: 'line',
                    spacingBottom: 60
                },
                title: null,
                yAxis: {
                    min: 0,
                    ceiling: 100,
                    title: null,
                    labels: {
                        formatter: function () {
                            return this.value + ' %';
                        }
                    }
                },
                xAxis: {
                    enableMouseTracking: true
                },
                tooltip: {
                    enabled: true,
                    backgroundColor: '#ffffff',
                    shared: true,
                    crosshairs: true,
                    useHTML: true,
                    headerFormat: '<div style="font-size: 18px; margin-left: 10px;"> Año {point.key} </div>',
                    pointFormat: '<span"> <a style="font-size: 13px; color:{series.color};">●</a> <b> {series.name}: {point.y:.1f}</b><br/>',
                    style: {
                        fontFamily: 'Montserrat'
                    }
                },
                plotOptions: {

                    series: {
                        point: {
                            events: {
                                mouseOut: function (e) {
                                    this.dataLabel.css({
                                        fontSize: "0px"
                                    });
                                },
                                mouseOver: function (e) {
                                    this.dataLabel.css({
                                        fontSize: "11px"
                                    });
                                }
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            align: 'center',
                            style: { fontSize: '0px' },
                            states: {
                                hover: {
                                    enabled: true
                                }
                            },
                            format:'{point.y:,.1f}'
                        }
                    },

                    line: {
                        marker: {
                            enabled: true,
                            symbol: 'circle',
                            radius: 4
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                legend: {
                    symbolHeight: 0,
                    symbolPadding: 10,
                    symbolWidth: 0,
                    verticalAlign: 'bottom',
                    align: 'center',
                    y: 60,
                    labelFormatter: function () {
                        return '<span"><b style="padding: 10px;">' + this.name + '</b><br/>';
                    }
                },
                responsive: {
                    rules: [{
                      condition: {
                        maxWidth: 500
                      },
                      chartOptions: {
                        legend: {
                          itemWidth: 125
                        }
                      }
                    }]
                  }
            };

        }
        }

        
    }
    /* @ngInject */
    function odecWidgetEvoPenController ($http) {
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecWidgetAudience', odecWidgetAudience);

    odecWidgetAudience.inject = ['$http'];
    function odecWidgetAudience($http) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecWidgetCollection/odecWidgetAudience/odecWidgetAudience.html',
            bindToController: true,
            controller: odecWidgetAudienceController,
            controllerAs: 'odecWidgetAudience',
            link: link,
            restrict: 'EA',
            scope: {
                odecWidgetAudienceData: '<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecWidgetAudience;
            var audienceData = scope.$watch('odecWidgetAudience.odecWidgetAudienceData', function (newData) {
                return vm;
            });
            
        }

        
    }
    /* @ngInject */
    function odecWidgetAudienceController (globalHelpersService, $filter, $http) {
        var vm = this;
    }
})();
/*global canvg,html2canvas*/
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSnapshotModal', odecSnapshotModal);

    odecSnapshotModal.$inject = ['$rootScope'];
    function odecSnapshotModal($rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecSnapshotButton/odecSnapshotModal/odecSnapshotModal.html',
            bindToController: true,
            controller: odecSnapshotModalController,
            controllerAs: 'odecSnapshotModal',
            link: link,
            restrict: 'EA',
            scope: {
            }
        };

        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecSnapshotModal;
            vm.visible = false;
            vm.model = {};
            vm.content = null;

            // listeners
            var snapItWatcher = $rootScope.$on('snapshot:snapIt', render);

            scope.$on('$destroy', function () {
                snapItWatcher();
            });

            // private method

            function render(event, args) {
                vm.visible = true;
                vm.content = args.html;
                vm.model = args.model;
            }
        }
    }

    odecSnapshotModalController.$inject = ['$rootScope','snapshotsService','$q','errorHandlerService','$document'];
    function odecSnapshotModalController($rootScope,snapshotsService,$q,errorHandlerService,$document) {
        var vm = this;

        vm.doSnapshot = doSnapshot;
        vm.cancelSnapshot = cancelSnapshot;

        var height;
        var width;

        function doSnapshot() {

            var elementSnapModalWrapper = angular.element('.odecSnapshotModal-wrapper');
            height = elementSnapModalWrapper.height()+50; //sum an error margin of 50
            width = elementSnapModalWrapper.width()+50; //sum an error margin of 50

            var element = angular.element('.odecSnapshotModal-content');
            
            transformSvgToCanvas(element.find('.odecSnapshotModal-wrapper'))
            .then(transformHtml2canvas)
            .then(addImage)
            .catch(errorHandlerService.callbackError);
        }

        function transformSvgToCanvas(el) {
            svgToCanvas(el);
            return $q.when(el);
        }

        function transformHtml2canvas(el) {
            return html2canvas(el, {/*allowTaint: true,*/logging: true})
                .then(function (canvas) {
                    var img = canvas.toDataURL('image/png');
                    var obj = _.extend({ image: img }, vm.model);
                    return obj;
                });
        }

        function addImage(obj) {
            snapshotsService.appendSnapshot(obj);
            vm.visible = false;
        }

        function cancelSnapshot() {
            if (vm.fnPostSnapshot) {
                vm.fnPostSnapshot();
            }
            vm.visible = false;
        }

        function svgToCanvas(targetElem) {
            var svgElem = targetElem.find('svg');

            svgElem.each(function (index, node) {
                var parentNode = node.parentNode;

                // el ie es muy pijo...
                var s = new XMLSerializer();
                var svg = s.serializeToString(node);

                var canvas = $document && $document[0].createElement('canvas');

                canvg(canvas, svg);
                parentNode.removeChild(node);
                parentNode.appendChild(canvas);
            });
        }
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app')
        .directive('odecPanelHeader', odecPanelHeader);

    /* @ngInject */
    function odecPanelHeader() {
        // Usage:
        // <odec-panel-header 
        //   odec-panel-header-config="config">
        // </odec-panel-header>
        //
        // config = {
        //      title:'Este es el titulo',
        //      isClosable:true,
        //      isCollapsable:true,
        //      moreActions:[
        //          {
        //              type:'action',
        //              text:'Action 01',
        //              method:interviewlist.actions.fnAction01
        //          },{
        //              type:'divider'
        //          },{
        //              type:'action',
        //              text:'Action 02',
        //              method:interviewlist.actions.fnAction02
        //          }
        //      ]} 
        //
        // Creates:
        //

        
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelHeader/odecPanelHeader.html',
            bindToController: true,
            controller: odecPanelHeaderController,
            controllerAs: 'odecPanelHeader',
            link: link,
            restrict: 'EA',
            require:'^^odecPanel',
            scope: {
                odecPanelHeaderConfig:"<"
            }
        };
        return directive;
        
        function link(scope, element, attrs,ctrl) {
            var vm = scope.odecPanelHeader;
            //scope.odecPanelHeader.odecPanelHeaderConfig.isCollapsable = angular.isUndefined(vm.odecPanelHeaderConfig.isCollapsable)? true:false; 
            //scope.odecPanelHeader.odecPanelHeaderConfig.isClosable    = angular.isUndefined(vm.odecPanelHeaderConfig.isClosable)? true:false; 


            vm.odecPanelCtrl = ctrl;
        }
    }
    /* @ngInject */
    function odecPanelHeaderController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecPanelFooter', odecPanelFooter);

    /* @ngInject */
    function odecPanelFooter() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelFooter/odecPanelFooter.html',
            bindToController: true,
            controller: odecPanelFooterController,
            controllerAs: 'odecPanelFooter',
            link: link,
            restrict: 'EA',
            transclude:true,
            require:'^^odecPanel',
            scope: {
            }
        };
        return directive;
        
        function link(scope, element, attrs,ctrl) {
            var vm = scope.odecPanelFooter;
            vm.odecPanelCtrl = ctrl;
        }
    }
    /* @ngInject */
    function odecPanelFooterController () {
        
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app')
        .directive('odecPanelBodyBarActionButton', odecPanelBodyBarActionButton);

    /* @ngInject */
    function odecPanelBodyBarActionButton() {

        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelBodyBarActionButton/odecPanelBodyBarActionButton.html',
            bindToController: true,
            controller: odecPanelBodyBarActionButtonController,
            controllerAs: 'odecPanelBodyBarActionButton',
            link: link,
            restrict: 'EA',
            require:'^^odecPanel',
            scope: {
                odecPanelBodyBarActionButtonOnClick:"<",
                odecPanelBodyBarActionButtonIcon:"<",
                odecPanelBodyBarActionButtonTooltip:"<"
            }
        };
        return directive;
        
        function link(scope, element, attrs,ctrl) {
            var vm = scope.odecPanelBodyBarActionButton;
            vm.onButtonClick = onButtonClick; 
            vm.isLoading = false;
            vm.icon = vm.odecPanelBodyBarActionButtonIcon;

            // private methods
            function onButtonClick(event) {
                if (vm.isLoading) {
                    event.preventDefault();
                    return;
                }
                vm.isLoading = true;
                vm.icon = 'icon-spinner22 animated-spin';
                vm.odecPanelBodyBarActionButtonOnClick()
                .finally(function(){
                    vm.isLoading = false;
                    vm.icon = vm.odecPanelBodyBarActionButtonIcon;
                });
            }
        }
    }
    /* @ngInject */
    function odecPanelBodyBarActionButtonController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecPanelBodyBar', odecPanelBodyBar);

    /* @ngInject */
    function odecPanelBodyBar() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelBodyBar/odecPanelBodyBar.html',
            bindToController: true,
            controller: odecPanelBodyBarController,
            controllerAs: 'odecPanelBodyBar',
            link: link,
            restrict: 'EA',
            transclude:{
                exports:'?odecPanelBodyBarSlotExports',
                multiwaveexport:'?odecPanelBodyBarSlotMultiwaveExport'
            },
            scope: {
                odecPanelBodyBarSearchText:'=?',
                odecPanelBodyBarSearchPlaceholder:'<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecPanelBodyBarController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecPanelBody', odecPanelBody);

    /* @ngInject */
    function odecPanelBody() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanelBody/odecPanelBody.html',
            bindToController: true,
            controller: odecPanelBodyController,
            controllerAs: 'odecPanelBody',
            link: link,
            restrict: 'EA',
            transclude:true,
            require:'^^odecPanel',
            scope: {
            }
        };
        return directive;
        
        function link(scope, element, attrs,ctrl) {
            var vm = scope.odecPanelBody;
            vm.odecPanelCtrl = ctrl;
        }
    }
    /* @ngInject */
    function odecPanelBodyController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('odecFilterPills', odecFilterPills);

    //odecFilterPills.$inject = [''];
    function odecFilterPills() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecFilter/odecFilterPills/odecFilterPills.html',
            bindToController: true,
            controller: odecFilterPillsController,
            controllerAs: 'odecFilterPills',
            link: link,
            restrict: 'EA',
            scope: {
                odecFilterPillsCollection:'<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecFilterPills;
        }
    }
    /* @ngInject */
    function odecFilterPillsController ($scope) {
        var vm = this;
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSubmenuList', odecSubmenuList);

    //odecSubmenuList.$inject = ['dep'];
    function odecSubmenuList() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSubmenuList/odecSubmenuList.html',
            bindToController: true,
            controller: odecSubmenuListController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            transclude:true,
            scope: {
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecSubmenuListController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebarOverlay', odecSidebarOverlay);

    //odecSidebarOverlay.$inject = ['dependency1'];
    function odecSidebarOverlay() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/layout-ui/odecSidebarOverlay/odecSidebarOverlay.html',
            bindToController: true,
            controller: odecSidebarOverlayController,
            controllerAs: 'odecSidebarOverlay',
            link: link,
            restrict: 'EA',
            scope: {
                odecSidebarOverlayOpened:'=',
                odecSidebarOverlayClose:'&'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarOverlayController () {
        var vm = this;

        vm.closeOverlay = closeOverlay;

        /** private methods */

        function closeOverlay(value) {
            vm.odecSidebarOverlayClose(value);
        } 
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebarToggle', odecSidebarToggle);

    //odecSidebarToggle.$inject = ['dependency1'];
    function odecSidebarToggle() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSidebarToggle/odecSidebarToggle.html',
            bindToController: true,
            controller: odecSidebarToggleController,
            controllerAs: 'odecSidebarToggle',
            link: link,
            restrict: 'EA',
            scope: {
                odecSidebarToggleOpen:'&'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarToggleController () {
        var vm = this;

        vm.clicked = clicked;

        /** private methods */
        function clicked(value) {
            vm.odecSidebarToggleOpen(value);
        }    
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecSidebar', odecSidebar);

    //odecSidebar.$inject = ['dependency1'];
    function odecSidebar() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecSidebar/odecSidebar.html',
            bindToController: true,
            controller: odecSidebarController,
            controllerAs: 'odecSidebar',
            link: link,
            restrict: 'EA',
            replace:true,
            transclude:true,
            scope: {
                odecSidebarOpened:'='
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecSidebarController () {
        
    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuListItem', odecMenuListItem);

    //odecMenuListItem.$inject = ['dep'];
    function odecMenuListItem() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecMenuListItem/odecMenuListItem.html',
            bindToController: true,
            controller: odecMenuListItemController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuListItemSelected:'=',
                odecMenuListItemIcon:'<',
                odecMenuListItemSelectedOnSelect:'&',
                odecMenuListItemLabel:'<',
                odecMenuListItemSubmenuChilds:'<'
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecMenuListItemController () {
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuList', odecMenuList);

    //odecMenuList.$inject = ['lodash'];
    function odecMenuList() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/layout-ui/odecMenuList/odecMenuList.html',
            bindToController: true,
            controller: odecMenuListController,
            controllerAs: 'odecMenuList',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuListCollection: '<'
            }
        };
        return directive;

        function link(scope) {
            var vm = scope.odecMenuList;
            // seleccionamos el primer item
            vm.data = {
                odecMenuListCollection: preSelect(vm.odecMenuListCollection)
            };
        }


        /** METODOS PRIVADOS */

        // si viene con algun elemento preseleccionado lo devolvemos tal cual sino
        // le preseleccionamos el primero
        function preSelect(collection) {
            var hasSelectedItem = _.chain(collection)
                .some(function (item) {
                    return item.selected;
                })
                .value();
            
            if (!hasSelectedItem) {
                return _.chain(collection)
                .map(function (item, index) {
                    if (index === 0) {
                        item.selected = true;
                    }
                    return item;
                })
                .value();
            }
            
            return collection;
        }
    }
    /* @ngInject */
    function odecMenuListController() {
        var vm = this;
        vm.onSelect = onSelect;

        /** private methods */
        function onSelect(event,menuItem) {
            if (!menuItem) {
                return;
            }
            
            // quitamos todos los seleccionados y ponemos el que toca a seleccionados
            vm.data.odecMenuListCollection = _.chain(vm.data.odecMenuListCollection)
            .map(function(item){
                if(item === menuItem) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
                return item;
            })
            .value();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecMenuLink', odecMenuLink);

    odecMenuLink.$inject = ['$state'];
    function odecMenuLink($state) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecMenuLink/odecMenuLink.html',
            bindToController: true,
            controller: odecMenuLinkController,
            controllerAs: 'odecMenuLink',
            link: link,
            restrict: 'EA',
            scope: {
                odecMenuLinkLabel:'<',
                odecMenuLinkState:'<',
                odecMenuLinkUrl:'<',
                odecMenuLinkOnClick:'&',
                odecMenuLinkVisible: '<'
            }
        };
        return directive;
        
        function link(scope) {
            var vm = scope.odecMenuLink;
            vm.onClick = onClick;

            /** metodos privados */

            function onClick() {
                scope.$emit('odecMenuLink:clicked');
                $state.go.apply(this,vm.odecMenuLinkState);
            }
        }
    }
    /* @ngInject */
    function odecMenuLinkController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecHeader', odecHeader);

    //odecHeader.$inject = ['dependency1'];
    function odecHeader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecHeader/odecHeader.html',
            bindToController: true,
            controller: odecHeaderController,
            controllerAs: 'odecHeader',
            link: link,
            restrict: 'EA',
            replace:true,
            transclude:true,
            scope: {
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecHeaderController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecFooter', odecFooter);

    //odecHeader.$inject = ['dependency1'];
    function odecFooter() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/odecFooter/odecFooter.html',
            bindToController: true,
            controller: odecFooterController,
            controllerAs: 'odecFooter',
            link: link,
            restrict: 'EA',
            replace:true,
            transclude:true,
            scope: {
            }
        };
        return directive;
        
        function link() {
        }
    }
    /* @ngInject */
    function odecFooterController () {
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecD3TargetSexDonut', odecD3TargetSexDonut);

    odecD3TargetSexDonut.inject = ['d3', 'uuid', '$rootScope', '$state', 'odecD3Service'];
    function odecD3TargetSexDonut(d3, uuid, $rootScope, $state, odecD3Service) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/d3/odecD3TargetSexDonut/odecD3TargetSexDonut.html',
            bindToController: true,
            controller: odecD3TargetSexDonutController,
            controllerAs: 'odecD3TargetSexDonut',
            link: link,
            restrict: 'EA',
            scope: {
                odecD3TargetSexDonutData: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecD3TargetSexDonut;
            var svg;
            var formatES = d3.formatLocale(odecD3Service.es_ES);
            var formatDecimal = formatES.format(",.1f");

            var _uuid = 'chart' + uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));

            var dataListener = scope.$watch('odecD3TargetSexDonut.odecD3TargetSexDonutData', function (newData) {
                if (newData) {
                    update();
                } else if (svg) {
                    svg.remove();
                }
            });

            update();

            var repaintListener = $rootScope.$on('window.resize', update);

            $rootScope.$on('$destroy', function () { 
                dataListener(); 
                repaintListener();
            });

            function update() {

                /*** If data/options change or window is resized we remove the svg and then repaint it ***/

                var elementRemove = d3.select('#' + element.attr('id'));
                elementRemove.select('svg').remove('svg');

                var width = element.innerWidth();
                var height = element.innerHeight();
                var radius = Math.min(width, height) / 3;
                var fontSize = radius * 0.25;
                var color = d3.scaleOrdinal(["#1D3661", "#914e56"]);
                var data = [_.find(vm.odecD3TargetSexDonutData, {'id': 'SEX.D1'}) && _.find(vm.odecD3TargetSexDonutData, {'id': 'SEX.D1'}).value, _.find(vm.odecD3TargetSexDonutData, {'id': 'SEX.D2'}) && _.find(vm.odecD3TargetSexDonutData, {'id': 'SEX.D2'}).value];
                var colorMan = "#1D3661";
                var colorWoman = "#914e56";

                var svg = d3.select('#' + element.attr('id'))
                    .append("svg")
                    .attr("width", width)
                    .attr("height", height);

                var groupChart = svg.append("g")
                    .attr("class", "group-chart");

                var chartSlices = groupChart.append("g")
                    .attr("class", "slices");

                var pie = d3.pie().sort(null).value(function (d) { return d; });
                var arc = d3.arc()
                    .innerRadius(radius * 0.75)
                    .outerRadius(radius * 0.6)
                    .padAngle(0.02);

                groupChart.attr("transform", "translate(" + width / 2 + "," + height / 2.5 + ")");

                chartSlices.selectAll('path')
                    .data(pie(data))
                    .enter()
                    .append('path')
                    .attr('fill', function (d, i) { return color(i); })
                    .transition()
                    .ease(d3.easeBounce)
                    .duration(2000)
                    .attrTween("d", tweenPie)
                    .transition()
                    .ease(d3.easeElastic)
                    .delay(function (d, i) { return 2000 + i * 50; })
                    .duration(750)
                    .attrTween("d", tweenDonut)
                    .attr("d", arc);

                function tweenPie(b) {
                    b.innerRadius = 0;
                    var i = d3.interpolate({ startAngle: 0, endAngle: 0 }, b);
                    return function (t) { return arc(i(t)); };
                }

                function tweenDonut(b) {
                    b.innerRadius = radius * 0.6;
                    var i = d3.interpolate({ innerRadius: 0 }, b);
                    return function (t) { return arc(i(t)); };
                }

                var inside = svg.append("g").attr("class", "inside-items");

                var groupWoman = inside
                    .append('g')
                    .attr('class', 'group-woman');

                groupWoman
                    .append('path')
                    .attr('d', 'M17.7,0A9,9,0,1,1,8.75,9,8.95,8.95,0,0,1,17.7,0ZM11.49,20.14a3.52,3.52,0,0,0-3.24,2.22L.32,40.82A3.13,3.13,0,0,0,1.73,45a3.08,3.08,0,0,0,4.13-1.4v0l.6-1.22s.19-.33.12,0C6.15,44.65,5,51.49,5,51.49A2.08,2.08,0,0,0,6.51,54a2.11,2.11,0,0,0,.61.06h3.45c.25,0,.2.19.2.19V68a3.17,3.17,0,0,0,2.79,3.49,3,3,0,0,0,.42,0c1.76,0,3.2-1.21,3.2-3.51V54.21a.13.13,0,0,1,.11-.13h.89c.21,0,.11.15.11.15V68c0,2.3,1.43,3.51,3.2,3.51a3.15,3.15,0,0,0,3.19-3.13,1.62,1.62,0,0,0,0-.38V54.3a.22.22,0,0,1,.24-.22h3.72a2.14,2.14,0,0,0,2.22-2,2.06,2.06,0,0,0-.06-.55s-1.19-7.33-1.51-9.33c-.09-.57.86,1.46.86,1.46a2.62,2.62,0,0,0,3.31,1.64,2.43,2.43,0,0,0,.37-.16,3.11,3.11,0,0,0,1.48-4.15l-7.63-18.6c-.44-.94-.83-2.2-2.62-2.2Z')
                    .attr("transform", function () {
                        var size = d3.select(this).node().getBoundingClientRect();
                        var scaleRatio = (radius/size.height)*0.7;
                        var iconX = (width / 2 - size.width * scaleRatio);
                        var iconY = height / 2.5 - size.height * scaleRatio / 2.5;
                        return "translate(" + iconX * 0.95 + "," + iconY + ") scale(" + scaleRatio + ")";
                    })
                    .attr('fill', "#914e56");

                var groupMan = inside
                    .append('g')
                    .attr('class', 'group-man');

                groupMan
                    .append('path')
                    .attr('d', 'M9.91,19.92a3.4,3.4,0,0,0-3.42,2.23L.19,41.38a3.15,3.15,0,0,0,1.81,4,3.08,3.08,0,0,0,4-1.77l0-.06L7.68,39s.12-.46.12,1.54V67.3a4.17,4.17,0,0,0,8.34,0h0V49.85a.13.13,0,0,1,.11-.15h1.59a.14.14,0,0,1,.15.13V67.3a4.17,4.17,0,1,0,8.34,0h0V40.6c0-2,.17-1.39.17-1.39l1.62,4.38a3.1,3.1,0,0,0,4,1.85h0a3.17,3.17,0,0,0,1.81-4L27.63,22.2A3.6,3.6,0,0,0,24.2,20ZM17.13,0A8.89,8.89,0,1,1,8.18,8.89,8.92,8.92,0,0,1,17.13,0Z')
                    .attr("transform", function () {
                        var size = d3.select(this).node().getBoundingClientRect();
                        var scaleRatio = (radius/size.height)*0.7;
                        var iconX = (width / 2);
                        var iconY = height / 2.5 - size.height * scaleRatio / 2.5;
                        return "translate(" + iconX * 1.05 + "," + iconY + ") scale(" + scaleRatio + ")";
                    })
                    .attr('fill', "#1D3661");

                var labelRight = svg.append("g").attr("class", "label-right")
                    .attr('transform', 'translate(' + ((width / 2) + radius * 0.8) + ',' + (height / 2.5 + fontSize / 2) + ')');

                var numberRight = labelRight.append('text');

                numberRight
                    .append("tspan")
                    .attr('text-anchor', 'start')
                    .attr('font-size', fontSize)
                    .attr('font-weight', 'bolder')
                    .text(formatDecimal(data[0]))
                    .attr('fill', "#1D3661");

                numberRight
                    .append("tspan")
                    .attr('text-anchor', 'middle')
                    .attr('font-size', fontSize / 2)
                    .attr('font-weight', 'bolder')
                    .text("%")
                    .attr('fill', "#1D3661");

                var labelLeft = svg.append("g").attr("class", "label-right")
                    .attr('transform', 'translate(' + ((width / 2) - radius * 0.8) + ',' + (height / 2.5 + fontSize / 2) + ')');

                var numberLeft = labelLeft.append('text');

                numberLeft
                    .append("tspan")
                    .attr('text-anchor', 'end')
                    .attr('font-size', radius * 0.25)
                    .attr('font-weight', 'bolder')
                    .text(formatDecimal(data[1]))
                    .attr('fill', "#914e56");

                numberLeft
                    .append("tspan")
                    .attr('text-anchor', 'middle')
                    .attr('font-size', radius * 0.15)
                    .attr('font-weight', 'bolder')
                    .text("%")
                    .attr('fill', "#914e56");

                /*** legend  ***/
               
                var legend = svg.append('g')
                    .attr('class', 'legend')
                    .attr("transform", "translate(" + 0 + "," + height*0.85 + ")");


                var  itemLegendMan = legend
                    .append('g')
                    .attr('class', 'item-legend-man');
                
                itemLegendMan
                    .append('circle')
                    .attr('fill', colorMan)
                    .attr('r', 3.5)
                    .attr("transform", "translate(" + ((width/2) + (radius/3)) + "," + 0 + ")")
                    .attr('cy', -3.5)
                    .attr('cx', -5);

                itemLegendMan
                    .append('text')
                    .attr('font-size', 11)
                    .attr('fill', colorMan)
                    .attr('font-weight', 'bold')
                    .attr('class', 'item-legend')
                    .text("HOMBRE")
                    .attr("transform", "translate(" + ((width/2) + (radius/3)) + "," + 0 + ")")
                    .attr('text-anchor', 'start');
                    
                var  itemLegendWoman = legend
                    .append('g')
                    .attr('class', 'item-legend-woman');

                    itemLegendWoman
                    .append('circle')
                    .attr('fill', colorWoman)
                    .attr('r', 3.5)
                    .attr("transform", "translate(" + ((width/2) - (radius/3)) + "," + 0 + ")")
                    .attr('cy', -3.5)
                    .attr('cx', -45);

                itemLegendWoman
                    .append('text')
                    .attr('font-size', 11)
                    .attr('fill', colorWoman)
                    .attr('font-weight', 'bold')
                    .attr('class', 'item-legend')
                    .text('MUJER')
                    .attr("transform", "translate(" + ((width/2) - (radius/3))  + "," + 0 + ")")
                    .attr('text-anchor', 'end');
            }
        }
    }
    /* @ngInject */
    function odecD3TargetSexDonutController() {

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecD3TargetDonut', odecD3TargetDonut);

    odecD3TargetDonut.inject = ['d3', 'uuid', '$rootScope', '$state', 'odecD3Service', 'configurationLoaderService'];
    function odecD3TargetDonut(d3, uuid, $rootScope, $state, odecD3Service, configurationLoaderService) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/d3/odecD3TargetDonut/odecD3TargetDonut.html',
            bindToController: true,
            controller: odecD3TargetDonutController,
            controllerAs: 'odecD3TargetDonut',
            link: link,
            restrict: 'EA',
            scope: {
                odecD3TargetDonutData: '<',
                odecD3TargetDonutIcon: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecD3TargetDonut;
            var svg;
            var formatES = d3.formatLocale(odecD3Service.es_ES);
            var formatDecimal = formatES.format(",.1f");

            var _uuid = 'chart' + uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));

            var dataListener = scope.$watch('odecD3TargetDonut.odecD3TargetDonutData', function (newData) {
                if (newData) {
                    update();
                } else if (svg) {
                    svg.remove();
                }
            });

            var repaintListener = $rootScope.$on('window.resize', update);

            $rootScope.$on('$destroy', function () { 
                dataListener(); 
                repaintListener();
            });

            /***Tooltip */
            var tip = d3.tip()
            .attr("class", "d3-tip d3-tip-donut")
            .html(function (data) {
                return '<p>' + data + '</p>';
            });

            function update() {

                /*** If data/options change or window is resized we remove the svg and then repaint it ***/

                var elementRemove = d3.select('#' + element.attr('id'));
                elementRemove.select('svg').remove('svg');

                var width = element.innerWidth();
                var height = element.innerHeight();
                var radius = Math.min(width, height) / 3;
                var colorSerie = _.chain(configurationLoaderService.getConfig()).result('colors').result('general').result('mainSerie').value();
                var color = d3.scaleOrdinal(colorSerie);
                var data = vm.odecD3TargetDonutData.values;
                var dataText = vm.odecD3TargetDonutData.text;

                /*** Chart options ***/

                //var numColumns = vm.odecD3TargetDonutOptions.numColumns; legend row num of elements
                var numColumns = 4;

                svg = d3.select('#' + element.attr('id'))
                    .append("svg")
                    .attr("width", width)
                    .attr("height", height);
                
                //svg.call(tip);

                var groupChart = svg.append("g")
                    .attr("class", "group-chart");

                var chartSlices = groupChart.append("g")
                    .attr("class", "slices");
                var chartLabels = groupChart.append("g")
                    .attr("class", "labels");
                var chartLines = groupChart.append("g")
                    .attr("class", "lines");

                

                var pie = d3.pie().sort(null).value(function (d) { return d; });
                var arc = d3.arc()
                    .innerRadius(radius * 0.75)
                    .outerRadius(radius * 0.6)
                    .padAngle(0.02);

                var outerArc = d3.arc()
                    .outerRadius(radius * 0.8)
                    .innerRadius(radius * 0.8);

                groupChart.attr("transform", "translate(" + width / 2 + "," + height / 2.5 + ")");

                chartSlices.selectAll('path')
                    .data(pie(data))
                    .enter()
                    .append('path')
                    .attr('fill', function (d, i) { return color(i); })
                    .transition()
                    .ease(d3.easeBounce)
                    .duration(1000)
                    .attrTween("d", tweenPie)
                    .transition()
                    .ease(d3.easeElastic)
                    .delay(function (d, i) { return 2000 + i * 50; })
                    .duration(750)
                    .attrTween("d", tweenDonut)
                    .attr("d", arc);

                function tweenPie(b) {
                    b.innerRadius = 0;
                    var i = d3.interpolate({ startAngle: 0, endAngle: 0 }, b);
                    return function (t) { return arc(i(t)); };
                }

                function tweenDonut(b) {
                    b.innerRadius = radius * 0.6;
                    var i = d3.interpolate({ innerRadius: 0 }, b);
                    return function (t) { return arc(i(t)); };
                }

                var polyline = chartLines
                    .selectAll('polyline')
                    .data(pie(data))
                    .enter().append('polyline')
                    .attr('points', function (d) {
                        var pos = outerArc.centroid(d);
                        pos[0] = midAngle(d) < Math.PI ? (pos[0] + 10) : (pos[0] - 10);
                        return [arc.centroid(d), outerArc.centroid(d), pos];
                    });

                var label = chartLabels.selectAll('text')
                    .data(pie(data))
                    .enter().append('text')
                    .attr('font-weight', 'bolder')
                    .attr('dy', '.35em')
                    .attr('fill', "black")
                    .text(function (d) {
                        return formatDecimal(d.data);
                    })
                    .attr('transform', function (d) {
                        var pos = outerArc.centroid(d);
                        pos[0] = midAngle(d) < Math.PI ? (pos[0] + 10) : (pos[0] - 10);
                        return 'translate(' + pos + ')';
                    })
                    .attr('text-anchor', function (d) {
                        return (midAngle(d)) < Math.PI ? 'start' : 'end';
                    });

                label
                    .append("tspan")
                    .attr('text-anchor', 'middle')
                    .attr('font-size', '.5em')
                    .attr('font-weight', 'bolder')
                    .text("%");

                var inside = svg.append("g").attr("class", "inside-items");

                var icon = inside.append("image")
                    .attr("class", "donut-center-icon")
                    .attr('height', radius * 0.4)
                    .attr('width', radius * 0.4)
                    .attr("xlink:href", "assets/images/" + vm.odecD3TargetDonutIcon);

                icon
                    .attr('x', function () {
                        var size = d3.select(this).node().getBBox();
                        return (width / 2 - size.width / 2);
                    })
                    .attr('y', function () {
                        var size = d3.select(this).node().getBBox();
                        return (height / 2.5 - size.height / 2);
                    });

                function midAngle(d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; }

                //Add legend chart

                var sizeColLegend = angular.isDefined(numColumns) && numColumns > 0 ? width / numColumns : width / data.length;
                var legend = svg.append('g')
                    .attr('class', 'legend')
                    .attr("transform", "translate(" + radius / 3 + "," + (-15) + ")");

                var itemLegend = legend
                    .selectAll('.item-legend')
                    .data(dataText)
                    .enter()
                    .append('g');/*
                    .on('mouseenter', function (d) {
                        return tip.show(d);
                    })
                    .on('mouseleave', tip.hide);*/

                itemLegend
                    .append('circle')
                    .attr('fill', function (d, i) {
                        return color(i);
                    })
                    .attr('r', 3.5)
                    .attr("transform", function (d, i) {
                        if (angular.isDefined(numColumns) && numColumns > 0) {
                            var xOff = (i % numColumns) * sizeColLegend;
                            var yOff = Math.floor(i / numColumns) * 20;
                            return "translate(" + xOff + "," + yOff + ")";
                        }
                        else {
                            return "translate(" + (i * sizeColLegend) + "," + 0 + ")";
                        }
                    })
                    .attr("cx", 5)
                    .attr("cy", height * 0.84);

                itemLegend
                    .append('text')
                    .attr('font-size', 11)
                    .attr('class', 'item-legend')
                    .text(function (d) {
                        return d;
                    })
                    .attr("transform", function (d, i) {
                        if (angular.isDefined(numColumns) && numColumns > 0) {
                            var xOff = (i % numColumns) * sizeColLegend;
                            var yOff = Math.floor(i / numColumns) * 20;
                            return "translate(" + xOff + "," + yOff + ")";
                        }
                        else {
                            return "translate(" + (i * sizeColLegend) + "," + 0 + ")";
                        }
                    })
                    .attr("dx", 12)
                    .attr("dy", height * 0.85)
                    .each(function (d, i) {
                        d3.select(this).call(odecD3Service.ellipsis.bind(d3.select(this).node(), sizeColLegend));
                    });
            }
        }
    }
    /* @ngInject */
    function odecD3TargetDonutController() {

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecD3StackedBar', odecD3StackedBar);

    odecD3StackedBar.inject = ['d3', 'uuid', '$rootScope'];
    function odecD3StackedBar(d3, uuid, $rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/d3/odecD3StackedBar/odecD3StackedBar.html',
            bindToController: true,
            controller: odecD3StackedBarController,
            controllerAs: 'odecD3StackedBar',
            link: link,
            restrict: 'EA',
            scope: {
                odecD3StackedBarOptions: '<',
                odecD3StackedBarKeys: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecD3StackedBar;
            
            var dataset;

            var _uuid = 'chart' + uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));

            var svg;
            

            var optionsListener = scope.$watch('odecD3StackedBar.odecD3StackedBarOptions', function (newData) {
                if (newData) {
                    update();
                } else if (svg) {
                    svg.remove();
                }
            });

            var repaintListener = $rootScope.$on('window.resize', update);

            $rootScope.$on('$destroy', function () { 
                optionsListener(); 
                repaintListener();
            });

            function update() {

                var elementRemove = d3.select('#' + element.attr('id'));
                elementRemove.select('svg').remove('svg');

                var data = vm.odecD3StackedBarOptions;
                var keys = ['television', 'exterior', 'internet', 'radio', 'revistas', 'diarios', 'suplementos', 'cine'];
                var dataColors = _.reduce(data,function(aggr,item){
                    var color = item.colors && item.colors.front;
                    aggr.push(color);
                    return aggr;
                },[]);
                dataset = _.reduce(data,function(aggr,item){
                    aggr[item.id] = item.share;
                    return aggr;
                },{});

                //legend
                vm.legend = _.reduce(data,function(aggr,item){
                    var legendItem = {};
                    if(_.indexOf(keys,item.id)>-1){
                        legendItem.id = item.id;
                        legendItem.name = item.name;
                        legendItem.color = item.colors.front;                    
                        aggr.push(legendItem);
                    }
                    return aggr;
                },[]);

                var w = element.innerWidth(),
                h = element.innerHeight(),
                          
                dataset = [].concat(dataset);
                var colors = d3.scaleOrdinal(dataColors);

                var xScale = d3.scaleLinear()
                    .domain([0, d3.max(dataset, function(d) {
                        var total = 0;
                        for (var i = 0; i < keys.length; i++) {
                            total += d[keys[i]];
                        }
                        return total;
                    })])
                    .range([w, 0]);
                

                var stack = d3.stack()
                    .keys(keys)
                    .order(d3.stackOrderAscending);
                
                var series = stack([].concat(dataset));
                
                var svg = d3.select('.d3-chart-share')
                    .append('svg')
                    .attr('width', w)
                    .attr('height',h*0.2);

                var groups = svg.selectAll('g')
                    .data(series)
                    .enter()
                    .append('g')
                    .style('fill', function(d, i){
                        return colors(i);
                    });
                   

                var rects = groups.selectAll('rect')
                    .data(function(d,i){
                        d[0].index = i;
                        return d;
                    })
                    .enter()
                    .append('rect')
                    .attr('y', 0)
                    .transition()
                    .duration(1000)
                    .delay(function (d, i) {
                        return i * 50;
                    })                 
                    .ease(d3.easeBounce)
                    .attr('x', function(d){
                        return xScale(d[1]);
                    })
                    .attr('width', function(d) {
                        return xScale(d[0]) - xScale(d[1]);
                    })
                    .attr('height', h*0.2);
                

                /** LABELS  */
                var labels = d3.select('.labels')
                    .append('svg')
                    .attr('width', w)
                    .attr('height', h*0.4);

                var labelGroup = labels
                    .append("g")
                    .attr("class","labels-group");


                var labelsText = labelGroup
                    .selectAll(".text-label")
                    .data(series)
                    .enter()
                    .append('text')
                    .attr("class","text-label")
                    .attr('fill', "black")
                    .attr("text-anchor","middle")
                    .attr("font-size",10)
                    .attr("font-weight","700")
                    .text(function(d,i){
                        return d[0][1] - d[0][0] + '%';
                    })
                    .attr('y', (h*0.4)*0.85)
                    .attr('x', function(d){
                        return xScale(d[0][1])+(xScale(d[0][0]) - xScale(d[0][1]))/2;
                    }); 
                
            }
            
        }
    }
    /* @ngInject */
    function odecD3StackedBarController() {

    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('odecD3SexWidget', odecD3SexWidget);

  odecD3SexWidget.$inject = ['d3', '$rootScope', 'uuid','configurationLoaderService','odecD3Service'];

  function odecD3SexWidget(d3, $rootScope, uuid, configurationLoaderService, odecD3Service) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl: 'app/components/d3/odecD3SexWidget/odecD3SexWidget.html',
      bindToController: true,
      controller: odecD3SexWidgetController,
      controllerAs: 'odecD3SexWidget',
      link: link,
      restrict: 'EA',
      scope: {
        data: '<'
      }
    };
    return directive;

    function link(scope, element, attrs) {
      var vm = scope.odecD3SexWidget;

      var _uuid = 'odec-d3-sex-widget';
      element.attr('id', _uuid.replace(/-/g, ''));

      var formatES = d3.formatLocale(odecD3Service.es_ES);
      var formatDecimal = formatES.format(",.1f");


      /*COLORS*/
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').result('sex').value();

      vm.manData = {
        color: colors.man,
        value: null
      };
      
      vm.womanData = {
        color: colors.woman,
        value: null
      };

      var margin = vm.odecD3SexWidget && vm.odecD3SexWidget.options && vm.odecD3SexWidget.options.margin || {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      };

      var vw = element.innerWidth();
      var vh = element.innerHeight();
      var width = vw - margin.left - margin.right;
      var height = vh - margin.top - margin.bottom;
      
      var repaintListener = $rootScope.$on('window.resize', update);

      //Watchers
      var dataWatcher = scope.$watch(function () {
        return vm;
      }, update);

      scope.$on('$destroy', function () {
        repaintListener();
        dataWatcher();
      });

      function update() {
        vm.manData.value = _.find(vm.data, {'id': 'SEX.D1'}) && _.find(vm.data, {'id': 'SEX.D1'}).value;
        vm.womanData.value = _.find(vm.data, {'id': 'SEX.D2'}) && _.find(vm.data, {'id': 'SEX.D2'}).value;
        
        var elementRemove = d3.select('#' + element.attr('id'));
        elementRemove.select('svg').remove();

        var widgetSex = d3.select('#' + element.attr('id'));

        vw = element.innerWidth();
        vh = element.innerHeight();
        width = vw - margin.left - margin.right;
        height = vh - margin.top - margin.bottom;
        var scaleGroup = height < 200 ? 1 : 1.1;
        
        var svg = widgetSex.append("svg")
          .attr('width', width)
          .attr('height', height)
          .attr('viewBox', '0 0 ' + width + ' ' + height)
          .attr('preserveAspectRatio', 'xMinYMin meet')
          .attr('class', "odec-d3-widget-sex");
          


        /** ClipPath Woman */
        createClipPaths();
        var group = svg
          .append('g')
          .attr('class', 'sex-group');
        createWoman();
        createMan();
        group
          .attr('transform', function () {
            var sizeGroup = d3.select(this).node().getBoundingClientRect();
            return 'translate(' + ((width - sizeGroup.width) / 2) + ', ' + (height - sizeGroup.height) / 2 + ")";
          });

        function createClipPaths() {
          var clipPath = svg
            .append('defs');

          var clipPathWoman = clipPath
            .append('clipPath')
            .attr('id', 'clip-path-w');

          var clipPathMan = clipPath
            .append('clipPath')
            .attr('id', 'clip-path-m');

          clipPathWoman
            .append('path')
            .attr('class', 'cls-1 clip-path-woman')
            .attr('d', 'M17.7,0A9,9,0,1,1,8.75,9,8.95,8.95,0,0,1,17.7,0ZM11.49,20.14a3.52,3.52,0,0,0-3.24,2.22L.32,40.82A3.13,3.13,0,0,0,1.73,45a3.08,3.08,0,0,0,4.13-1.4v0l.6-1.22s.19-.33.12,0C6.15,44.65,5,51.49,5,51.49A2.08,2.08,0,0,0,6.51,54a2.11,2.11,0,0,0,.61.06h3.45c.25,0,.2.19.2.19V68a3.17,3.17,0,0,0,2.79,3.49,3,3,0,0,0,.42,0c1.76,0,3.2-1.21,3.2-3.51V54.21a.13.13,0,0,1,.11-.13h.89c.21,0,.11.15.11.15V68c0,2.3,1.43,3.51,3.2,3.51a3.15,3.15,0,0,0,3.19-3.13,1.62,1.62,0,0,0,0-.38V54.3a.22.22,0,0,1,.24-.22h3.72a2.14,2.14,0,0,0,2.22-2,2.06,2.06,0,0,0-.06-.55s-1.19-7.33-1.51-9.33c-.09-.57.86,1.46.86,1.46a2.62,2.62,0,0,0,3.31,1.64,2.43,2.43,0,0,0,.37-.16,3.11,3.11,0,0,0,1.48-4.15l-7.63-18.6c-.44-.94-.83-2.2-2.62-2.2Z');

          clipPathMan
            .append('path')
            .attr('class', 'cls-1 clip-path-man')
            .attr('d', 'M9.91,19.92a3.4,3.4,0,0,0-3.42,2.23L.19,41.38a3.15,3.15,0,0,0,1.81,4,3.08,3.08,0,0,0,4-1.77l0-.06L7.68,39s.12-.46.12,1.54V67.3a4.17,4.17,0,0,0,8.34,0h0V49.85a.13.13,0,0,1,.11-.15h1.59a.14.14,0,0,1,.15.13V67.3a4.17,4.17,0,1,0,8.34,0h0V40.6c0-2,.17-1.39.17-1.39l1.62,4.38a3.1,3.1,0,0,0,4,1.85h0a3.17,3.17,0,0,0,1.81-4L27.63,22.2A3.6,3.6,0,0,0,24.2,20ZM17.13,0A8.89,8.89,0,1,1,8.18,8.89,8.92,8.92,0,0,1,17.13,0Z');

        }

        function createWoman() {
          var groupWoman = group
            .append('g')
            .attr('class', 'group-woman')
            .attr('transform', function () {
              return 'scale('+scaleGroup+')';
            });

          groupWoman
            .append('path')
            .attr('class', 'cls-1 path-woman')
            .attr('d', 'M17.7,0A9,9,0,1,1,8.75,9,8.95,8.95,0,0,1,17.7,0ZM11.49,20.14a3.52,3.52,0,0,0-3.24,2.22L.32,40.82A3.13,3.13,0,0,0,1.73,45a3.08,3.08,0,0,0,4.13-1.4v0l.6-1.22s.19-.33.12,0C6.15,44.65,5,51.49,5,51.49A2.08,2.08,0,0,0,6.51,54a2.11,2.11,0,0,0,.61.06h3.45c.25,0,.2.19.2.19V68a3.17,3.17,0,0,0,2.79,3.49,3,3,0,0,0,.42,0c1.76,0,3.2-1.21,3.2-3.51V54.21a.13.13,0,0,1,.11-.13h.89c.21,0,.11.15.11.15V68c0,2.3,1.43,3.51,3.2,3.51a3.15,3.15,0,0,0,3.19-3.13,1.62,1.62,0,0,0,0-.38V54.3a.22.22,0,0,1,.24-.22h3.72a2.14,2.14,0,0,0,2.22-2,2.06,2.06,0,0,0-.06-.55s-1.19-7.33-1.51-9.33c-.09-.57.86,1.46.86,1.46a2.62,2.62,0,0,0,3.31,1.64,2.43,2.43,0,0,0,.37-.16,3.11,3.11,0,0,0,1.48-4.15l-7.63-18.6c-.44-.94-.83-2.2-2.62-2.2Z');

          groupWoman
            .append('g')
            .attr('class', 'rect-path-w')
            .append('rect')
            .attr('fill', colors.woman)
            .attr('x', '0')
            .attr('y', function () {
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              return size.height;
            })
            .attr('width', function () {
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              return size.width*1.1;
            })
            .attr("opacity", 0)
            .transition()
            .delay(300)
            .duration(1000)
            .attr("opacity", 1)
            .attr('y', function () {
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              return size.height - (vm.womanData.value * size.height / 100);
            })

            .attr('height', function () {
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              return size.height;
              //return vm.womanData.value;
            });

          var textWoman = groupWoman
            .append('text');

          textWoman
            .append('tspan')
            .attr('class', 'value-woman')
            .text(formatDecimal(10))
            .attr('font-size', 23)
            .attr('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .attr('fill', colors.woman)
            .attr('x', function () {
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              return size.width / 2;
            })
            .attr('y', function () {
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              return size.height * 1.3;
            })
            .attr("opacity", 0)
            .transition()
            .duration(1000)
            .attr("opacity", 1)
            .tween("text", function () {
              var number = vm.womanData.value / 100;
              var that = d3.select(this),
                i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
              return function (t) {
                that.text(formatDecimal(i(t)));
              };
            });

          textWoman
            .append('tspan')
            .text('%')
            .attr('font-size', 13)
            .attr('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .attr('fill', colors.woman)
            .attr('x', function () {
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              var valueWoman = d3.select('.value-woman').node().getBoundingClientRect();
              return size.width / 2 + valueWoman.width / 1.7;
            })
            .attr('y', function () {
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              var valueWoman = d3.select('.value-woman').node().getBoundingClientRect();
              return size.height * 1.32 - valueWoman.height / 3;
            })
            .attr("opacity", 0)
            .transition()
            .delay(1100)
            .duration(500)
            .attr("opacity", 1);

          var legendWoman = groupWoman
            .append('g')
            .attr('class', 'legend-woman');

          legendWoman
            .append('circle')
            .attr('r', 3)
            .attr('fill', vm.womanData.color)
            .attr('cx', 0)
            .attr('cy', function(){
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              var valueWoman = d3.select('.value-woman').node().getBoundingClientRect();
              return size.height * 1.75;
            });

          legendWoman
            .append('text')
            .text('MUJER')
            .attr('font-size', 9)
            .attr('font-weight', 'bold')
            .attr('fill', vm.womanData.color)
            .attr('x', 6)
            .attr('y', function(){
              var size = d3.select('.path-woman').node().getBoundingClientRect();
              var valueWoman = d3.select('.value-woman').node().getBoundingClientRect();
              return size.height * 1.75 + 3;
            });
        }

        function createMan() {
          var groupMan = group
            .append('g')
            .attr('class', 'group-man')
            .attr('transform', function () {
              return 'translate(100,0) scale('+scaleGroup+')';
            });

          groupMan
            .append('path')
            .attr('class', 'cls-1 path-man')
            .attr('d', 'M9.91,19.92a3.4,3.4,0,0,0-3.42,2.23L.19,41.38a3.15,3.15,0,0,0,1.81,4,3.08,3.08,0,0,0,4-1.77l0-.06L7.68,39s.12-.46.12,1.54V67.3a4.17,4.17,0,0,0,8.34,0h0V49.85a.13.13,0,0,1,.11-.15h1.59a.14.14,0,0,1,.15.13V67.3a4.17,4.17,0,1,0,8.34,0h0V40.6c0-2,.17-1.39.17-1.39l1.62,4.38a3.1,3.1,0,0,0,4,1.85h0a3.17,3.17,0,0,0,1.81-4L27.63,22.2A3.6,3.6,0,0,0,24.2,20ZM17.13,0A8.89,8.89,0,1,1,8.18,8.89,8.92,8.92,0,0,1,17.13,0Z');

          groupMan
            .append('g')
            .attr('class', 'rect-path-m')
            .append('rect')
            .attr('fill', colors.man)
            .attr('x', '0')
            .attr('y', function () {
              var size = d3.select('.path-man').node().getBoundingClientRect();
              return size.height;
            })
            .attr('width', function () {
              var size = d3.select('.path-man').node().getBoundingClientRect();
              return size.width*1.1;
            })
            .attr("opacity", 0)
            .transition()
            .delay(500)
            .duration(1000)
            .attr("opacity", 1)
            .attr('y', function () {
              var size = d3.select('.path-man').node().getBoundingClientRect();
              return size.height - (vm.manData.value * size.height / 100);
            })

            .attr('height', function () {
              var size = d3.select('.path-man').node().getBoundingClientRect();
              return size.height;
            });

          var textMan = groupMan
            .append('text');

          textMan
            .append('tspan')
            .attr('class', 'value-man')
            .text(formatDecimal(10))
            .attr('font-size', 25)
            .attr('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .attr('fill', colors.man)
            .attr('x', function () {
              var size = d3.select('.path-man').node().getBoundingClientRect();
              return size.width / 2;
            })
            .attr('y', function () {
              var size = d3.select('.path-man').node().getBoundingClientRect();
              return size.height * 1.3;
            })
            .attr("opacity", 0)
            .transition()
            .duration(1000)
            .attr("opacity", 1)
            .tween("text", function () {
              var number = vm.manData.value / 100;
              var that = d3.select(this),
                i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
              return function (t) {
                that.text(formatDecimal(i(t)));
              };
            });

          textMan
            .append('tspan')
            .text('%')
            .attr('font-size', 13)
            .attr('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .attr('fill', colors.man)
            .attr('x', function () {
              var size = d3.select('.path-man').node().getBoundingClientRect();
              var valueWoman = d3.select('.value-man').node().getBoundingClientRect();
              return size.width / 2 + valueWoman.width / 1.7;
            })
            .attr('y', function () {
              var size = d3.select('.path-man').node().getBoundingClientRect();
              var valueWoman = d3.select('.value-man').node().getBoundingClientRect();
              return size.height * 1.32 - valueWoman.height / 3;
            })
            .attr("opacity", 0)
            .transition()
            .delay(1100)
            .duration(500)
            .attr("opacity", 1);

          var legendMan = groupMan
            .append('g')
            .attr('class', 'legend-man');

          legendMan
            .append('circle')
            .attr('r', 3)
            .attr('fill', colors.man)
            .attr('cx', 0)
            .attr('cy', function(d,i){
              var size = d3.select('.path-man').node().getBoundingClientRect();
              var valueWoman = d3.select('.value-man').node().getBoundingClientRect();
              return size.height * 1.75;
            });

          legendMan
            .append('text')
            .text('HOMBRE')
            .attr('font-size', 9)
            .attr('font-weight', 'bold')
            .attr('fill', colors.man)
            .attr('x', 6)
            .attr('y', function(){
              var size = d3.select('.path-man').node().getBoundingClientRect();
              var valueWoman = d3.select('.value-man').node().getBoundingClientRect();
              return size.height * 1.75 + 3;
            });
        }
      }
    }
  }
  /* @ngInject */
  function odecD3SexWidgetController() {

  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecD3Progress', odecD3Progress);

    odecD3Progress.inject = ['d3', 'uuid', '$rootScope', '$state','odecD3Service'];
    function odecD3Progress(d3, uuid, $rootScope, $state, odecD3Service) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/d3/odecD3Progress/odecD3Progress.html',
            bindToController: true,
            controller: odecD3ProgressController,
            controllerAs: 'odecD3Progress',
            link: link,
            restrict: 'EA',
            scope: {
                odecD3ProgressOptions: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecD3Progress.odecD3ProgressOptions;

            var formatES = d3.formatLocale(odecD3Service.es_ES);
            var formatDecimal = formatES.format(",.1f");

            var _uuid = vm.name + uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));

            var svg;

            var optionsListener = scope.$watch('odecD3Progress.odecD3ProgressOptions', function (newData) {
                if (newData) {
                    vm = newData;
                    update();
                } else if (svg) {
                    svg.remove();
                }
            });

            var repaintListener = $rootScope.$on('window.resize', update);

            $rootScope.$on('$destroy', function () { 
                optionsListener(); 
                repaintListener();
            });

            function update() {

                var elementRemove = d3.select('#' + element.attr('id'));
                elementRemove.select('svg').remove('svg');

                var value = parseFloat(vm.value);

                var width = element.innerWidth();
                var height = width;
                
                var duration = 1000;
                var foregroundColor = vm.colors.front;
                var backgroundColor = vm.colors.back;

                var radius = (Math.min(width, height) / 2)*0.8;
                var thickness = radius*0.15;
                var color = d3.scaleOrdinal([foregroundColor, backgroundColor]);

                svg = d3.select('#' + element.attr('id'))
                .append('svg')
                .attr('width', width)
                .attr('height', height)
                .attr("preserveAspectRatio", "xMinYMin meet")
                .attr("viewBox", "0 0 " + width + " " + height)
                .on("mouseover", function() {
                    d3.select(this)
                    .transition()
                    .duration(50)
                    .style("transform", "scale(1.05,1.05)")
                    .style("cursor", 'pointer');
                })
                .on("mouseout", function() {
                    d3.select(this)
                    .transition()
                    .duration(50)
                    .style("transform", "scale(1,1)");
                })
                .on('click', function(d){
                    $state.go('main.'+vm.name);
                  });

                var chart = svg.append('g')
                .attr('transform', 'translate(' + (width/2) + ',' + (height/2) + ')')
                .attr("class", "pie");
                //.attr("filter", "url(#dropshadow)");
                
                
                var arc = d3.arc()
                .innerRadius(radius - thickness)
                .outerRadius(radius)
                .padAngle(0.02);

                var pie = d3.pie()
                .sort(null);

                var path = chart.selectAll('path')
                .data(pie([0, 1]))
                .enter()
                .append('path')
                .attr('d', arc)
                .attr('fill', function(d, i) {
                    return color(i);
                })
                .each(function(d) { this._current = d; });


                path.data(pie([value, 100-value]))
                .transition()
                .duration(duration)
                .attrTween('d', function(d) {
                    var interpolate = d3.interpolate(this._current, d);
                    this._current = interpolate(0);
                    return function(t) {
                        return arc(interpolate(t));
                    };
                });

                var inside = svg.append("g").attr("class", "inside-items")
                .attr('transform', 'translate(' + (width/2) + ',' + (height/2) + ')');

                var number = inside.append('text');

                number
                .append("tspan")
                .attr('text-anchor', 'middle')
                .attr('font-size', radius*0.4)
                .attr('font-weight', 'bolder')
                .attr('dy', radius*0.2)
                .text(0)
                .attr("opacity", 0)
                .transition()
                .delay(500)
                .duration(duration)
                .attr("opacity", 1)
                .tween("text", function () {
                    var number = value / 100;
                    var that = d3.select(this),
                        i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
                        return function (t) {
                        that.text(formatDecimal(i(t)));
                    };
                });
                

                number
                .append("tspan")
                .attr('text-anchor', 'middle')
                .attr('font-size', radius*0.2)
                .attr('font-weight', 'bolder')
                .attr('dy', -radius*0.15 )
                .attr("opacity", 0)
                .transition()
                .delay(500)
                .duration(duration)
                .attr("opacity", 1)
                .text("%");
                

                inside.append('text')
                .attr('text-anchor', 'middle')
                .attr('font-weight', 'bold')
                .attr('font-size', radius*0.15)
                .attr('y', radius*0.5)
                .text(vm.text);

                inside.append("image")
                .attr('x', -radius*0.4/2)
                .attr('y', -radius*0.6)
                .attr('height', radius*0.4)
                .attr('width', radius*0.4)
                .attr("xlink:href", "assets/images/"+vm.name.toUpperCase()+".svg");
                
            }
            
        }
    }
    /* @ngInject */
    function odecD3ProgressController() {

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecD3DonutDoble', odecD3DonutDoble);

    odecD3DonutDoble.inject = ['d3', 'uuid', '$rootScope', '$state', 'odecD3Service', 'configurationLoaderService'];
    function odecD3DonutDoble(d3, uuid, $rootScope, $state, odecD3Service, configurationLoaderService) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/d3/odecD3DonutDoble/odecD3DonutDoble.html',
            bindToController: true,
            controller: odecD3DonutDobleController,
            controllerAs: 'odecD3DonutDoble',
            link: link,
            restrict: 'EA',
            scope: {
                legend: '<',
                inner: '<',
                outer: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecD3DonutDoble;
            var svg;
            var formatES = d3.formatLocale(odecD3Service.es_ES);
            var formatDecimal = formatES.format(",.1f");
            /*COLORS*/
            var colors = _.chain(configurationLoaderService.getConfig()).result('colors').result('general').result('mainSerie').value();
            var colorSerieOuter = _.slice(colors,0,vm.outer.length);
            colorSerieOuter.push('transparent');
            var colorSerieInner = ["#202D4D", "#E9C46A"];
            
            /*Data*/
          
            var color = d3.scaleOrdinal(colorSerieOuter);
            var outerDonutData = vm.outer;
            outerDonutData.push( 100 - _.sum(vm.outer));
            var innerDonutData = vm.inner;
            var legendData = vm.legend;

            /**Animations */
            var interval = 50;
            var delay = 300,
                delayValues = 550;
            var duration = 1000;

            var _uuid = 'chart' + uuid.v4();
            element.attr('id', _uuid.replace(/-/g, ''));

            var dataListener = scope.$watch('odecD3DonutDoble.odecD3DonutDobleData', function (newData) {
                if (newData) {
                    update();
                } else if (svg) {
                    svg.remove();
                }
            });

            var repaintListener = $rootScope.$on('window.resize', update);

            $rootScope.$on('$destroy', function () { 
                dataListener(); 
                repaintListener();
            });

            update();

            function update() {

                /*** If data/options change or window is resized we remove the svg and then repaint it ***/

                var elementRemove = d3.select('#' + element.attr('id'));
                elementRemove.select('svg').remove('svg');
                var width = element.innerWidth();
                var mobileScreen = element.innerWidth() < 400 || element.innerWidth() < element.innerHeight() ? true : false;
                var translateChartX = mobileScreen ? 2.3 : 3;
                var translateChartY = mobileScreen ? 2.9 : 2;
                var translateLegendX = mobileScreen ? 5 : 1.5;
                var translateLegendY = mobileScreen ? 1.5 : 3;
                var height = element.innerHeight();
                var outerDonutRadius = Math.min(width, height) / 2;
                var innerDonutRadius = outerDonutRadius * 0.75;

                /*** Chart options ***/

                var svg = d3.select('#' + element.attr('id'))
                    .append("svg")
                    .attr("width", width)
                    .attr("height", height);

                var groupChart = svg.append("g")
                    .attr("class", "group-chart");

                var chartSlices = groupChart.append("g")
                    .attr("class", "slices");
                var chartLabels = groupChart.append("g")
                    .attr("class", "labels");
                var chartLines = groupChart.append("g")
                    .attr("class", "lines");


                var pie = d3.pie().sort(null).value(function (d) { return d; });
                var arc = d3.arc()
                    .innerRadius(outerDonutRadius * 0.75)
                    .outerRadius(outerDonutRadius * 0.6)
                    .padAngle(0.02);

                var outerArc = d3.arc()
                    .outerRadius(outerDonutRadius * 0.9)
                    .innerRadius(outerDonutRadius * 0.8);

                groupChart.attr("transform", "translate(" + width / translateChartX + "," + height / translateChartY + ")");

                chartSlices.selectAll('path')
                    .data(pie(outerDonutData))
                    .enter()
                    .append('path')
                    .attr('fill', function (d, i) { return color(i); })
                    .transition()
                    .ease(d3.easeBounce)
                    .duration(2000)
                    .attrTween("d", tweenPie)
                    .transition()
                    .ease(d3.easeElastic)
                    .delay(function (d, i) { return 2000 + i * 50; })
                    .duration(2500)
                    .attrTween("d", tweenDonut)
                    .attr("d", arc);

                function tweenPie(b) {
                    b.innerRadius = 0;
                    var i = d3.interpolate({ startAngle: 0, endAngle: 0 }, b);
                    return function (t) { return arc(i(t)); };
                }

                function tweenDonut(b) {
                    b.innerRadius = outerDonutRadius * 0.6;
                    var i = d3.interpolate({ innerRadius: 0 }, b);
                    return function (t) { return arc(i(t)); };
                }

                var polyline = chartLines
                    .selectAll('polyline')
                    .data(pie(outerDonutData))
                    .enter().append('polyline')
                    .attr('points', function (d, i) {
                        if (i !== outerDonutData.length - 1) {
                            var pos = outerArc.centroid(d);
                            pos[0] = (pos[0] + 10) * (midAngle(d) < Math.PI ? 1 : -1);
                            return [arc.centroid(d), outerArc.centroid(d), pos];
                        }
                    });

                var label = chartLabels.selectAll('text')
                    .data(pie(outerDonutData))
                    .enter().append('text')
                    .attr('font-weight', 'bolder')
                    .attr('dy', '.35em')
                    .attr('fill', "black")
                    .text(function (d, i) {
                        if (i !== outerDonutData.length - 1) {
                            return formatDecimal(d.data);
                        }
                    })
                    .attr('transform', function (d) {
                        var pos = outerArc.centroid(d);
                        pos[0] = pos[0] = (pos[0] + 11) * (midAngle(d) < Math.PI ? 1 : -1);
                        return 'translate(' + pos + ')';
                    })
                    .attr('text-anchor', function (d) {
                        return (midAngle(d)) < Math.PI ? 'start' : 'end';
                    });

                label
                    .append("tspan")
                    .attr('text-anchor', 'middle')
                    .attr('font-size', '.6em')
                    .attr('font-weight', 'bolder')
                    .attr('dx', 1)
                    .text(function (d, i) {
                        if (i !== outerDonutData.length - 1) {
                            return "%";
                        }
                    });

                /**Inner Donut */

                var innerDonutArc = d3.arc()
                    .innerRadius(innerDonutRadius * 0.75)
                    .outerRadius(innerDonutRadius * 0.6)
                    .padAngle(0.02);

                var innerDonut = svg.append("g").attr("class", "inner-donut")
                    .attr("transform", "translate(" + width / translateChartX + "," + height / translateChartY + ")");

                var innerDonutSlices = innerDonut.append("g")
                    .attr("class", "slices");

                innerDonutSlices.selectAll('path')
                    .data(pie(innerDonutData))
                    .enter()
                    .append('path')
                    .attr('fill', function (d, i) { return colorSerieInner[i]; })
                    .transition()
                    .ease(d3.easeBounce)
                    .duration(1000)
                    .attrTween("d", tweenInnerDonutPie)
                    .transition()
                    .ease(d3.easeElastic)
                    .delay(function (d, i) { return 2000 + i * 50; })
                    .duration(750)
                    .attrTween("d", tweenInnerDonut)
                    .attr("d", innerDonutArc);

                function tweenInnerDonutPie(b) {
                    b.innerRadius = 0;
                    var i = d3.interpolate({ startAngle: 0, endAngle: 0 }, b);
                    return function (t) { return innerDonutArc(i(t)); };
                }

                function tweenInnerDonut(b) {
                    b.innerRadius = innerDonutRadius * 0.6;
                    var i = d3.interpolate({ innerRadius: 0 }, b);
                    return function (t) { return innerDonutArc(i(t)); };
                }

                /**Inside of the innerDonut */

                var inside = svg.append("g").attr("class", "inside-items")
                    .attr('transform', 'translate(' + width / translateChartX + "," + height / translateChartY + ')');

                var rightItem = inside.append('text')
                    .attr('dx', 25);

                rightItem
                    .append("tspan")
                    .attr('text-anchor', 'start')
                    .attr('font-size', innerDonutRadius * 0.15)
                    .attr('font-weight', 'bolder')
                    .attr('fill', function (d, i) { return colorSerieInner[0]; })
                    .text(0)
                    .attr("opacity", 0)
                    .transition()
                    .delay(500)
                    .duration(1000)
                    .attr("opacity", 1)
                    .tween("text", function () {
                        var number = innerDonutData[0] / 100;
                        var that = d3.select(this),
                            i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
                        return function (t) {
                            that.text(formatDecimal(i(t)));
                        };
                    });

                rightItem
                    .append("tspan")
                    .attr('text-anchor', 'start')
                    .attr('font-size', innerDonutRadius * 0.07)
                    .attr('font-weight', 'bolder')
                    .attr("opacity", 0)
                    .transition()
                    .delay(500)
                    .duration(1000)
                    .attr("opacity", 1)
                    .text("%")
                    .attr('fill', function (d, i) { return colorSerieInner[0]; });

                rightItem
                    .append('tspan')
                    .attr('text-anchor', 'start')
                    .attr('font-weight', 'bold')
                    .attr('font-size', innerDonutRadius * 0.05)
                    .attr('dy', innerDonutRadius / 11)
                    .attr('dx', -innerDonutRadius / 2.6)
                    .attr("opacity", 0)
                    .transition()
                    .delay(1000)
                    .duration(1000)
                    .attr("opacity", 1)
                    .text('ALGUNA VEZ');

                var leftItem = inside.append('text')
                    .attr('dx', -innerDonutRadius * 0.5)
                    .attr('text-anchor', 'start');

                leftItem
                    .append("tspan")
                    .attr('font-size', innerDonutRadius * 0.15)
                    .attr('font-weight', 'bolder')
                    .attr('text-anchor', 'start')
                    .attr('fill', function (d, i) { return colorSerieInner[1]; })
                    .text(0)
                    .attr("opacity", 0)
                    .transition()
                    .delay(500)
                    .duration(1000)
                    .attr("opacity", 1)
                    .tween("text", function () {
                        var number = innerDonutData[1] / 100;
                        var that = d3.select(this),
                            i = d3.interpolateNumber(that.text().replace(/,/g, ""), number * 1e2);
                        return function (t) {
                            that.text(formatDecimal(i(t)));
                        };
                    });

                leftItem
                    .append("tspan")
                    .attr('font-size', innerDonutRadius * 0.07)
                    .attr('font-weight', 'bolder')
                    .attr('text-anchor', 'start')
                    .attr("opacity", 0)
                    .transition()
                    .delay(500)
                    .duration(1000)
                    .attr("opacity", 1)
                    .text("%")
                    .attr('fill', function (d, i) { return colorSerieInner[1]; });

                leftItem
                    .append('tspan')
                    .attr('font-weight', 'bold')
                    .attr('font-size', innerDonutRadius * 0.05)
                    .attr('dy', innerDonutRadius / 11)
                    .attr('dx', -innerDonutRadius / 2.6)
                    .attr("opacity", 0)
                    .transition()
                    .delay(1000)
                    .duration(1000)
                    .attr("opacity", 1)
                    .text('NUNCA O');

                leftItem
                    .append('tspan')
                    .attr('font-weight', 'bold')
                    .attr('font-size', innerDonutRadius * 0.05)
                    .attr('dy', innerDonutRadius / 11)
                    .attr('dx', -innerDonutRadius / 4)
                    .attr("opacity", 0)
                    .transition()
                    .delay(1000)
                    .duration(1000)
                    .attr("opacity", 1)
                    .text('CASI NUNCA');

                //Add legend chart
                
                var legend = svg.append('g')
                    .attr('class', 'legend')
                    .attr("transform", "translate(" + width / translateLegendX + "," + height / translateLegendY + ")");

                var itemLegend = legend
                    .selectAll('.item-legend')
                    .data(legendData)
                    .enter()
                    .append('g');

                itemLegend
                    .append('circle')
                    .attr('fill', function (d, i) {
                        return colorSerieOuter[i];
                    })
                    .attr('r', 3.5)
                    .attr("transform", function (d, i) {
                        return "translate(" + 0 + "," + i * 40 + ")";
                    });


                itemLegend
                    .append('text')
                    .attr('font-size', 12)
                    .attr('class', 'item-legend')
                    .text(function (d) {
                        return d;
                    })
                    .attr("transform", function (d, i) {
                        return "translate(" + 0 + "," + i * 40 + ")";
                    })

                    .attr("dx", 12)
                    .attr("dy", 4);

                itemLegend
                    .attr("opacity", 0)
                    .transition()
                    .delay(function (d, i) {
                        return i * interval + delayValues;
                    })
                    .duration(duration)
                    .attr("opacity", 1);


                function midAngle(d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; }

            }
        }
    }
    /* @ngInject */
    function odecD3DonutDobleController() {

    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('odecD3ColumnThematic', odecD3ColumnThematic);

  odecD3ColumnThematic.$inject = ['d3', '$rootScope', 'uuid', 'odecD3Service', 'configurationLoaderService'];

  function odecD3ColumnThematic(d3, $rootScope, uuid, odecD3Service, configurationLoaderService) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl: 'app/components/d3/odecD3ColumnThematic/odecD3ColumnThematic.html',
      bindToController: true,
      controller: odecD3ColumnController,
      controllerAs: 'odecD3ColumnThematic',
      link: link,
      restrict: 'EA',
      scope: {
        series: '<',
        options: '<'
      }
    };
    return directive;

    function link(scope, element, attrs) {
      var vm = scope.odecD3ColumnThematic;

      var formatES = d3.formatLocale(odecD3Service.es_ES);
      var formatDecimal = formatES.format(",.0f");

      /*COLORS*/
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').result('simple').value();

      /**Animations */
      var interval = 50;
      var delay = 300,
        delayValues = 550;
      var duration = 1000;
      var numRangeGrid = 5;
      

      /***Tooltip */
      var tip = d3.tip()
        .attr("class", "d3-tip d3-tip-column-chart")
        .html(function (data) {
          return '<p>' + data.text + '</p>';
        });

      var _uuid = 'odec-d3-column-' + uuid.v4();
      element.attr('id', _uuid.replace(/-/g, ''));

      var margin = vm.odecD3ColumnThematic && vm.odecD3ColumnThematic.options && vm.odecD3ColumnThematic.options.margin || {
        top: 10,
        left: 30,
        bottom: 5,
        right: 30
      };

      var vw = element.innerWidth();
      var vh = element.innerHeight();
      var width = vw - margin.left - margin.right;
      var height = vh - margin.top - margin.bottom;

      var repaintListener = $rootScope.$on('window.resize', update);

      //Watchers
      var dataWatcher = scope.$watch(function () {
        return vm;
      }, update);

      scope.$on('$destroy', function () {
        repaintListener();
        dataWatcher();
      });

      function update() {

        var elementRemove = d3.select('#' + element.attr('id'));
        elementRemove.select('svg').remove();

        var widgetColumn = d3.select('#' + element.attr('id'));

        vw = element.innerWidth();
        vh = element.innerHeight();
        width = vw - margin.left - margin.right;
        height = vh - margin.top - margin.bottom;
        var heightChart = height * 0.7;        

        var svg = widgetColumn.append("svg")
          .attr('width', width)
          .attr('height', height)
          .attr('viewBox', '0 0 ' + width + ' ' + height)
          .attr('preserveAspectRatio', 'xMinYMin meet')
          .attr('class', "odec-d3-column");

        svg.call(tip);

        // set the ranges
        var x = d3.scaleBand()
          .range([0, width])
          .padding(0.75);
        var y = d3.scaleLinear()
          .range([heightChart * .85, 0]);



        // Scale the range of the data in the domains
        x.domain(vm.series.map(function (d) {
          return d.text;
        }));
        y.domain([0, 1.2*d3.max(vm.series, function (d) {
          return d.value;
        })]);

        // gridlines in y axis function
        function make_y_gridlines() {
          return d3.axisLeft(y)
            .ticks(numRangeGrid);
        }
        // add the Y gridlines
        svg.append("g")
          .attr("class", "grid-line-d3-column")
          .attr('transform', 'translate(' + (margin.left + margin.right) + ',' + (heightChart - heightChart * .85) / 2 + ')')
          .call(make_y_gridlines()
            .tickSize(-width)
            .tickFormat("")
          )
          .attr("opacity", 0)
          .transition()
          .delay(function (d, i) {
            return i * interval + delay;
          })
          .duration(duration)
          .attr("opacity", 1);

        // append the rectangles for the bar chart
        svg.selectAll(".d3-column")
          .data(vm.series)
          .enter()
          .append("rect")
          .attr("class", "d3-column")
          .attr('fill', colors.mainColor)
          .attr("x", function (d) {
            return margin.left + x(d.text);
          })
          .attr("width", x.bandwidth()/3)
          .attr("y", function (d) {
            return -y(d.value);
          })
          .attr('rx', 7)
          .attr('ry', 7)
          .attr("opacity", 0)
          .transition()
          .delay(function (d, i) {
            return i * interval + delay;
          })
          .duration(duration)
          .attr("opacity", 1)
          .attr("y", function (d) {
            return ((heightChart - heightChart * .85) / 2) + y(d.value);
          })
          .attr("height", function (d) {
            return heightChart * .85 - y(d.value);
          });

        // append the text for the bar chart
        svg.selectAll(".d3-column-text")
          .data(vm.series)
          .enter()
          .append("text")
          .attr("class", "d3-column-text")
          .attr('fill', 'black')
          .attr('font-weight','bold')
          .attr("x", function (d) {
            return margin.left + x(d.text) + (x.bandwidth()/3) / 2;
          })
          .attr("y", function (d) {
            return -y(d.value) * 0.95;
          })
          .attr('text-anchor', 'middle')
          .text(0)
          .attr('font-size', 18)
          .attr("opacity", 0)
          .transition()
          .delay(function (d, i) {
            return i * interval + delayValues;
          })
          .duration(duration)
          .attr("opacity", 1)
          .attr("y", function (d) {
            return ((heightChart - heightChart * .85) / 2) + y(d.value) - 7.5;
          })
          .tween("text", function (d) {
            var that = d3.select(this),
              i = d3.interpolateNumber(that.text().replace(/,/g, ""), d.value );
            return function (t) {
              that.text(formatDecimal(i(t)));
            };
          });


        // append the text for the title column
        svg.selectAll(".d3-column-title")
        .data(vm.series)
        .enter()
        .append("text")
        .attr("class", "d3-column-tile")
        .attr('fill', 'black')
        .attr('font-weight','bold')
        .attr("x", function (d) {
          return margin.left + x(d.text) + (x.bandwidth()/3) / 2;
        })
        .attr("y", function (d) {
          return heightChart;
        })
        .attr('text-anchor', 'middle')
        .text(function (d, i) {
          return d.text;
        })
        .attr('font-size', 10)
        .attr("opacity", 0)
        .transition()
        .delay(function (d, i) {
          return i * interval + delayValues;
        })
        .duration(duration)
        .attr("opacity", 1)
        .call(odecD3Service.wrapText, x.bandwidth(), "middle");
        // add the y Axis
        svg
          .append("g")
          .attr('class', "group-d3-column-axis")
          .attr('transform', 'translate(' + (margin.left + margin.right) + ',' + (heightChart - heightChart * .85) / 2 + ')')
          .call(
            d3.axisLeft(y)
            .ticks(numRangeGrid)
          );


        //Add line horizontal chart
        svg.append('line')
          .attr('x1', margin.left + margin.right)
          .attr('x2', width)
          .attr('y1', heightChart + 0.5 - (heightChart - heightChart * .85) / 2)
          .attr('y2', heightChart + 0.5 - (heightChart - heightChart * .85) / 2)
          .attr('stroke', '#C2B2B2')
          .attr('stroke-width', 1);


        svg.attr('transform', function () {
          return 'translate(' + (vw - width) / 2 + ',' + (height - heightChart) / 2 + ')';
        });

      }
    }
  }
  /* @ngInject */
  function odecD3ColumnController() {

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('odecD3Column', odecD3Column);

  odecD3Column.$inject = ['d3', '$rootScope', 'uuid', 'odecD3Service', 'configurationLoaderService'];

  function odecD3Column(d3, $rootScope, uuid, odecD3Service, configurationLoaderService) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl: 'app/components/d3/odecD3Column/odecD3Column.html',
      bindToController: true,
      controller: odecD3ColumnController,
      controllerAs: 'odecD3Column',
      link: link,
      restrict: 'EA',
      scope: {
        series: '<',
        options: '<'
      }
    };
    return directive;

    function link(scope, element, attrs) {
      var vm = scope.odecD3Column;

      var formatES = d3.formatLocale(odecD3Service.es_ES);
      var formatDecimal = formatES.format(",.1f");
      var formatPercent = d3.format(".0%");

      /*COLORS*/
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').result('general').result('mainSerie').value();

      /**Animations */
      var interval = 50;
      var delay = 300,
        delayValues = 550;
      var duration = 1000;

      /***Tooltip */
      var tip = d3.tip()
        .attr("class", "d3-tip d3-tip-column-chart")
        .html(function (data) {
          return '<p>' + data.text + '</p>';
        });

      var _uuid = 'odec-d3-column-' + uuid.v4();
      element.attr('id', _uuid.replace(/-/g, ''));

      var margin = vm.odecD3Column && vm.odecD3Column.options && vm.odecD3Column.options.margin || {
        top: 10,
        left: 20,
        bottom: 5,
        right: 20
      };

      var vw = element.innerWidth();
      var vh = element.innerHeight();
      var width = vw - margin.left - margin.right;
      var height = vh - margin.top - margin.bottom;

      var repaintListener = $rootScope.$on('window.resize', update);

      //Watchers
      var dataWatcher = scope.$watch(function () {
        return vm;
      }, update);

      scope.$on('$destroy', function () {
        repaintListener();
        dataWatcher();
      });

      function update() {
        var elementRemove = d3.select('#' + element.attr('id'));
        elementRemove.select('svg').remove();

        var widgetColumn = d3.select('#' + element.attr('id'));

        vw = element.innerWidth();
        vh = element.innerHeight();
        width = vw - margin.left - margin.right;
        height = vh - margin.top - margin.bottom;
        var heightChart = height * 0.7;

        var colorScale = d3.scaleOrdinal(colors);

        var svg = widgetColumn.append("svg")
          .attr('width', width)
          .attr('height', height)
          .attr('viewBox', '0 0 ' + width + ' ' + height)
          .attr('preserveAspectRatio', 'xMinYMin meet')
          .attr('class', "odec-d3-column");

        //svg.call(tip);

        // set the ranges
        var x = d3.scaleBand()
          .range([0, width])
          .padding(0.75);
        var y = d3.scaleLinear()
          .range([heightChart * 0.85, 0]);



        // Scale the range of the data in the domains
        x.domain(vm.series.map(function (d) {
          return d.text;
        }));
        y.domain([0, d3.max(vm.series, function (d) {
          return 1;
          //return d.value;
        })]);

        // gridlines in y axis function
        function make_y_gridlines() {
          return d3.axisLeft(y)
            .ticks(3);
        }
        // add the Y gridlines
        svg.append("g")
          .attr("class", "grid-line-d3-column")
          .attr('transform', 'translate(' + (margin.left + margin.right) + ',' + (heightChart - heightChart * .85) / 2 + ')')
          .call(make_y_gridlines()
            .tickSize(-width)
            .tickFormat("")
          )
          .attr("opacity", 0)
          .transition()
          .delay(function (d, i) {
            return i * interval + delay;
          })
          .duration(duration)
          .attr("opacity", 1);

        // append the rectangles for the bar chart
        svg.selectAll(".d3-column")
          .data(vm.series)
          .enter()
          .append("rect")
          .attr("class", "d3-column")
          .attr('fill', function (d, i) {
            return colorScale(i);
          })
          .attr("x", function (d) {
            return margin.left + x(d.text);
          })
          .attr("width", x.bandwidth())
          .attr("y", function (d) {
            return -y(d.value);
          })
          .attr('rx', 7)
          .attr('ry', 7)
          .attr("opacity", 0)
          .transition()
          .delay(function (d, i) {
            return i * interval + delay;
          })
          .duration(duration)
          .attr("opacity", 1)
          .attr("y", function (d) {
            return ((heightChart - heightChart * .85) / 2) + y(d.value);
          })
          .attr("height", function (d) {
            return heightChart * .85 - y(d.value);
          });

        // append the text for the bar chart
        svg.selectAll(".d3-column-text")
          .data(vm.series)
          .enter()
          .append("text")
          .attr("class", "d3-column-text")
          .attr('fill', 'black')
          .attr('font-weight','bold')
          .attr("x", function (d) {
            return margin.left + x(d.text) + x.bandwidth() / 2;
          })
          .attr("y", function (d) {
            return -y(d.value) * 0.95;
          })
          .attr('text-anchor', 'middle')
          .text(function (d, i) {
            return formatDecimal(d.value * 100);
          })
          .attr('font-size', 11)
          .attr("opacity", 0)
          .transition()
          .delay(function (d, i) {
            return i * interval + delayValues;
          })
          .duration(duration)
          .attr("opacity", 1)
          .attr("y", function (d) {
            return ((heightChart - heightChart * .85) / 2) + y(d.value) * 0.95;
          });

        // add the y Axis
        svg
          .append("g")
          .attr('class', "group-d3-column-axis")
          .attr('transform', 'translate(' + (margin.left + margin.right) + ',' + (heightChart - heightChart * .85) / 2 + ')')
          .call(
            d3.axisLeft(y)
            .ticks(3)
            .tickFormat(formatPercent)
          );


        //Add line horizontal chart
        svg.append('line')
          .attr('x1', margin.left + margin.right)
          .attr('x2', width)
          .attr('y1', heightChart + 0.5 - (heightChart - heightChart * .85) / 2)
          .attr('y2', heightChart + 0.5 - (heightChart - heightChart * .85) / 2)
          .attr('stroke', '#C2B2B2')
          .attr('stroke-width', 1);



        //Add legend chart
        var numColumns = vm.options && vm.options.numColumnLegend;
        var sizeColLegend = angular.isDefined(numColumns) && numColumns > 0 ? width / numColumns : width / vm.series.length;
        var legend = svg.append('g')
          .attr('class', 'legend');

        var itemLegend = legend
          .selectAll('.item-legend')
          .data(vm.series)
          .enter()
          .append('g');/*
          .on('mouseenter', function (d) {
            return tip.show(d);
          })
          .on('mouseleave', tip.hide);*/

        itemLegend
          .append('circle')
          .attr('fill', function (d, i) {
            return colorScale(i);
          })
          .attr('r', 3.5)
          .attr("transform", function (d, i) {
            if (angular.isDefined(numColumns) && numColumns > 0) {
              var xOff = (i % numColumns) * sizeColLegend;
              var yOff = Math.floor(i / numColumns) * 20;
              return "translate(" + xOff + "," + yOff + ")";
            } else {
              return "translate(" + (i * sizeColLegend) + "," + 0 + ")";
            }
          })

          .attr("cx", 5)
          .attr("cy", function () {
            return angular.isDefined(numColumns) && numColumns > 0 ? heightChart * 1.135 : heightChart * 1.2;
          });



        itemLegend
          .append('text')
          .attr('font-size', 11)
          .attr('class', 'item-legend')
          .text(function (d) {
            return d.text;
          })
          .attr("transform", function (d, i) {
            if (angular.isDefined(numColumns) && numColumns > 0) {
              var xOff = (i % numColumns) * sizeColLegend;
              var yOff = Math.floor(i / numColumns) * 20;
              return "translate(" + xOff + "," + yOff + ")";
            } else {
              return "translate(" + (i * sizeColLegend) + "," + 0 + ")";
            }
          })

          .attr("dx", 12)
          .attr("dy", function () {
            return angular.isDefined(numColumns) && numColumns > 0 ? heightChart * 1.155 : heightChart * 1.22;
          })
          .each(function (d, i) {
            d3.select(this).call(odecD3Service.ellipsis.bind(d3.select(this).node(), sizeColLegend));
          });

        itemLegend
          .attr("opacity", 0)
          .transition()
          .delay(function (d, i) {
            return i * interval + delayValues;
          })
          .duration(duration)
          .attr("opacity", 1);

        svg.attr('transform', function () {
          return 'translate(' + (vw - width) / 2 + ',' + (heightChart - heightChart*0.85) / 2 + ')';
        });

      }
    }
  }
  /* @ngInject */
  function odecD3ColumnController() {

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('odecD3Bar', odecD3Bar);

  odecD3Bar.$inject = ['d3', 'uuid', '$rootScope','configurationLoaderService', 'odecD3Service'];

  function odecD3Bar(d3, uuid, $rootScope,configurationLoaderService, odecD3Service) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl: 'app/components/d3/odecD3Bar/odecD3Bar.html',
      bindToController: true,
      controller: odecD3BarController,
      controllerAs: 'odecD3Bar',
      link: link,
      restrict: 'EA',
      scope: {
        series: '<',
        separe: '<',
        decimal: '<'
      }
    };
    return directive;

    function link(scope, element, attrs) {
      var vm = scope.odecD3Bar;
      var svg, paidSerie, freeSerie, y, yFree, widthLabels, heightAxis, sizeAxis, x, max;

      var formatES = d3.formatLocale(odecD3Service.es_ES);
      var formatDecimal = vm.decimal ? formatES.format(",." + vm.decimal + "f") : formatES.format(",.0f");

      /*COLORS*/
      var colors = _.chain(configurationLoaderService.getConfig()).result('colors').result('simple').value();

      /**Animations */
      var interval = 25;
      var delay = 150, delayRectData=200, delayValues=350;
      var duration = 1000;


      /***Tooltip */
      var tip = d3.tip()
        .attr("class", "d3-tip d3-tip-column-chart")
        .html(function (data) {
          return '<p>' + data.text + '</p>';
        });

      var _uuid = 'odec-d3-column-' + uuid.v4();
      element.attr('id', _uuid.replace(/-/g, ''));
      


      var margin = vm.odecD3Column && vm.odecD3Column.options && vm.odecD3Column.options.margin || {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      };

      var vw = element.innerWidth();
      var vh = element.innerHeight();
      var width = vw - margin.left - margin.right;
      var height = vh - margin.top - margin.bottom;

      var repaintListener = $rootScope.$on('window.resize', update);

      //Watchers
      var dataWatcher = scope.$watch(function () {
        return vm;
      }, update);

      scope.$on('$destroy', function () {
        repaintListener();
        dataWatcher();
      });

      function update() {
        //vm.series = vm.series.sort(function(a, b) { return a.value - b.value; });
       
        var elementRemove = d3.select('#' + element.attr('id'));
        elementRemove.select('svg').remove();

        var widgetBar = d3.select('#' + element.attr('id'));

        vw = element.innerWidth();
        vh = element.innerHeight();
        width = vw - margin.left - margin.right;
        height = vh - margin.top - margin.bottom;
        max = _.chain(vm.series).map('value').max().value();

        svg = widgetBar.append("svg")
          .attr('width', width)
          .attr('height', height)
          .attr('viewBox', '0 0 ' + width + ' ' + height)
          .attr('preserveAspectRatio', 'xMinYMin meet')
          .attr('class', "odec-d3-bar");

        svg.call(tip);

        widthLabels = width * 0.29;
        heightAxis = 20;

        x = d3.scaleLinear().range([0, width * 0.7]);
        x.domain([0, 1.2*d3.max(vm.series, function (d) { return d.value; })]);
        
        var axisTopScale = d3.scaleLinear().range([0, width * 0.7/1.2]);
        axisTopScale.domain([0, d3.max(vm.series, function (d) { return d.value; })]);


        var groupAxis = svg.append("g").attr('class', 'axis-top');
        groupAxis.attr("transform", "translate(" + widthLabels + "," + heightAxis + ")")
          .call(
            d3.axisBottom(axisTopScale)
            .ticks(5)
          );

        d3.selectAll('.axis-top text').attr('transform','translate(0,'+(-heightAxis)+')'); 
        
        sizeAxis = d3.select('.axis-top').node().getBBox();

        paidSerie = angular.copy(vm.series);
        var separeFactor = vm.separe ? 0.8 : 1;
        y = d3.scaleBand().range([0, height*separeFactor - heightAxis - sizeAxis.height]);
        y.domain(paidSerie.map(function (d) { return d.text; })).padding(0.5);
        

        if(vm.separe){
          paidSerie = _.filter(vm.series, {free:false});
          y.domain(paidSerie.map(function (d) { return d.text; })).padding(0.5);
          freeSerie = _.filter(vm.series, {free:true});
          yFree = d3.scaleBand().range([20 + height*separeFactor, 20 + height*separeFactor + freeSerie.length*y.bandwidth()*2.2]);
          yFree.domain(freeSerie.map(function (d) { return d.text; })).padding(0.5);

          svg.append("g")
          .attr("class", "y-free-axis-d3-bar-chart")
          .call(d3.axisLeft(yFree))
          .attr("transform", "translate(" + widthLabels * 0.99 + ",0)");
        }

        svg.append("g")
          .attr("class", "y-axis-d3-bar-chart")
          .call(d3.axisLeft(y))
          .attr("transform", "translate(" + widthLabels * 0.99 + "," + (heightAxis + sizeAxis.height) + ")");

        d3
        .selectAll('.y-axis-d3-bar-chart text')
        .each(function (d, i) {
          d3.select(this).call(odecD3Service.ellipsis.bind(d3.select(this).node(), widthLabels));
          if(d.substr(0,1) === '.' && d.substr(0,2) !== '..') {
            d3.select(this).attr('font-weight', 'bold');
          }
        });


        //PAID NP CHART
        defaultSerie();

        //FREE NP CHART
        if (vm.separe) {
          separeSerie();
        }
      }

      function defaultSerie() {
        var groupChartRectsBack = svg.append('g').attr('class', 'group-chart-rects');
        // append the rectangles for the bar chart background
        groupChartRectsBack.selectAll(".bar-back")
          .data(paidSerie)
          .enter().append("rect")
          .attr("class", "bar-back")
          .attr("x", widthLabels * 1.01)
          .attr("height", y.bandwidth())
          .attr("y", function (d) { return (heightAxis + sizeAxis.height) + y(d.text); })
          .attr("fill", colors.backgroundColor)
          .attr('rx',7)
          .attr('ry',7)
          .attr("opacity", 0)
          .transition()
          .delay(function(d,i){
            return i*interval+delay;
          })
          .duration(duration)
          .attr("opacity", 1)
          .attr("width", function (d) { return x(max); })
          .attr("y", function (d) { return (heightAxis + sizeAxis.height) + y(d.text); });

        var groupChartRectsData = svg.append('g').attr('class', 'group-chart-rects');
        // append the rectangles for the bar chart background
        groupChartRectsData.selectAll(".bar")
          .data(paidSerie)
          .enter().append("rect")
          .attr("class", "bar")
          .attr("x", widthLabels)
          .attr("y", function (d) { return (heightAxis + sizeAxis.height) + y(d.text); })
          .attr("height", y.bandwidth())
          .attr("fill", function (d) { 
            if(d.text.substr(0,1) === '.' && d.text.substr(0,2) !== '..') {
              return '#F9B229';
            }
            else {return colors.mainColor;}
          })
          .attr('rx',7)
          .attr('ry',7)
          .attr("opacity", 0)
          .transition()
          .delay(function(d,i){
            return i*interval+delayRectData;
          })
          .duration(duration)
          .attr("opacity", 1)
          .attr("width", function (d) { return x(d.value); });

        // append the rectangles for the bar chart background
        groupChartRectsData.selectAll(".text-label")
        .data(paidSerie)
        .enter().append("text")
        .attr('font-size',9)
        .attr('font-weight','bold')
        .attr("class", "text-label")
        .attr("x", function(d,i){
          return widthLabels + x(max)*1.05;
        })
        .text(0)
        .attr("opacity", 0)
          .transition()
          .delay(function(d,i){
            return i*interval+delayValues;
          })
          .duration(duration)
          .attr("opacity", 1)
        .each(function(){
          var textSize = d3.select(this).node().getBBox();
          d3.select(this).attr("y", function (d) { return (heightAxis + sizeAxis.height) + y(d.text)+ (y.bandwidth() + textSize.height/2)/2; });
        })
        .tween("text", function (d) {
          var that = d3.select(this),
            i = d3.interpolateNumber(that.text().replace(/,/g, ""), d.value );
          return function (t) {
            that.text(formatDecimal(i(t)));
          };
        });
      }

      function separeSerie() {
        var groupChartRectsBackFree = svg.append('g').attr('class', 'group-chart-rects');
        // append the rectangles for the bar chart background
        groupChartRectsBackFree.selectAll(".bar-back")
          .data(freeSerie)
          .enter().append("rect")
          .attr("class", "bar-back")
          .attr("x", widthLabels * 1.01)
          .attr("height", y.bandwidth())
          .attr("y", function (d) { return (heightAxis) + yFree(d.text); })
          .attr("fill", colors.backgroundColor)
          .attr('rx',7)
          .attr('ry',7)
          .attr("opacity", 0)
          .transition()
          .delay(function(d,i){
            return i*interval+delay;
          })
          .duration(duration)
          .attr("opacity", 1)
          .attr("width", function (d) { return x(max); })
          .attr("y", function (d) { return yFree(d.text); });


        var groupChartRectsDataFree = svg.append('g').attr('class', 'group-chart-rects');
        // append the rectangles for the bar chart background
        groupChartRectsDataFree.selectAll(".bar")
          .data(freeSerie)
          .enter().append("rect")
          .attr("class", "bar")
          .attr("x", widthLabels)
          .attr("y", function (d) { return yFree(d.text); })
          .attr("height", y.bandwidth())
          .attr("fill", '#F9B229')
          .attr('rx',7)
          .attr('ry',7)
          .attr("opacity", 0)
          .transition()
          .delay(function(d,i){
            return i*interval+delayRectData;
          })
          .duration(duration)
          .attr("opacity", 1)
          .attr("width", function (d) { return x(d.value); });

        // append the rectangles for the bar chart background
        groupChartRectsDataFree.selectAll(".text-label")
        .data(freeSerie)
        .enter().append("text")
        .attr('font-size',9)
        .attr('font-weight','bold')
        .attr("class", "text-label")
        .attr("x", function(d,i){
          return widthLabels + x(max)*1.05;
        })
        .text(0)
        .attr("opacity", 0)
          .transition()
          .delay(function(d,i){
            return i*interval+delayValues;
          })
          .duration(duration)
          .attr("opacity", 1)
        .each(function(){
          var textSize = d3.select(this).node().getBBox();
          d3.select(this).attr("y", function (d) { return yFree(d.text)+ (y.bandwidth() + textSize.height/2)/2; });
        })
        .tween("text", function (d) {
          var that = d3.select(this),
            i = d3.interpolateNumber(that.text().replace(/,/g, ""), d.value );
          return function (t) {
            that.text(formatDecimal(i(t)));
          };
        });
      }
    }
  }
  /* @ngInject */
  function odecD3BarController() {

  }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecWidgetRenderer', odecWidgetRenderer);

    odecWidgetRenderer.$inject = ['$compile'];
    function odecWidgetRenderer($compile) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecWidgetRendererController,
            controllerAs: 'odecWidgetRenderer',
            compile:compile,
            restrict: 'EA',
            scope: {
                config:'<'
            }
        };
        return directive;

        function compile(el,at) {
            return link;
        }
        
        function link(scope, element, attrs) {
            var vm = scope.odecWidgetRenderer;
            function render() {
                var tmpl = '<' + vm.config.type + ' config="odecWidgetRenderer.config">' +'</' + vm.config.type + '>';
                element.replaceWith($compile(tmpl)(scope));
            }

            render();

        }
    }
    /* @ngInject */
    function odecWidgetRendererController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecWaveSelector', odecWaveSelector);

    /** @ngInject */
    function odecWaveSelector() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            templateUrl: 'app/components/odecWaveSelector/odecWaveSelector.html',
            controller: odecWaveSelectorController,
            controllerAs: 'waveSelector',
            link: link,
            restrict: 'EA',
            scope: {   
                odecStationSelected: '<',
                odecProgramSelected: '<',
                odecWavesData: '<',
                odecLoading: '<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    
    /** @ngInject */
    function odecWaveSelectorController ($scope) {
        var vm = this;
        var selectedWave;
        var denyEmitFirsTime = true;

        var slyConfig = {
            horizontal: 1,
            itemNav: 'forceCentered',
            activateMiddle: false,
            smart: 1,
            mouseDragging: 1,
            touchDragging: 1,
            activateOn: 'click',
            startAt: 0,
            scrollBy: 1,
            speed: 300,
            elasticBounds: 1,
            easing: 'swing' // easeInOutElastic
        };

        vm.sly = {
            config: slyConfig,
            callback: callback,
            showPrevButton: true,
            showNextButton: true
        };

        function callback(){
            return {
                //On wave change
                active: function(event, index){
                    selectedWave = vm.odecWavesData[index];
                    if(!denyEmitFirsTime){ emitWaveChange(selectedWave); }
                    else { denyEmitFirsTime = false; }
                },
                change: function (eventName){
                    if(_.first(this.pages) === this.pos.dest){
                        vm.sly.showPrevButton = false;
                    } else if(!vm.sly.showPrevButton) {
                        vm.sly.showPrevButton = true;
                    }
                    
                    if(_.last(this.pages) === this.pos.dest){
                        vm.sly.showNextButton = false;
                    } else if(!vm.sly.showNextButton) {
                        vm.sly.showNextButton = true;
                    }

                    $scope.$apply();
                }
            };
        }

        function emitWaveChange(selectedWave){
            $scope.$emit('waveSelector:change', selectedWave);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecViewDataLoader', odecViewDataLoader);

    //odecViewDataLoader.$inject = ['dependency1'];
    function odecViewDataLoader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecViewDataLoader/odecViewDataLoader.html',
            bindToController: true,
            controller: odevViewDataLoaderController,
            controllerAs: 'odecViewDataLoader',
            link: link,
            restrict: 'EA',
            scope: {
                odecViewDataLoaderLoading:'='
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odevViewDataLoaderController () {
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLoginValidation', odecLoginValidation);

    /* @ngInject */
    function odecLoginValidation($q, $http, loginService) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            require: 'ngModel',
            link: link
        };
        return directive;
        
        function link(scope, element, attrs, ctrl) {

            //Defer object
            var def;
            //Original login (in case we are editing)
            var originalLogin = attrs.userOriginalLogin;
            //Login value
            var value;
            ctrl.$asyncValidators.loginValidation = function (modelValue, viewValue) {

                if (ctrl.$isEmpty(modelValue)) {
                    //Consider empty model valid
                    return $q.when();
                }

                //Login
                value = modelValue || viewValue;

                def = $q.defer();
                $http({
                    method:'GET',
                    url:'./api/users/user/check',
                    params: {
                        token: loginService.getToken(),
                        tipo: 'LOGIN',
                        value: modelValue || viewValue,
                        projectCode: loginService.getUser().userListExternalProjectName
                    }
                })
                .then(processData)
                .catch(reject);

                return def.promise;
            };
            
            function processData(data){
                if(data.data && originalLogin !== value){
                   reject();
                }
                else {
                    // The login is available
                    def.resolve();
                }
            }

            function reject(){
                //Login not available
                def.reject();
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecTransitionPage', odecTransitionPage);

    /* @ngInject */
    function odecTransitionPage($rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecTransitionPage/odecTransitionPage.html',
            bindToController: true,
            controller: odecTransitionPageController,
            controllerAs: 'odecTransitionPage',
            link: link,
            restrict: 'EA',
            replace:true,
            scope: {
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecTransitionPageController ($rootScope,$scope) {
        var vm = this,
            startWatcher,
            endWatcher;


        vm.loading = true;

        /** watchers */
        startWatcher = $rootScope.$on('transition:start',function() {toggleLoading(true);});
        endWatcher = $rootScope.$on('transition:end',function() {toggleLoading(false);});

        $scope.$on('$destroy',function() {
            startWatcher();
            endWatcher();
        });


        /** private methods */
        function toggleLoading(value) {
            vm.loading = value;
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecToggle', odecToggle);

    //odecToggle.$inject = ['dependency1'];
    function odecToggle() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecToggle/odecToggle.html',
            bindToController: true,
            controller: odecToggleController,
            controllerAs: 'odecToggle',
            link: link,
            restrict: 'EA',
            scope: {
                odecToggleActive:'=',
                odecToggleOnChange:'<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecToggleController () {
        var vm = this;

        vm.onClick = onClick;

        function onClick() {
            vm.odecToggleActive = !vm.odecToggleActive;
            vm.odecToggleOnChange.fn.apply(null,[vm.odecToggleActive].concat(vm.odecToggleOnChange.args));
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSvgSwitch', odecSvgSwitch);

    odecSvgSwitch.inject = ['d3', 'uuid', '$rootScope'];
    function odecSvgSwitch(d3, uuid, $rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecSvgSwitch/odecSvgSwitch.html',
            bindToController: true,
            controller: odecSvgSwitchController,
            controllerAs: 'odecSvgSwitch',
            link: link,
            restrict: 'EA',
            scope: {
                odecSvgSwitchName: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecSvgSwitch;
        }
    }
    /* @ngInject */
    function odecSvgSwitchController() {
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecStationSelector', odecStationSelector);

    /** @ngInject */
    function odecStationSelector() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            templateUrl: 'app/components/odecStationSelector/odecStationSelector.html',
            controller: odecStationSelectorController,
            controllerAs: 'stationSelector',
            link: link,
            restrict: 'EA',
            scope: {
                stationSelectorStations:'<',
                stationSelectorSelected:'<',
                stationSelectorLoading: '<'       
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.stationSelector;
            vm.menu.stationsData = vm.stationSelectorStations;
            vm.menu.selected = vm.menu.selectItem(vm.stationSelectorSelected,false);
        }
    }
    
    /** @ngInject */
    function odecStationSelectorController (configurationLoaderService, $scope) {
        var vm = this;

        vm.menu = {
            toggle: toggle,
            opened: false,
            selectItem: selectItem,
            stationsData: [],
            selected: null
        };

        function toggle(){
            if(!vm.stationSelectorLoading){ 
                vm.menu.opened = !vm.menu.opened; 
            }
        }

        function selectItem(station,doToggle){
            //New selection
            vm.menu.selected = station;

            //Emit the new selection
            $scope.$emit('stationSelector:change', { station: station });
            vm.stationSelectorSelected = station;            

            if (doToggle) {
                toggle();
            }

            return station;
        }

        /*$rootScope.$on('stationSelector:change', function(evnt, args){
            console.log(args.station);
        });*/
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecStarRenderer', odecStarRenderer);

    //odecStarRenderer.$inject = ['dependency1'];
    function odecStarRenderer() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecStarRenderer/odecStarRenderer.html',
            bindToController: true,
            controller: odecStarRendererController,
            controllerAs: 'odecStarRenderer',
            link: link,
            restrict: 'EA',
            scope: {
                odecStarRendererValue:'<',
                odecStarRendererOutof:'<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecStarRenderer;
            
            vm.full = 0;
            vm.partial = 0;
            vm.empty = 0;
            
            var noDecimals,
                decimals,
                value,
                outOf,
                dataChangeWatcher;
            
            // roundig criteria
            // limit values for each range -> full | partial | empty
            var ROUND_UMBRAL_FLOOR = 0.25,ROUND_UMBRAL_HALF = 0.75;

            // we need the watcher cause we have a method init that only runs once, so if we want it
            // to run everytime the input changes we need the watch to invoke it. In case we didn't have
            // this init and all variables in html were direct from input we wouldn't need this
            dataChangeWatcher = scope.$watch(function(){return vm.odecStarRendererValue;},function(newValue) {
                if (newValue) {
                    init();
                }
            });

            scope.$on('$destroy',function(){
                dataChangeWatcher();
            });

            // private methods

            function init() {
                // generamos los numeros
                value = parseFloat(vm.odecStarRendererValue);
                outOf = parseFloat(vm.odecStarRendererOutof);

                if (isNaN(value)) { throw 'odecStarRenderer -> value is not a number';}
                if (isNaN(outOf)) { throw 'odecStarRenderer -> max. stars (outOf) is not a number';}

                if (value > outOf) {
                    throw 'odecStarRenderer -> Not a valid value value cannot be higher than limit';
                }

                // get not decimal part
                noDecimals = Math.floor(value);

                // javscript has problems with decimals and 0.2 -> 0.20000000018!!
                // fix it to have only 2 decimals
                decimals = (value % 1).toFixed(2);

                // create 3 vars we need, number of stars full, partial and empty,
                // dependind on the rounding criteria
                vm.full = noDecimals;
                if (decimals >= ROUND_UMBRAL_HALF) {
                    vm.full += 1;
                } else if (decimals < ROUND_UMBRAL_HALF && decimals >= ROUND_UMBRAL_FLOOR) {
                    vm.partial = 1;                
                }

                vm.empty = outOf - vm.full - vm.partial;
            } 

        }
    }
    /* @ngInject */
    function odecStarRendererController () {
        var vm = this;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSnapshotButton', odecSnapshotButton);

    odecSnapshotButton.$inject = ['$rootScope','$filter'];
    function odecSnapshotButton($rootScope,$filter) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecSnapshotButton/odecSnapshotButton.html',
            bindToController: true,
            controller: odecSnapshotButtonController,
            controllerAs: 'odecSnapshotButton',
            link: link,
            restrict: 'EA',
            scope: {
                odecSnapshotButtonTargetId:'<',
                odecSnapshotButtonTargetOptions:'<'
            }
        };
        return directive;

        function link(scope, element, attrs) {

            var vm = scope.odecSnapshotButton;

            vm.createSnapshot = createSnapshot;

            function createSnapshot() {

                $rootScope.$emit('snapshot:snapIt',{
                    html:$filter('htmlToString')(angular.element('#'+vm.odecSnapshotButtonTargetId).get(0)),
                    model:vm.odecSnapshotButtonTargetOptions
                });
            }
        }
    }
    /* @ngInject */
    function odecSnapshotButtonController() {
        var vm = this;
        vm.snapshotActive = false;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSelectionPills', odecSelectionPills);

    //odecSelectionPills.$inject = ['dependency1'];
    function odecSelectionPills() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecSelectionPills/odecSelectionPills.html',
            bindToController: true,
            controller: odecSelectionPillsController,
            controllerAs: 'odecSelectionPills',
            link: link,
            restrict: 'EA',
            scope: {
                odecSelectionPillsCollection: '<',
                odecSelectionPillsOnSelection: '&'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecSelectionPills,
                preselectFirst = true;

            // if we want to set as selected the first item...
            if (preselectFirst) {
                vm.onSelection(vm.odecSelectionPillsCollection[0]);
            }            
        }
    }
    /* @ngInject */
    function odecSelectionPillsController() {
        var vm = this;

        vm.onSelection = onSelection;

        // private methods
        function onSelection(item) {
            // remove all selected items
            vm.odecSelectionPillsCollection = removeAllSelected(vm.odecSelectionPillsCollection);

            // find id and set it selected
            var objSelected = _.find(vm.odecSelectionPillsCollection, { id: item.id });

            if (objSelected) {
                objSelected.isSelected = true;
                vm.odecSelectionPillsOnSelection({ selection: getSelectedIds(vm.odecSelectionPillsCollection) });
            }
        }

        function removeAllSelected(collection) {
            var selected = _.filter(collection, { isSelected: true });

            _.each(selected, function (item) { item.isSelected = false; });

            return collection;
        }

        function getSelectedIds(collection) {
            return _.chain(collection)
                .filter({ isSelected: true })
                .map('id')
                .value();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecSelect2', odecSelect2);

    /** @ngInject */
    function odecSelect2($rootScope) {
        var directive = {
            templateUrl: 'app/components/odecSelect2/odecSelect2.html',
            restrict: 'EA',
            replace:true,
            scope: {
                odecSelect2Data: '=',
                odecSelect2Event:'<',
                odecSelect2Selection: '=',
                odecSelect2Raw: '@',
                odecSelect2Placeholder: '@',
                odecSelect2ConfigExtra: '@',
                odecSelect2AllowClear: '=',
                odecSelect2Disabled: '<'
            },            
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el) {
            var select2Component,
                eventName = scope.odecSelect2Event? 'select2:' + scope.odecSelect2Event: 'select2',
                options;

            /** private methods */
            function init(newData,oldData) {
                angular.element(el).html('');

                options = {                    
                    placeholder: scope.odecSelect2Placeholder || '...',
                    data: newData || [],
                    allowClear: scope.odecSelect2AllowClear
                };

                scope.odecSelect2Selection = scope.odecSelect2Selection || null;

                if (scope.odecSelect2Raw) {
                    initRaw();
                } else {
                    initWithData();
                }
            }

            function initWithData() {
                options.disabled=scope.odecSelect2Disabled;
                select2Component = angular.element(el).select2(options);
                select2Component.val(scope.odecSelect2Selection).trigger('change');
            }

            function initRaw() {
                select2Component = angular.element(el).select2(options);
                select2Component.val(scope.odecSelect2Selection).trigger('change');            
            }

            /** events */
            angular.element(el).on('select2:select',function(event){
                $rootScope.$emit(eventName,angular.extend(event.params.data,{events:{selecting:true}}));
            });

            angular.element(el).on('select2:unselect',function(event){
                $rootScope.$emit(eventName,angular.extend(event.params.data,{events:{removing:true}}));
            });
            

            /** listeners */
            
            var collectionWatcher = scope.$watch('odecSelect2Data', init);
            var selectionWatcher = scope.$watch('odecSelect2Selection',function(newValue,oldValue){
                if (newValue) {
                    //select2Component.val(newValue);
                    select2Component.val(newValue).trigger('change');
                } 
                
            });
            var disabledWatcher = scope.$watch('odecSelect2Disabled',function(newValue,oldValue) {
                select2Component.prop('disabled', newValue);
            });
            
            scope.$on('$destroy', function () {
                collectionWatcher();
                selectionWatcher();
                disabledWatcher();
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecScrollable', odecScrollable);

    /** @ngInject */
    function odecScrollable($timeout,$document) {
        var directive = {
            restrict: 'EA',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr) {
            var isMobile = mobileDetection();

            var transitionEvent = whichTransitionEvent();

            // param options passed to niceScroll
            var opciones = {};

            // width of bar
            opciones.width = attr.odecScrollableWidth || 7;

            // color of bar
            opciones.color = attr.odecScrollableColor || '#cecece';

            // align
            opciones.railalign = attr.odecScrollableRailalign || 'right';

            // time to wait before repaint, else sometimes on hide/show does not paint well
            opciones.waitAnimation = attr.odecScrollableWaitanimation || 300;

            // autohide param
            if (attr.odecScrollableAutohide === 'true') {
                opciones.autohide = true;
            } else if (attr.odecScrollableAutohide === 'false') {
                opciones.autohide = false;
            } else if (attr.odecScrollableAutohide) {
                opciones.autohide = attr.odecScrollableAutohide;
            } else {
                opciones.autohide = false;
            }


            // in case odecScrollableShow undefined create it else wait til it changes
            if (!attr.odecScrollableShow) {
                create();
            }

            /** private methods */

            // initialization
            function create() {
                if (isMobile.any) {
                    angular.element(el).css('overflow-y', 'scroll');
                    return;
                }

                if (angular.element(el).getNiceScroll().length !== 0) {
                    // if already exists repaint
                    resize();
                } else {
                    // if not already exists call pluggin 
                    angular.element(el).niceScroll({
                        autohidemode: opciones.autohide,
                        styler: 'fb',
                        cursorcolor: opciones.color,
                        cursorwidth: opciones.width,
                        cursorborderradius: '0px',
                        background: 'rgb(118,122,125)',
                        spacebarenabled: false,
                        cursorborder: '0',
                        railalign: opciones.railalign
                    });

                    resize();

                    // resize it just in case there's any animation
                    /*$timeout(function () {
                        angular.element(el).getNiceScroll().resize();
                    }, opciones.waitAnimation);*/
                }
            }

            // on destroy
            function destroy() {
                // clean it. wait in case there's any animation
                $timeout(function () {
                    angular.element(el).getNiceScroll().remove();
                    angular.element(el).attr('style', '');
                }, opciones.waitAnimation);
            }

            function whichTransitionEvent() {
                var t,
                    el = $document[0].createElement("fakeelement");

                var transitions = {
                    "transition": "transitionend",
                    "OTransition": "oTransitionEnd",
                    "MozTransition": "transitionend",
                    "WebkitTransition": "webkitTransitionEnd"
                };

                for (t in transitions) {
                    if (angular.isDefined(el.style[t])) {
                        return transitions[t];
                    }
                }
            }

            function resize() {
                return el.one(transitionEvent,function() {
                    angular.element(el).getNiceScroll().resize();
                });
            }

            /** listeners */

            // on show/hide change
            attr.$observe('odecScrollableShow', function (newValue) {
                if (newValue === 'false') {
                    // if hidding and already exists destroy it
                    if (angular.element(el).getNiceScroll().length !== 0) {
                        destroy();
                    }
                }

                // if showing initialize
                if (newValue === 'true') {
                    create();
                }
            });

            // on destroy
            scope.$on('$destroy', function () {
                destroy();
            });
        }

        function mobileDetection() {

            var mobileDetection,
                apple_phone = /iPhone/i,
                apple_ipod = /iPod/i,
                apple_tablet = /iPad/i,
                android_phone = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
                android_tablet = /Android/i,
                amazon_phone = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
                amazon_tablet = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
                windows_phone = /IEMobile/i,
                windows_tablet = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
                other_blackberry = /BlackBerry/i,
                other_blackberry_10 = /BB10/i,
                other_opera = /Opera Mini/i,
                other_chrome = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
                other_firefox = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
                seven_inch = new RegExp(
                    '(?:' + // Non-capturing group

                    'Nexus 7' + // Nexus 7

                    '|' + // OR

                    'BNTV250' + // B&N Nook Tablet 7 inch

                    '|' + // OR

                    'Kindle Fire' + // Kindle Fire

                    '|' + // OR

                    'Silk' + // Kindle Fire, Silk Accelerated

                    '|' + // OR

                    'GT-P1000' + // Galaxy Tab 7 inch

                    ')', // End non-capturing group

                    'i'); // Case-insensitive matching

            var match = function (regex, userAgent) {
                return regex.test(userAgent);
            };

            var IsMobileClass = function (userAgent) {
                var ua = userAgent || navigator.userAgent;

                // Facebook mobile app's integrated browser adds a bunch of strings that
                // match everything. Strip it out if it exists.
                var tmp = ua.split('[FBAN');
                if (typeof tmp[1] !== 'undefined') {
                    ua = tmp[0];
                }

                // Twitter mobile app's integrated browser on iPad adds a "Twitter for
                // iPhone" string. Same probable happens on other tablet platforms.
                // This will confuse detection so strip it out if it exists.
                tmp = ua.split('Twitter');
                if (typeof tmp[1] !== 'undefined') {
                    ua = tmp[0];
                }

                this.apple = {
                    phone: match(apple_phone, ua),
                    ipod: match(apple_ipod, ua),
                    tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
                    device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
                };
                this.amazon = {
                    phone: match(amazon_phone, ua),
                    tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
                    device: match(amazon_phone, ua) || match(amazon_tablet, ua)
                };
                this.android = {
                    phone: match(amazon_phone, ua) || match(android_phone, ua),
                    tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
                    device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
                };
                this.windows = {
                    phone: match(windows_phone, ua),
                    tablet: match(windows_tablet, ua),
                    device: match(windows_phone, ua) || match(windows_tablet, ua)
                };
                this.other = {
                    blackberry: match(other_blackberry, ua),
                    blackberry10: match(other_blackberry_10, ua),
                    opera: match(other_opera, ua),
                    firefox: match(other_firefox, ua),
                    chrome: match(other_chrome, ua),
                    device: match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
                };
                this.seven_inch = match(seven_inch, ua);
                this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

                // excludes 'other' devices and ipods, targeting touchscreen phones
                this.phone = this.apple.phone || this.android.phone || this.windows.phone;

                // excludes 7 inch devices, classifying as phone or tablet is left to the user
                this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

                if (typeof window === 'undefined') {
                    return this;
                }
            };

            var instantiate = function () {
                var IM = new IsMobileClass();
                IM.Class = IsMobileClass;
                return IM;
            };

            mobileDetection = instantiate();
            return mobileDetection;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecRenderer', odecRenderer);

    /* @ngInject */
    function odecRenderer($compile) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controllerAs: 'odecRenderer',
            link: link,
            restrict: 'A',
            controller:odecRendererController,
            scope: {
                odecRendererConfig:'=',
                odecRendererDisabled:'<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecRenderer,
                htmlTemplate;
            if (vm.odecRendererConfig.type === 'select2') {
                htmlTemplate = '<div odec-select2 odec-select2-data="odecRenderer.odecRendererConfig.datos" odec-select2-placeholder="{{odecRenderer.odecRendererConfig.label|translate}}" odec-select2-selection="odecRenderer.odecRendererConfig.selectedNode" odec-select2-event="odecRenderer.odecRendererConfig.eventId" odec-select-2-config-extra="odecRenderer.odecRendererConfig.config" odec-select2-allow-clear="odecRenderer.odecRendererConfig.allowClear" odec-select2-disabled="odecRenderer.odecRendererDisabled"></div>';
            } else if (vm.odecRendererConfig.type === 'label') {
                htmlTemplate = '<span class="label label-success">{{odecRenderer.odecRendererConfig.selectedNode}}</span>';                
            }
            element.replaceWith($compile(htmlTemplate)(scope));
            
        }
    }

    /* @ngInject */
    function odecRendererController() {

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecPanel', odecPanel);

    /* @ngInject */
    function odecPanel() {
        /**
         * Component used to render panels, this is the container
         * 
         * @example
         * <odec-panel>
         *     <odec-panel-header
         *         odec-panel-header-config="interviewlist.panel.config">
         *     </odec-panel-header>
         *     <odec-panel-body>
         *         <odec-panel-body-bar
         *             odec-panel-body-bar-search-text="interviewlist.expandable.searchText"
         *             odec-panel-body-bar-search-placeholder="interviewlist.expandable.placeholder">
         *         </odec-panel-body-bar>
         *         <div class="content padding--1">
         *             <table id="interviewListTable" class="table table-stripped table-bordered"
         *                 odec-datatable
         *                 odec-datatable-column-defs="interviewlist.table.columnsDef"
         *                 odec-datatable-data="interviewlist.table.data"
         *                 odec-datatable-columns="interviewlist.table.columns"
         *                 odec-datatable-sort="interviewlist.table.order"
         *                 odec-datatable-search-text="interviewlist.expandable.searchText"
         *                 odec-datatable-allow-row-click="true"></table>
         *         </div>
         *     </odec-panel-body>
         * </odec-panel>
         */
        var directive = {
            templateUrl: 'app/components/odecPanel/odecPanel.html',
            bindToController: true,
            controller: odecPanelController,
            controllerAs: 'odecPanel',
            link: link,
            restrict: 'EA',
            transclude: true,
            scope: {
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$on('$destroy',function() {
                element.remove();
            });
        }
    }
    /* @ngInject */
    function odecPanelController($scope) {
        var vm = this;
        vm.isCollapsed = false;
        vm.collapse = collapse;
        vm.close = close;


        /** private methods */
        function collapse() {
            vm.isCollapsed = !vm.isCollapsed;
        }


        function close() {
            $scope.$destroy();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecNoDataDisplay', odecNoDataDisplay);

    /* @ngInject */
    function odecNoDataDisplay() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecNoDataDisplayController,
            templateUrl: 'app/components/odecNoDataDisplay/odecNoDataDisplay.html',
            controllerAs: 'displayCtrl',
            link: link,
            restrict: 'EA',
            scope: {
                isError: '<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecNoDataDisplayController () {
        var NO_DATA_MESSAGE = 'No hay datos que mostrar';
        var ERROR_MESSAGE = 'Error cargando los datos';

        var vm = this;

        // Error display
        vm.message = vm.isError ? 
        { key: ERROR_MESSAGE, icon: 'icon-close2' } :
        { key: NO_DATA_MESSAGE, icon: 'icon-error_outline' };
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecNoData', odecNoData);

    /* @ngInject */
    function odecNoData() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecNoDataController,
            templateUrl: 'app/components/odecNoData/odecNoData.html',
            controllerAs: 'noDataCtrl',
            link: link,
            restrict: 'EA',
            scope: {
                isError: '<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecNoDataController () {
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecModal', odecModal);

    /* @ngInject */
    function odecModal() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odeModalController,
            templateUrl: 'app/components/odecModal/odecModal.html',
            controllerAs: 'modalCtrl',
            transclude: true,
            link: link,
            restrict: 'EA',
            scope: {
                headerTitle: '@',
                bodyMessage: '@',
                eventId: '@',
                emitData: '<', //Data to send when the event is emited
                showData: '<' //Data to show besides the 'bodyMessage' (format: [{key: '', value: ''}, ...])
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            element.on('click', scope.modalCtrl.openModal);
        }
    }
    /* @ngInject */
    function odeModalController ($rootScope, $scope, $uibModal) {
        var vm = this;
        //Modal instance
        var modalInstance;
        
        vm.openModal = openModal; //Open 
        vm.closeModal = closeModal; //Close
        vm.accept = accept; //Accept

        /**
         * Open the modal when click the button
         */
        function openModal(){
            modalInstance = $uibModal.open({
                templateUrl: 'odecModal.html',
                scope: $scope
            });
        }

        /**
         * Close de modal
         */
        function closeModal(){
            modalInstance.dismiss('cancel');
        }

        /**
         * When accept is clicked
         */
        function accept(){
            //Close modal
            vm.closeModal();
            //Emit
            var eventString = 'modal:accept';
            if(angular.isDefined(vm.eventId)){
                eventString += ':' + vm.eventId;
            }
            $scope.$emit(eventString, vm.emitData);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLoadingButton', odecLoadingButton);

    function odecLoadingButton() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecLoadingButton/odecLoadingButton.html',
            bindToController: true,
            controller: odecLoadingButtonController,
            controllerAs: 'odecLoadingButton',
            link: link,
            restrict: 'EA',
            transclude:true,
            replace:true,
            scope: {
                odecLoadingButtonLoading:'='
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function odecLoadingButtonController () {
        
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .directive('odecLanguageSelector', odecLanguageSelector);

  function odecLanguageSelector() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      templateUrl: 'app/components/odecLanguageSelector/odecLanguageSelector.html',
      bindToController: true,
      controller: odecLanguageSelectorController,
      controllerAs: 'odecLanguageSelector',
      link: link,
      restrict: 'EA',
      transclude: true,
      replace: true,
      scope: {
        odecLanguageList: '=',
        odecLanguageSelected: '=',
        odecLanguageOnChange: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {
      var vm = scope.odecLanguageSelector;
      // inicializamos con los que nos pasa al componente desde fuera
      vm.languageSelector.language.selected = vm.odecLanguageSelected;
      vm.languageSelector.language.list = vm.odecLanguageList;
    }
  }
  /* @ngInject */
  function odecLanguageSelectorController() {
    var vm = this;

    var enumStatus = [{
        label: 'HOME_SELECT_COUNTRY'
      }, {
        label: 'HOME_SELECT_LANGUAGE'
      }],
      statusSelected = 0,
      lastSelected = null;

    vm.languageSelector = {
      status: enumStatus[statusSelected],
      countrySelectionChange: countrySelectionChange,
      isLoading: false,
      language: {
        selected: null,
        list: []
      },
      filteredLanguageList: [],
      languageSelectionChange: languageSelectionChange,
      returnCountrySelection: returnCountrySelection
    };


    function countrySelectionChange($event, country) {
      statusSelected++;
      lastSelected = vm.languageSelector.language.selected;
      vm.languageSelector.language.selected = {
        country: country.country,
        image: country.image,
        lang: '',
        code: ''
      };

      if (country.languages.length === 1) {
        vm.languageSelector.language.selected.lang = country.languages[0].lang;
        vm.languageSelector.language.selected.code = country.languages[0].code;
        vm.languageSelector.isLoading = true;

        vm.odecLanguageSelected = country.languages[0].code;

        vm.odecLanguageOnChange({
          selection: vm.languageSelector.language.selected
        });
      } else {
        vm.languageSelector.filteredLanguageList = country.languages;
        vm.languageSelector.status = enumStatus[statusSelected];

        vm.odecLanguageSelected = null;

        $event.stopPropagation();
      }

    }

    function languageSelectionChange(language) {
      statusSelected--;
      vm.languageSelector.language.selected.lang = language.lang;
      vm.languageSelector.language.selected.code = language.code;
      vm.languageSelector.filteredLanguageList = [];
      vm.languageSelector.status = enumStatus[statusSelected];
      lastSelected = null;
      vm.languageSelector.isLoading = true;

      vm.odecLanguageSelected = language.code;

      vm.odecLanguageOnChange({
        selection: vm.languageSelector.language.selected
      });
    }

    function returnCountrySelection() {
      statusSelected--;
      vm.languageSelector.language.selected = lastSelected;
      vm.languageSelector.status = enumStatus[statusSelected];
    }
  }


})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .directive('odecJerarquicFilter', odecJerarquicFilter);
  
    function odecJerarquicFilter() {
      // Usage:
      //
      // Creates:
      //
      var directive = {
        templateUrl: 'app/components/odecJerarquicFilter/odecJerarquicFilter.html',
        bindToController: true,
        controller: odecJerarquicFilterController,
        controllerAs: 'odecJerarquicFilter',
        link: link,
        restrict: 'EA',
        scope: {
            odecJerarquicFilterOpened: '=',
            odecJerarquicFilterWaves: '<'
        }
      };
      return directive;
  
      function link(scope, element, attrs) {
        var vm = scope.odecJerarquicFilter;  
        vm.waves = vm.odecJerarquicFilterWaves;
      }
    }
    /* @ngInject */
    function odecJerarquicFilterController($rootScope) {
      var vm = this;
      vm.changeWave = changeWave;
      vm.closeFilter = closeFilter;

      function changeWave( wave ) {
        vm.odecJerarquicFilterOpened = false;
        vm.waves.selected.wave = wave;
        emitChangeWave( vm.waves.selected );
      }
  
      function emitChangeWave( _wave ) {
        $rootScope.$emit('main:changeWave',  _wave );
      }

      function closeFilter () {
        vm.odecJerarquicFilterOpened = false;
      }
  
      
    }
  
  
  })();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecCopyToClipboard', odecCopyToClipboard);

    /** @ngInject */
    function odecCopyToClipboard(toastr, $document) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            templateUrl: 'app/components/odecCopyToClipboard/odecCopyToClipboard.html',
            controller: odecCopyToClipboardController,
            controllerAs: 'odecCopyToClipboard',
            link: link,
            restrict: 'EA',
            scope: {   
                odecCopyToClipboardData: '<',
                odecCopyToClipboardFormatFn: '<'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecCopyToClipboard;
            vm.copyToClipboard = copyToClipboard;
            vm.copyText = 'Copiar datos al portapapeles';

            function copyToClipboard() {
                var formattedData = vm.odecCopyToClipboardFormatFn(vm.odecCopyToClipboardData);
                var el = $document[0].createElement('textarea');  // Create a <textarea> element
                el.value = formattedData;   
                el.textContent = formattedData;                              // Set its value to the string that you want copied
                el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
                el.style.position = 'absolute';
                el.style.left = '-9999px';                      // Move outside the screen to make it invisible
                $document[0].body.appendChild(el);                  // Append the <textarea> element to the HTML document
                var selected = $document[0].getSelection().rangeCount > 0 ? $document[0].getSelection().getRangeAt(0) : false;     // Store selection if found or mark as false to know no selection existed before
                el.select();                                    // Select the <textarea> content
                $document[0].execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
                $document[0].body.removeChild(el);                  // Remove the <textarea> element
                if (selected) {                                 // If a selection existed before copying
                    $document[0].getSelection().removeAllRanges();    // Unselect everything on the HTML document
                    $document[0].getSelection().addRange(selected);   // Restore the original selection
                }
                toastr.success('Los datos estan copiada en el portapapeles','Proceso finalizado');
            }            
        }
    }
    
    /** @ngInject */
    function odecCopyToClipboardController ($scope) {
        var vm = this;
    }
})();
/*global Highcharts */
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecHighcharts', odecHighcharts);

    odecHighcharts.$inject = ['$timeout'];

    function odecHighcharts($timeout) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: odecHighchartsController,
            controllerAs: 'odecHighcharts',
            link: link,
            restrict: 'EA',
            scope: {
                odecHighchartsConfig: '<',
                odecHighchartsData: '<',
                odecHighchartsCategories: '<',
                odecHighchartsInstance: '=',
                odecHighchartsOnClick: '&'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecHighcharts;
            var chart,
                dataWatcher,
                TIMEOUT_REFLOW = 300;


            dataWatcher = scope.$watch(function() {
                return vm.odecHighchartsData;
            }, init);

            scope.$on('$destroy', function() {
                dataWatcher();
            });



            // private methods
            function init(newData) {
                // in case the data is null exit
                if (!newData) {
                    return;
                }

                var opciones = vm.odecHighchartsConfig;

                // add data
                opciones.series = vm.odecHighchartsData && vm.odecHighchartsData.length > 0 ?
                    vm.odecHighchartsData :
                    vm.odecHighchartsConfig.series;

                // add categories
                opciones.xAxis = opciones.xAxis || {};
                opciones.xAxis.categories = vm.odecHighchartsCategories && vm.odecHighchartsCategories.length > 0 ?
                    vm.odecHighchartsCategories :
                    vm.odecHighchartsConfig.categories;

                // get id for chart from parent element
                opciones.chart = opciones.chart || {};
                opciones.chart.renderTo = element.attr('id');

                // set events                            
                if (angular.isDefined(attrs.odecHighchartsOnClick)) {
                    opciones.plotOptions = opciones.plotOptions || {};
                    opciones.plotOptions.series = opciones.plotOptions.series || {};
                    opciones.plotOptions.series.point = opciones.plotOptions.series.point || {};
                    opciones.plotOptions.series.point.events = {
                        click: angular.isDefined(attrs.odecHighchartsOnClick) && onClick
                    };
                }

                // fix responsive bug: need that container has own width and highcharts-container
                // to be width:100%
                element.attr('style','display:block;width:100%');
                //console.log('Creating chart:' + element.attr('id') + ' -> width: ' + element.width());
                chart = new Highcharts.Chart(opciones);
                reflow();

            }

            function reflow() {
                $timeout(function() {
                    chart.reflow();
                }, TIMEOUT_REFLOW);
            }

            function onClick(event) {
                vm.odecHighchartsOnClick({event:event});
            }
        }
    }
    /* @ngInject */
    function odecHighchartsController() {
        var vm = this;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('odecFilter', odecFilter);

    /** @ngInject */
    function odecFilter($rootScope, filterService, errorHandlerService,$log) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecFilter/odecFilter.html',
            bindToController: true,
            controller: odecFilterController,
            controllerAs: 'odecFilter',
            link: link,
            restrict: 'EA',
            scope: {
                odecFilterData: '<',
                hideFilterBar: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecFilter;
            var watcherUpdate, watcherAsyncFirst, treeWatchersOnChange, openWatcher,watcherDoUpdate;
            var eventList;

            vm.displayer;

            /** listeners */

            // watch for filter updates            
            watcherDoUpdate = $rootScope.$on('filter:do:update', function() {
                // allow to do filter update from outside the component without clicking the button
                // do it without emiting apply or it loops
                return vm.applyFilter(false);
            });
            watcherUpdate = $rootScope.$on('filter:update', updateFilter);
            openWatcher = $rootScope.$on('filter:open', vm.open);
            watcherAsyncFirst = scope.$watch('odecFilter.odecFilterData', watchFilter);

            scope.$on('$destroy', function () {
                destroyAllWatchers();
                watcherUpdate();
                watcherAsyncFirst();
                openWatcher();
                watcherDoUpdate();
            });

            function destroyAllWatchers() {
                $log.warn('destroying watcher', treeWatchersOnChange && treeWatchersOnChange.length);

                _.each(treeWatchersOnChange, function (item) {
                    item();
                });
            }

            function getEventList(filterData) {
                return _.chain(filterData)
                    .map('data')
                    .flatten()
                    .map(function (item) {
                        return {
                            type: item.type,
                            eventId: item.eventId
                        };
                    })
                    .uniqBy('eventId')
                    .value();
            }

            function createDataWatchers(eventList) {

                return _.chain(eventList).map(function (item) {
                    //console.warn('register Watchers', item.eventId);
                    var dataWatcher =  $rootScope.$on(item.type + ':' + item.eventId, function (event, object) {
                        setLoading(true);
                        var eventObject = object;
                        if (object.events.removing) {
                            //In case of removing, it is necessary to remove from the previous node selected.
                            var networkObject = _.chain(scope.odecFilter.odecFilterData).flatMap('selection').filter({ 'eventId': item.eventId }).value(),
                                indexSelected = _.chain(networkObject).findIndex({ id: object.id }).value(),
                                previousObject;

                            if (indexSelected > 0) {
                                previousObject = networkObject[indexSelected - 1];
                                eventObject = _.extend({}, eventObject, previousObject);
                            } else {
                                eventObject = _.extend({}, eventObject, { id: null });
                            }



                        }
                        filterService.onChangeCallback.apply(this, Array.prototype.concat(event, eventObject, item.eventId))
                            .then(function () { })
                            .catch(errorHandlerService.callbackError)
                            .finally(function () {
                                setLoading(false);
                            });
                    });
                    return dataWatcher;
                })
                    .value();

            }

            function updateFilter(event, data) {
                //console.warn('update');

                // in case input was null that means it was synchronous and
                // must update pills with data requested
                // if (data.data) {
                //     vm.pillsCollection = angular.copy(vm.createPills(data.data));
                // }

                setLoading(true);

                var newEventList = getEventList(data.data);
                var newEvents = _.difference(_.map(newEventList, 'eventId'), _.map(eventList, 'eventId'));
                var newEventObjs;

                if (newEvents.length > 0) {
                    newEventObjs = _.filter(newEventList, function (item) {
                        return _.some(newEvents, function (el) { return el === item.eventId; });
                    });

                    treeWatchersOnChange.concat(createDataWatchers(newEventObjs));
                    eventList = eventList.concat(newEventObjs);
                } else if (newEventList.length < eventList.length) {
                    destroyAllWatchers();
                    treeWatchersOnChange = createDataWatchers(newEventList);
                }


                vm.displayer = data.data;
                setLoading(false);
            }

            function watchFilter(newValue) {
                //console.warn('watch');
                if (newValue) {
                    // que events form filter response
                    eventList = getEventList(newValue);

                    // destroy all watchers before registering
                    if (treeWatchersOnChange && treeWatchersOnChange.length > 0) {
                        destroyAllWatchers();
                    }

                    // create watchers for events
                    treeWatchersOnChange = createDataWatchers(eventList);


                    // in case input was null that means it was synchronous and
                    // must update pills with data requested
                    setLoading(true);
                    if (!vm.pillsCollection) {
                        vm.pillsCollection = angular.copy(vm.createPills(newValue));
                    }

                    vm.displayer = newValue;
                    setLoading(false);
                }
            }

            function setLoading(blnValue) {
                vm.loading = blnValue;
            }

        }
    }

    /* @ngInject */
    function odecFilterController($scope) {
        var vm = this;

        vm.opened = false;
        vm.open = toggleFilterView;
        vm.applyFilter = applyFilter;
        vm.createPills = createPills;
        vm.loading = false;

        /** private methods */

        // toggle filter openness. can pass the value as optional, without parameter is a toggle.
        function toggleFilterView(value) {
            if (angular.isUndefined(value)) {
                vm.opened = !vm.opened;
                return;
            }

            vm.opened = value;
        }

        function applyFilter(forceEmit) {
            // if undefined, the default is to emit
            if (angular.isUndefined(forceEmit)) {
                forceEmit = true;
            }

            if (forceEmit) {
                $scope.$emit('filter:apply', { filter: vm.displayer });
            }            
            // on apply create pills
            vm.pillsCollection = angular.copy(createPills(vm.displayer));
            toggleFilterView(false);
        }

        function createPills(data) {
            return _.chain(data)
                .map('filterInfo')
                .flatten()
                .filter(function (item) {
                    // return not undefined items
                    return item;
                })
                .map(function (item) {
                    return {
                        label: item.viewLabel,
                        value: item.text
                    };
                })
                .value();
        }


    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecDatatable', odecDatatable);

    /** @ngInject */
    function odecDatatable() {
        var directive = {
            restrict: 'EA',
            scope: {
                odecDatatableData: '=',
                odecDatatableColumns: '=',
                odecDatatableColumnDefs: '=',
                odecDatatableSort: '=',
                odecDatatableLanguageUrl: '@',
                odecDatatableSearchText:'=',
                odecDatatableAllowRowClick:'<',
                odecDatatableAllowCellClick:'<',
                odecDatatableTableState: '<',
                odecDatatableNotDestroy: '<'
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el,attr) {
            var options,
                tabla,
                id,
                event,
                saveState;
            
            id = attr.id;

            if (id) {
                event = 'datatables:' + id + ':';
            } else {
                event = 'datatables:';
            }
            
            /** private methods */

            // datatables initialization, prepares config and calls plugin
            function init(newData) {
                if (tabla && !scope.odecDatatableNotDestroy) {
                    destroy();
                }

                // only initiate if newData is not null
                if (!newData || !newData.length > 0) {return;}

                options = {};

                // set i18
                options.language = {
                    url: scope.odecDatatableLanguageUrl
                };

                // set data rows only if is defined
                if (angular.isDefined(scope.odecDatatableData)) {
                    options.data = scope.odecDatatableData;
                }

                // set data columns only if defined
                if (angular.isDefined(scope.odecDatatableColumns)) {
                    options.columns = scope.odecDatatableColumns;
                }

                // set column defs only if defined
                if (angular.isDefined(scope.odecDatatableColumnDefs)) {
                    options.columnDefs = scope.odecDatatableColumnDefs;
                }

                // if passed some sorting use it else will order by default using first column
                if (angular.isDefined(scope.odecDatatableSort)) {
                    options.aaSorting = scope.odecDatatableSort;
                } else {
                    options.aaSorting = [];
                }

                //Table state (columns sorting, search, pagination, ...)
                saveState = angular.isDefined(scope.odecDatatableTableState);

                // destroy table each time is update otherwise won't update
                options.destroy = true;

                // processing overlay during process
                options.bProcessing = true;

                // defer drawing, this avoids freezing when to much rows
                options.bDeferRender = true;

                // hide length change combo
                options.bLengthChange = false;

                // type of paging is simple numbers
                options.pagingType = 'simple_numbers';

                // in case the table don't fit x-space there will be a scrollbar
                options.sScrollX = true;

                //Saving the table state?
                options.stateSave = saveState;

                /**
                 * We emit the current table state
                 * 
                 * !! This will be call only if 'stateSave' value is true.
                 */
                options.stateSaveCallback = function (settings, data) {
                    scope.$emit('datatables:saveState', data);
                };

                /**
                 * Return the previous saved state
                 * 
                 * !! This will be call only if 'stateSave' value is true.
                 */
                options.stateLoadCallback = function (settings) {
                    return scope.odecDatatableTableState;
                };


                if (options.data && options.data.length > 0) {
                    // inititalize datatables just in case there is data
                    tabla = angular.element(el).DataTable(options);
                }

                if (scope.odecDatatableAllowCellClick) {
                    tabla.off( 'click' ).on( 'click', 'td', function () {
                        var cell = tabla.cell(this);
                        var index = tabla.cell(this).index();
                        scope.$emit(event + 'cell',{cell:cell, index:index});
                    });
                }
                
                if (scope.odecDatatableAllowRowClick) {
                    tabla.on( 'click', 'td', function () {
                        var row = tabla.row(this).data();
                        scope.$emit(event + 'row',{row:row});
                    });
                }
            }

            // metod on destroy
            function destroy() {
                if (tabla) {
                    tabla.destroy();
                    angular.element(el).empty();
                }
            }

            // method used to externalize search
            function searchGlobal(newData, oldData) {
                if (newData !== oldData) {
                    tabla.search(
                        newData,
                        false, //Regex
                        false //Smart search
                    ).draw();
                }
            }

            /** listeners */

            // watch change on data input
            var datawatch = scope.$watch('odecDatatableData', init);

            // watch change on search input
            var seachTextWatch = scope.$watch('odecDatatableSearchText', searchGlobal);

            // on destroy listener
            scope.$on('$destroy', function() {
                destroy();
                datawatch();
                seachTextWatch();
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecLayoutUi', odecLayoutUi);

    //odecLayoutUi.$inject = ['dependency1'];
    function odecLayoutUi() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl:'app/components/layout-ui/layoutUi.html',
            bindToController: true,
            controller: odecLayoutUiController,
            controllerAs: 'vm',
            link: link,
            restrict: 'EA',
            transclude:true,
            replace:true,
            scope: {
                opened:'='                
            }
        };
        return directive;
        
        function link() {           

        }
    }
     /* @ngInject */
    function odecLayoutUiController () {
        
    }    
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('odecBarMenu', odecBarMenu);

    odecBarMenu.inject = ['d3', 'uuid', '$rootScope'];
    function odecBarMenu(d3, uuid, $rootScope) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecBarMenu/odecBarMenu.html',
            bindToController: true,
            controller: odecBarMenuController,
            controllerAs: 'odecBarMenu',
            link: link,
            restrict: 'EA',
            scope: {
                odecBarMenuSelected: '<',
                odecBarMenuData: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var vm = scope.odecBarMenu;
            vm.showItem = vm.odecBarMenuSelected;
            vm.onMouseEnterItem = mouseEnterItem;
            vm.onMouseLeaveItem = mouseLeaveItem;
            vm.elementOnHover = null;
            var selectionWatcher, dataWatcher;      
            var totalWidth = element.outerWidth();
            vm.data = vm.odecBarMenuData;
            
            // watchers
            selectionWatcher = scope.$watch(function () { return vm.odecBarMenuSelected; }, init);
            dataWatcher = scope.$watch(function () { return vm.odecBarMenuData; }, init);
            scope.$on('$destroy', function () { selectionWatcher(); });
            scope.$on('$destroy', function () { dataWatcher(); });

            // private methods

            function mouseEnterItem(event,item) {
                vm.showItem = item;
            }
            function mouseLeaveItem(event,item) {
                vm.showItem = vm.odecBarMenuSelected;
            }

            function init() {
                // Para que actualice cada vez que se cambia de ola
                vm.data = vm.odecBarMenuData;

                parseMenuItems(); 

            }

            function parseMenuItems() {
                var totalData = 0;
                _.forEach(vm.data, function(item) {
                    totalData = totalData + item.value;
                    return totalData;
                });
                vm.menuItems = _.reduce(vm.data,function(aggr,item){
                    item.menuWidth = (item.value*totalWidth/totalData);
                    aggr.push(item);
                    return aggr;
                },[]);
            }

        }
    }
    /* @ngInject */
    function odecBarMenuController($state) {
        var vm = this;
        vm.goToModule = goToModule;

        function goToModule(module){
            $state.go('main.'+ module);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('odecButtonExpandable', odecButtonExpandable);

    //odecButtonExpandable.$inject = ['dependency1'];
    function odecButtonExpandable() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/components/odecButtonExpandable/odecButtonExpandable.html',
            bindToController: true,
            controller: odecButtonExpandableController,
            controllerAs: 'odecButtonExpandable',
            link: link,
            restrict: 'EA',
            transclude:true,
            scope: {
                odecButtonExpandableOpened:'=?',
                odecButtonExpandableClosable:'<?'
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
            var vm = scope.odecButtonExpandable;
            vm.odecButtonExpandableOpened = angular.isUndefined(vm.odecButtonExpandableOpened)? false:vm.odecButtonExpandableOpened; 
            vm.odecButtonExpandableClosable = angular.isUndefined(vm.odecButtonExpandableClosable)? true:vm.odecButtonExpandableClosable;
        }
    }
    /* @ngInject */
    function odecButtonExpandableController () {
        var vm = this;
        vm.toggleOpen = toggleOpen;

        /** private methods */
        function toggleOpen() {
            
            if (!vm.odecButtonExpandableClosable) {
                return;
            }

            vm.odecButtonExpandableOpened = !vm.odecButtonExpandableOpened;
        }

    }
})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .service('odecD3Service', odecD3Service);
  
    odecD3Service.$inject = ['d3'];
  
    function odecD3Service(d3) {
      var es_ES = {
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d/%m/%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
        "shortDays": ["Dom", "Lun", "Mar", "Mi", "Jue", "Vie", "Sab"],
        "months": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        "shortMonths": ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
    };
      
      var service = {
        wrapText: wrapText,
        ellipsis: ellipsis,
        es_ES:es_ES
      };
  
      return service;
  
      //for ellipsis text
      function ellipsis(width) {
        var widthBlackBox = angular.isDefined(width) && width > 0 ? width : 150;
        var self = d3.select(this),
          textLength = self.node().getComputedTextLength(),
          text = self.text();
        while (textLength > (widthBlackBox - 25) && text.length > 0) {
          text = text.slice(0, -1);
          self.text(text + '...');
          textLength = self.node().getComputedTextLength();
        }
      }
  
      // for wrapping labels
      function wrapText(text, width, textAnchor, fontSize) {
        textAnchor = textAnchor ? textAnchor : "start";
        text.each(function () {
          var text = d3.select(this)
            .attr("text-anchor", textAnchor)
            .attr('font-size', fontSize || 8),
            words = text.text().split(/\s+/).reverse(),
            word = words.pop(),
            line = [],
            lineNumber = 0,
            lineHeight = 1, // ems
            x = text.attr('x'),
            y = text.attr('y'),
            dy = 0, //parseFloat(text.attr('dy')),
            tspan = text.text(null)
            .append('tspan')
            .attr('x', x)
            .attr('y', y)
            .attr('dy', dy + 'em');
          while (word) {
              line.push(word);
              tspan.text(line.join(' '));
              if (tspan.node().getComputedTextLength() > width && line.length > 1 ) {
                line.pop();
                tspan.text(line.join(' '));
                line = [word];
                tspan = text.append('tspan')
                  .attr('x', x)
                  .attr('y', y)
                  
                  //.attr('font-weight', 'bold')
                  .attr('dy', ++lineNumber * lineHeight + dy + 'em')
                  .text(word);
              }         
            word = words.pop();
          }
        });
      }
    }
  })();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('televisionService', televisionService);

    /** @ngInject */
    function televisionService($http, $q, errorHandlerService) {
        var service = {
            getRankData: getRankData,
            getPenData: getPenData,
            getPerData: getPerData
        };

        return service;

        ////////////////

        function getRankData(type,wave) {
            return $q.all([getTvTotal(type, wave), getTvTotal30(wave), getRankTv(type,wave), getRankTvPago(wave), getRankTvResto(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPenData(wave) {
            return $q.all([getTvPenSex(wave), getTvPenEdad(wave), getTvPenNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPerData(wave) {
            return $q.all([getTvPerSex(wave), getTvPerEdad(wave), getTvPerNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getTvTotal(type, wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                    "datasource": type === 'rk' ? 'RANKTV1' : 'RANKTVS',
                    "query": type === 'rk' ? 'TOTTV' : 'TOTTVS',
                    "parameters": { "$wave$": wave},
                    "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getTvTotal30(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKTV3",
                  "query": "TOTTV30",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankTv(type, wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": type === 'rk' ? 'RANKTV1' : 'RANKTVS',
                  "query": type === 'rk' ? 'RANKTV' : 'RANKTVS',
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankTvPago(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKTV2",
                  "query": "RANKTVPAGO",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankTvResto(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKTV2",
                  "query": "RANKTVRESTO",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getTvPenSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "TVPENSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getTvPenEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "TVPENEDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getTvPenNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "TVPENNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getTvPerSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "TVPERSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getTvPerEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "TVPEREDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getTvPerNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "TVPERNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function transformData(data) {
            return data && data.data;
        }

        function parseData(data) {
            return data;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.television', {
                url: '/television',
                views: {
                    content: {
                        templateUrl: 'app/television/television.html',
                        controller: 'TelevisionController',
                        controllerAs: 'televisionController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('TelevisionController', TelevisionController);

    /** @ngInject */  
    function TelevisionController(televisionService, errorHandlerService, $rootScope, mainService, stateManagerService, $scope) {
        var selectedRankingType;
        var vm = this;
        vm.id = 'television';
        vm.selectedWave = null;
        vm.menuData = mainService.audienceDataState;
        vm.penWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.perWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.rankWidget = {
            loading: false,
            reachTotal: null,
            tematicasTotal: null,
            reachData: [],
            temPagoData: [],
            temRestoData: []
        };

        vm.filters = {
            w1:[{ 
                comboId:'type',
                selected:null,
                childs:[
                    { id:'sh', text: 'Minutos', title: 'CONSUMO DE MINUTOS', subtitle: 'Minutos/Telespectador' },
                    { id:'rk', text: 'Reach Diario', title: 'REACH DIARIO', subtitle: 'Telespectadores/Día (000)' }                 
                ]
            }]
        };

        
        init();

        /** listeners */ 
        var changeWaveWatcher = $rootScope.$on('main:changeWave', init); 
        var changeFilterRankingTypeWatcher = $rootScope.$on('odecFilterHeader:selectFilter:tvRanking:type', function(event, value) {
            if (value.id === selectedRankingType) { return; }
            selectedRankingType = value.id;
            vm.filters.w1[0].selected = value;
            getRankData();
        });
 
        $scope.$on('$destroy', function () { 
            changeWaveWatcher(); 
            changeFilterRankingTypeWatcher();
        });


        ////////////////

        function init() {
            vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
            vm.filters.w1[0].selected = vm.filters.w1[0].childs[0];
            vm.rankWidget.mainTvRankFormatFn =  copyMainTvRankWidgetToClipboard;
            vm.rankWidget.temTvRankFormatFn =  copyTemTvRankWidgetToClipboard;
            vm.penWidget.penWidgetFormatFn =  copyPenWidgetToClipboard;
            vm.perWidget.perWidgetFormatFn =  copyPerWidgetToClipboard;
            if(vm.selectedWave && vm.selectedWave.fullWave) {
                getGeneralAudienceData();
                getRankData();
                getPenData();
                getPerData();
            }
        }

        function getGeneralAudienceData(){
            mainService.getAudienceData()
            .then(function(data) {
                vm.menuData = data;
            })
            .catch(televisionError);
        }

        function getRankData() {
            vm.rankWidget.loading = true;
            televisionService.getRankData(vm.filters.w1[0].selected.id,vm.selectedWave.fullWave)
            .then(function(data) {
                vm.rankWidget.reachTotal = data[0];
                vm.rankWidget.tematicasTotal = data[1];
                vm.rankWidget.reachData = data[2];
                vm.rankWidget.temPagoData = data[3];
                vm.rankWidget.temRestoData = data[4];
                vm.rankWidget.reachTitle = vm.filters.w1[0].selected.title;
            })
            .catch(televisionError)
            .finally(function(){ vm.rankWidget.loading = false; });
        }

        function getPenData() {
            vm.penWidget.loading = true;
            televisionService.getPenData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.penWidget.sexo = data[0];
                vm.penWidget.edad = data[1];
                vm.penWidget.iso = data[2];
            })
            .catch(televisionError)
            .finally(function(){ vm.penWidget.loading = false; });
        }

        function getPerData() {
            vm.perWidget.loading = true;
            televisionService.getPerData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.perWidget.sexo = data[0];
                vm.perWidget.edad = data[1];
                vm.perWidget.iso = data[2];
            })
            .catch(televisionError)
            .finally(function(){ vm.perWidget.loading = false; });
        }

        

        function televisionError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyMainTvRankWidgetToClipboard(data) {
            var total = data.reachTitle + '\t' + data.reachTotal;
            var chartData = _.reduce(data.reachData, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(total, chartData);
            return formattedData.join('\n');
        }

        function copyTemTvRankWidgetToClipboard(data) {
            var total = 'TOTAL AUDIENCIA CADENAS DE TELEVISIÓN' + '\t' + data.tematicasTotal;
            var title1 = 'CANALES TEMÁTICOS DE PAGO';
            var title2 = 'RESTO CANALES TEMÁTICOS';
            var chart1Data = _.reduce(data.temPagoData, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.temRestoData, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(total, title1, chart1Data, title2, chart2Data);
            return formattedData.join('\n');
        }

        function copyPenWidgetToClipboard(data) {
            var title = 'PENETRACIÓN POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

        function copyPerWidgetToClipboard(data) {
            var title = 'PERFIL POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad.text, function(aggr, item, index) {
                var row = item + '\t' + data.edad.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso.text, function(aggr, item, index) {
                var row = item + '\t' + data.iso.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('revistasService', revistasService);

    /** @ngInject */
    function revistasService($http, $q, errorHandlerService) {
        var service = {
            getRankData: getRankData,
            getPenData: getPenData,
            getPerData: getPerData
        };

        return service;

        ////////////////

        function getRankData(wave) {
            return $q.all([getRevTotalMen(wave), getRevTotalSem(wave), getRevTotalBim(wave), getRevTotalQuin(wave), getRankRevMen(wave), getRankRevSem(wave), getRankRevBi(wave), getRankRevQuin(wave), getRevTotalTrim(wave), getRankRevTri(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPenData(wave) {
            return $q.all([getRevPenSex(wave), getRevPenEdad(wave), getRevPenNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPerData(wave) {
            return $q.all([getRevPerSex(wave), getRevPerEdad(wave), getRevPerNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getRevTotalMen(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVMENS",
                  "query": "TOTREVMEN",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevTotalSem(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVSEM",
                  "query": "TOTREVSEM",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevTotalBim(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVBIMT",
                  "query": "TOTREVBIM",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevTotalTrim(wave) {
          return $http({
            method:'POST',
            url:'./crosstab/operations/AIMC/extract',
            data: {
              "datasource": "RANKREVBIMT",
              "query": "TOTREVTRIM",
              "parameters": { "$wave$": wave},
              "transform": {
                "template": "Evolution",
                "parameters": {
                  "categories": "Columns",
                  "series": "Rows"
                }
              }
            }
          })
          .then(transformData)
          .then(function(data){
              return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
          })
          .catch(function(){
              return $q.when(null);
          });
        }

        function getRevTotalQuin(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVQUIN",
                  "query": "TOTREVQUI",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankRevMen(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVMENS",
                  "query": "RANKREVMEN",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankRevSem(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVSEM",
                  "query": "RANKREVSEM",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankRevBi(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVBIM",
                  "query": "RANKREVBIM",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankRevTri(wave){
          return $http({
            method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVTRIM",
                  "query": "RANKREVTRIM",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
          })
          .then(transformData)
          .then(function(data){
              return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                  item.value = item.values && item.values.length > 0 && item.values[0];
                  item.value = parseFloat(item.value);
                  return item;
              }) : null;
          })
          .catch(function(){
              return $q.when(null);
          });
        }

        function getRankRevQuin(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKREVQUIN",
                  "query": "RANKREVQUI",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevPenSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "REPENSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevPenEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "REPENEDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevPenNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "REPENNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevPerSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "REPERSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevPerEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "REPEREDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRevPerNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "REPERNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function transformData(data) {
            return data && data.data;
        }

        function parseData(data) {
            return data;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.revistas', {
                url: '/revistas',
                views: {
                    content: {
                        templateUrl: 'app/revistas/revistas.html',
                        controller: 'RevistasController',
                        controllerAs: 'revistasController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('RevistasController', RevistasController);

    /** @ngInject */  
    function RevistasController(revistasService, errorHandlerService, $rootScope, mainService, stateManagerService, $scope) {
        var vm = this;
        vm.id = 'revistas';
        vm.selectedWave = null;
        vm.menuData = mainService.audienceDataState;
        vm.penWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.perWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.rankWidget = {
            loading: false,
            totalMen: null,
            totalSem: null,           
            totalBi: null,
            totalQuin: null,
            rankMen: [],
            rankSem: [],
            rankBim: [],
            rankQuin: []
        };
        
        init();

        /** listeners */ 
        var changeWaveWatcher = $rootScope.$on('main:changeWave', init); 
 
        $scope.$on('$destroy', function () { 
            changeWaveWatcher(); 
        });


        ////////////////

        function init() {
            vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
            vm.rankWidget.rankMenWidgetFormatFn = copyRankMenWidgetToClipboard;
            vm.rankWidget.rankSemWidgetFormatFn = copyRankSemWidgetToClipboard;
            vm.penWidget.penWidgetFormatFn =  copyPenWidgetToClipboard;
            vm.perWidget.perWidgetFormatFn =  copyPerWidgetToClipboard;
            if(vm.selectedWave && vm.selectedWave.fullWave) {
                getGeneralAudienceData();
                getRankData();
                getPenData();
                getPerData();
            }
        }

        function getGeneralAudienceData(){
            mainService.getAudienceData()
            .then(function(data) {
                vm.menuData = data;
            })
            .catch(revistasError);
        }

        function getRankData() {
            vm.rankWidget.loading = true;
            revistasService.getRankData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.rankWidget.totalMen = data[0];
                vm.rankWidget.totalSem = data[1];          
                vm.rankWidget.totalBim = data[2];
                vm.rankWidget.totalQuin = data[3];
                vm.rankWidget.rankMen = data[4];
                vm.rankWidget.rankSem = data[5];
                vm.rankWidget.rankBim = data[6];
                vm.rankWidget.rankQuin = data[7];
                vm.rankWidget.totalTrim = data[8];
                vm.rankWidget.rankTrim = data[9];
            })
            .catch(revistasError)
            .finally(function(){ vm.rankWidget.loading = false; });
        }

        function getPenData() {
            vm.penWidget.loading = true;
            revistasService.getPenData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.penWidget.sexo = data[0];
                vm.penWidget.edad = data[1];
                vm.penWidget.iso = data[2];
            })
            .catch(revistasError)
            .finally(function(){ vm.penWidget.loading = false; });
        }

        function getPerData() {
            vm.perWidget.loading = true;
            revistasService.getPerData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.perWidget.sexo = data[0];
                vm.perWidget.edad = data[1];
                vm.perWidget.iso = data[2];
            })
            .catch(revistasError)
            .finally(function(){ vm.perWidget.loading = false; });
        }

        

        function revistasError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyRankMenWidgetToClipboard(data) {
            var total = 'TOTAL LECTORES REVISTAS MENSUALES' + '\t' + data.totalMen;
            var chartData = _.reduce(data.rankMen, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(total, chartData);
            return formattedData.join('\n');
        }

        function copyRankSemWidgetToClipboard(data) {
            var totalSem = 'TOTAL LECTORES REVISTAS SEMANALES' + '\t' + data.totalSem;
            var totalBim = 'TOTAL LECTORES REVISTAS BIMESTRALES' + '\t' + data.totalBim;
            var totalQuin = 'TOTAL LECTORES REVISTAS QUINCENALES' + '\t' + data.totalQuin;
            var totalTrim = 'TOTAL LECTORES REVISTAS TRIMESTRALES' + '\t' + data.totalTrim;
            var chartDataSem = _.reduce(data.rankSem, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chartDataBim = _.reduce(data.rankBim, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chartDataQuin = _.reduce(data.rankQuin, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chartDataTrim = _.reduce(data.rankTrim, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);

            var formattedData = data.rankTrim 
                ? [].concat(totalSem, chartDataSem, totalBim, chartDataBim, totalQuin, chartDataQuin, totalTrim, chartDataTrim) 
                : [].concat(totalSem, chartDataSem, totalBim, chartDataBim, totalQuin, chartDataQuin);
            return formattedData.join('\n');
        }

        function copyPenWidgetToClipboard(data) {
            var title = 'PENETRACIÓN POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

        function copyPerWidgetToClipboard(data) {
            var title = 'PERFIL POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad.text, function(aggr, item, index) {
                var row = item + '\t' + data.edad.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso.text, function(aggr, item, index) {
                var row = item + '\t' + data.iso.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('snapshotsService', snapshotsService);

    snapshotsService.$inject = ['$rootScope', 'stateManagerService', '$http', 'exportService'];
    function snapshotsService($rootScope, stateManagerService, $http, exportService) {
        var service = {
            setSnapshots:setSnapshots,
            appendSnapshot: appendSnapshot,
            getSnapshots: getSnapshots,
            clearSnapshots: clearSnapshots,
            exportPPT: exportPPT
        };



        return service;

        /** private methods */

        function setSnapshots(collection) { 
            stateManagerService.setState('snapshots', [].concat(collection));
            $rootScope.$emit('snapshots:notification',{count:collection.length});
        }

        function appendSnapshot(obj) {
            var snapshots = stateManagerService.getState('snapshots') || [];
            stateManagerService.setState('snapshots', [].concat(snapshots, obj));
            $rootScope.$emit('snapshots:notification',{count:snapshots.length + 1});
        }

        function getSnapshots() {
            return stateManagerService.getState('snapshots') || [];
        }

        function clearSnapshots() {
            stateManagerService.setState('snapshots', null);
            $rootScope.$emit('snapshots:notification',{count:0});
        }

        function exportPPT(obj) {
            return $http({
                method: 'POST',
                url: './api/pptx/img2PptxCover/egmCopeTemplates/egmCope/plantillaCope',
                data: obj,
                transformRequest: [].concat([transformationPPT,toString]),
                transformResponse: $http.defaults.transformResponse.concat([getUrl])
            })
            .then(download);                
        }

        function getUrl(data, header, status) {
            return header()['x-doclocation'].replace('/egmCope', '.');
        }

        function download(data) {
            if (!data.data) {
                throw ('Descarga de PowerPoint no disponible');
            }

            return exportService.downloadUrl(data.data);
        }

        function transformation(data) {
            return _.chain(data)
                .map(function (obj) {
                    return {
                        imgBase64: obj.image,
                        titulo: obj.title,
                        descripcion: obj.description,
                        filtros: [obj.filter],
                        anchoPagina: '1200',
                        orientacion: '1'

                    };
                })
                .value();
        }

        function transformationPPT(data) {
            return _.chain(data)
                .map(function (obj) {
                    return {
                        imgBase64: obj.image,
                        elements: [
                            {
                                key: 'titulo',
                                value: obj.title || ' '
                            },
                            {
                                key: 'descripcion',
                                value: obj.description || ' '
                            }, {
                                key: 'filtros',
                                value: obj.filter.toString() || ' '
                            }, {
                                key: 'date',
                                value: new Date().toLocaleString()
                            }, {
                                key: 'nodo',
                                value: ' '
                            }
                        ]
                    };
                })
                .value();
        }

        function toString(data) {
            return angular.toJson(data);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.snapshots', {
                url: '/snapshots',
                views: {
                    content: {
                        templateUrl: 'app/snapshots/snapshots.html',
                        controller: 'SnapshotsController',
                        controllerAs: 'snapshots'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
'use strict';

    angular
        .module('app')
        .controller('SnapshotsController', SnapshotsController);

    SnapshotsController.$inject = ['snapshotsService','routingService','$state','errorHandlerService','$translate'];
    function SnapshotsController(snapshotsService,routingService,$state,errorHandlerService,$translate) {
        var vm = this;
        vm.snapshotsCollection = [];
        vm.selectedImage = null;
        vm.createPPT = createPPT;
        vm.clearAll = clearAll;
        vm.goBack = goBack;
        vm.lastState = routingService.getLastState();
        vm.update = update;
        vm.remove = remove;
        vm.exportingPPT = false;        

        init();

        /** private methods */

        function goBack() {
            $state.go(vm.lastState.state,vm.lastState.params);
        }

        function createPPT(collection) {
            vm.exportingPPT = true;
            return snapshotsService.exportPPT(collection)
            .catch(errorHandlerService.callbackError)
            .finally(function(){
                vm.exportingPPT = false;
            });
        }

        function clearAll() {
            snapshotsService.clearSnapshots();
            vm.snapshotsCollection = [];
            vm.selectedImage = null;
        }

        function update(obj) {
            var temp = angular.copy(vm.snapshotsCollection);
            var pre = obj.index > 0 ? _.slice(temp,0,obj.index): [];
            var post = obj.index < temp.length ? _.slice(temp,obj.index + 1): [];

            temp = [].concat(pre,obj,post);
            
            vm.snapshotsCollection = temp;
            vm.selectedImage = null;
            snapshotsService.setSnapshots(temp);
        }

        function remove(obj) {
            var temp = angular.copy(vm.snapshotsCollection);
            _.chain(temp).splice(obj.index,1).value();
            vm.snapshotsCollection = temp;
            vm.selectedImage = null;
            return snapshotsService.setSnapshots(temp);
        }

        function init() { 
            vm.snapshotsCollection = snapshotsService.getSnapshots();     

            //translate titles
            vm.snapshotsCollection = _.chain(vm.snapshotsCollection)
                .map(function (item) {
                    var title = item.title;
                    item.title = title;
                    return item;
                })
                .value();                    
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('suplementosService', suplementosService);

    /** @ngInject */
    function suplementosService($http, $q, errorHandlerService) {
        var service = {
            getRankData: getRankData,
            getPenData: getPenData,
            getPerData: getPerData
        };

        return service;

        ////////////////

        function getRankData(wave) {
            return $q.all([getRankSup(wave), getRankTotal(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPenData(wave) {
            return $q.all([getSupPenSex(wave), getSupPenEdad(wave), getSupPenNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPerData(wave) {
            return $q.all([getSupPerSex(wave), getSupPerEdad(wave), getSupPerNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getRankSup(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKSUPL",
                  "query": "RANKSUPL",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankTotal(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKSUPL",
                  "query": "TOTSUPL",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getSupPenSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "SUPENSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getSupPenEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "SUPENEDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getSupPenNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "SUPENNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getSupPerSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "SUPERSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getSupPerEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "SUPEREDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getSupPerNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "SUPERNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function transformData(data) {
            return data && data.data;
        }

        function parseData(data) {
            return data;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.suplementos', {
                url: '/suplementos',
                views: {
                    content: {
                        templateUrl: 'app/suplementos/suplementos.html',
                        controller: 'SuplementosController',
                        controllerAs: 'suplementosController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('SuplementosController', SuplementosController);

    /** @ngInject */  
    function SuplementosController(suplementosService, errorHandlerService, mainService, $rootScope, stateManagerService, $scope) {
        var vm = this;
        vm.id = 'suplementos';
        vm.selectedWave = null;
        vm.menuData = mainService.audienceDataState;
        vm.penWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.perWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.rankWidget = {
            loading: false,            
            rankSup: [],
            rankTotal: null
        };

        
        init();

        /** listeners */ 
        var changeWaveWatcher = $rootScope.$on('main:changeWave', init); 
 
        $scope.$on('$destroy', function () { 
            changeWaveWatcher(); 
        });


        ////////////////

        function init() {
            vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
            vm.rankWidget.rankWidgetFormatFn = copyRankWidgetToClipboard;
            vm.penWidget.penWidgetFormatFn =  copyPenWidgetToClipboard;
            vm.perWidget.perWidgetFormatFn =  copyPerWidgetToClipboard;
            if(vm.selectedWave && vm.selectedWave.fullWave) {
                getGeneralAudienceData();
                getRankData();
                getPenData();
                getPerData();
            }
        }

        function getGeneralAudienceData(){
            mainService.getAudienceData()
            .then(function(data) {
                vm.menuData = data;
            })
            .catch(suplementosError);
        }

        function getRankData() {
            vm.rankWidget.loading = true;
            suplementosService.getRankData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.rankWidget.rankSup = data[0];
                vm.rankWidget.rankTotal = data[1];

            })
            .catch(suplementosError)
            .finally(function(){ vm.rankWidget.loading = false; });
        }

        function getPenData() {
            vm.penWidget.loading = true;
            suplementosService.getPenData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.penWidget.sexo = data[0];
                vm.penWidget.edad = data[1];
                vm.penWidget.iso = data[2];
            })
            .catch(suplementosError)
            .finally(function(){ vm.penWidget.loading = false; });
        }

        function getPerData() {
            vm.perWidget.loading = true;
            suplementosService.getPerData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.perWidget.sexo = data[0];
                vm.perWidget.edad = data[1];
                vm.perWidget.iso = data[2];
            })
            .catch(suplementosError)
            .finally(function(){ vm.perWidget.loading = false; });
        }


        function suplementosError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyRankWidgetToClipboard(data) {
            var total = 'TOTAL LECTORES DE SUPLEMENTOS' + '\t' + data.rankTotal;
            var chartData = _.reduce(data.rankSup, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(total, chartData);
            return formattedData.join('\n');
        }

        function copyPenWidgetToClipboard(data) {
            var title = 'PENETRACIÓN POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

        function copyPerWidgetToClipboard(data) {
            var title = 'PERFIL POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad.text, function(aggr, item, index) {
                var row = item + '\t' + data.edad.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso.text, function(aggr, item, index) {
                var row = item + '\t' + data.iso.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('radioService', radioService);

    /** @ngInject */
    function radioService($http, $q, errorHandlerService) {
        var service = {
            getRankData: getRankData,
            getPenData: getPenData,
            getPerData: getPerData,
            getAudienceTypeData: getAudienceTypeData
        };

        return service;

        ////////////////

        /**
         * Obtenemos el rankig de radios
         *
         * @param {*} typeFilter opciones de 'ranking (rk)' o 'share (sh)'
         * @param {*} periodFilter opciones de 'Lunes a viernes (lv)' o 'Lunes a domingo (ld)'
         * @returns
         */
        function getRankData(typeFilter, periodFilter, wave) {
            return $q.all([
                getRadioTotal(typeFilter, periodFilter, wave),
                getRadioGeneralistaTotal(typeFilter, periodFilter, wave),
                getRadioGeneralistaGraphic(typeFilter, periodFilter, wave),
                getRadioTematicaTotal(typeFilter, periodFilter, wave),
                getRadioTematicaGraphic(typeFilter, periodFilter, wave)
            ])
            .then(parseRankingData)
            .catch(errorHandlerService.callbackError);
        }

        function getRadioTotal(typeFilter,periodFilter, wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                    "datasource": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'RANKRADIOLV' :'RANKRADIOLVS') : (typeFilter === 'rk' ? 'RANKRADIOLD' : 'RANKRADIOLDS'),
                    "query": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'LVTOTRAD' : 'LVTOTRADM') : (typeFilter === 'rk' ? 'LDTOTRAD' : 'LDTOTRADM'),
                    "parameters": { "$wave$": wave},
                    "transform": {
                        "template": "Evolution",
                        "parameters": {
                        "categories": "Columns",
                        "series": "Rows"
                        }
                    }
                }
            })
            .then(transformData)
            .then(function(data) {
                return { radioTotal: data };
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRadioGeneralistaTotal(typeFilter,periodFilter, wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                    "datasource": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'RANKRADIOLV' : 'RANKRADIOLVS') : (typeFilter === 'rk' ? 'RANKRADIOLD' : 'RANKRADIOLDS'),
                    "query": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'LVTOTRADGEN' : 'LVTOTRADGENM') : (typeFilter === 'rk' ? 'LDTOTRADGEN' : 'LDTOTRADGENM'),
                    "parameters": { "$wave$": wave},
                    "transform": {
                        "template": "Evolution",
                        "parameters": {
                        "categories": "Columns",
                        "series": "Rows"
                        }
                    }
                }
            })
            .then(transformData)
            .then(function(data) {
                return { radioGeneralistaTotal: data };
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRadioGeneralistaGraphic(typeFilter,periodFilter, wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                    "datasource": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'RANKRADIOLV' : 'RANKRADIOLVSGEN') : (typeFilter === 'rk' ? 'RANKRADIOLD' : 'RANKRADIOLDSGEN'),
                    "query": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'LVRANKGEN' : 'LVRANKGENS') : (typeFilter === 'rk' ? 'LDRANKGEN' : 'LDRANKGENS'),
                    "parameters": { "$wave$": wave},
                    "transform": {
                        "template": "Evolution",
                        "parameters": {
                        "categories": "Columns",
                        "series": "Rows"
                        }
                    }
                }
            })
            .then(transformData)
            .then(function(data) {
                var series = data.series ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
                return { generalistaGraphic: series };
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRadioTematicaTotal(typeFilter,periodFilter, wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                    "datasource": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'RANKRADIOLV' : 'RANKRADIOLVS') : (typeFilter === 'rk' ? 'RANKRADIOLD' : 'RANKRADIOLDS'),
                    "query": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'LVTOTRADTEM' : 'LVTOTRADTEMM') : (typeFilter === 'rk' ? 'LDTOTRADTEM' : 'LDTOTRADTEMM'),
                    "parameters": { "$wave$": wave},
                    "transform": {
                        "template": "Evolution",
                        "parameters": {
                        "categories": "Columns",
                        "series": "Rows"
                        }
                    }
                }
            })
            .then(transformData)
            .then(function(data) {
                return { radioTematicaTotal: data };
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRadioTematicaGraphic(typeFilter,periodFilter, wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                    "datasource": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'RANKRADIOLV' : 'RANKRADIOLVSTEM') : (typeFilter === 'rk' ? 'RANKRADIOLD' : 'RANKRADIOLDSTEM'),
                    "query": periodFilter === 'lv' ? (typeFilter === 'rk' ? 'LVRANKTEM' : 'LVRANKTEMS') : (typeFilter === 'rk' ? 'LDRANKTEM' : 'LDRANKTEMS'),
                    "parameters": { "$wave$": wave},
                    "transform": {
                        "template": "Evolution",
                        "parameters": {
                        "categories": "Columns",
                        "series": "Rows"
                        }
                    }
                }
            })
            .then(transformData)
            .then(function(data) {
                var series = data.series ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
                return { tematicaGraphic: series };
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function parseRankingData(parsedRes) {
            // Array of objects to a single object
            return _.reduce(parsedRes, function(aggr, item) {
                return _.assign(aggr, item);
            }, {});
        }

        function getAudienceTypeData(periodFilter, wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                    "datasource": periodFilter === 'lv' ? 'RANKRADIOLV' : 'RANKRADIOLD',
                    "query": periodFilter === 'lv' ? 'LVESTRUCRAD' : 'LDESTRUCRAD',
                    "parameters": { "$wave$": wave},
                    "transform": {
                        "template": "Evolution",
                        "parameters": {
                        "categories": "Columns",
                        "series": "Rows"
                        }
                    }
                }
            })
            .then(transformData)
            .then(function(data) {
                var series = _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                });
                return { audienceType: series };
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getPenData(wave) {
            return $q.all([getRaPenSex(wave), getRaPenEdad(wave), getRaPenNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPerData(wave) {
            return $q.all([getRaPerSex(wave), getRaPerEdad(wave), getRaPerNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getRaPenSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "RAPENSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value();
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRaPenEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "RAPENEDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value();
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRaPenNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "RAPENNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value();
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRaPerSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "RAPERSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value();
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRaPerEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "RAPEREDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                };
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRaPerNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "RAPERNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                };
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function transformData(data) {
            return data && data.data;
        }

        function parseData(data) {
            return data;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.radio', {
                url: '/radio',
                views: {
                    content: {
                        templateUrl: 'app/radio/radio.html',
                        controller: 'RadioController',
                        controllerAs: 'radioController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('RadioController', RadioController);

    /** @ngInject */  
    function RadioController(radioService, errorHandlerService, mainService, $rootScope, stateManagerService, $scope) {
        var vm = this;

        var selectedRankingType, selectedRankingPeriod, selectedAudiencePeriod;

        vm.id = 'radio';
        vm.selectedWave = null;
        vm.menuData = mainService.audienceDataState;
        vm.penWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.perWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.ranking = {
            loading: false,
            total: null,
            generalista: {
                total: null,
                series: []
            },
            tematica: {
                total: null,
                series: []
            }
        };
        vm.audience = {
            loading: false,
            series: []
        };

        vm.filters = {
            w1:[{ 
                comboId:'type',
                selected:null,
                childs:[
                    { id:'rk', text: 'Audiencia Acumulada', title: 'AUDIENCIA', subtitle:'Oyentes/dia (000)' },
                    { id:'sh', text: 'Share', title: 'SHARE', subtitle:'Minutos por persona y dia' }
                ]
            },{ 
                comboId:'period',
                selected:null,
                childs:[
                    { id:'ld', text: 'Lunes a domingo' },
                    { id:'lv', text: 'Lunes a viernes' }
                    
                ]
            }],
            w2:[{ 
                comboId:'period',
                selected:null,
                childs:[
                    { id:'ld', text: 'Lunes a domingo' },
                    { id:'lv', text: 'Lunes a viernes' }
                ]
            }]
        };

        /** listeners */ 
        var changeWaveWatcher = $rootScope.$on('main:changeWave', function() { init(true); }); 
        var changeFilterRankingTypeWatcher = $rootScope.$on('odecFilterHeader:selectFilter:radioRanking:type', function(event, value) {
            if (value.id === selectedRankingType) { return; }
            selectedRankingType = value.id;
            vm.filters.w1[0].selected = value;
            getRankData();
        });
        var changeFilterRankingPeriodWatcher = $rootScope.$on('odecFilterHeader:selectFilter:radioRanking:period', function(event, value) {
            if (value.id === selectedRankingPeriod) { return; }
            selectedRankingPeriod = value.id;
            vm.filters.w1[1].selected = value;
            getRankData();
        });
        var changeFilterAudiencePeriodWatcher = $rootScope.$on('odecFilterHeader:selectFilter:radioAudience:period', function(event, value) {
            if (value.id === selectedAudiencePeriod) { return; }
            selectedAudiencePeriod = value.id;
            vm.filters.w2[0].selected = value;
            getAudienceData();
        });
 
        $scope.$on('$destroy', function () { 
            changeWaveWatcher();
            changeFilterRankingTypeWatcher();
            changeFilterRankingPeriodWatcher();
            changeFilterAudiencePeriodWatcher();
        });


        ////////////////

        // hasWaveChange: Solo queremos que obtenga los datos de ranking y audiencia
        // una vez tenga seleccionado el filtro de perido A MENOS que haya un cambio de ola
        function init() {
            vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
            vm.filters.w1[0].selected = vm.filters.w1[0].childs[0];
            vm.filters.w1[1].selected = vm.filters.w1[1].childs[0];
            vm.filters.w2[0].selected = vm.filters.w2[0].childs[0];
            vm.ranking.rankWidgetFormatFn =  copyRankWidgetToClipboard;
            vm.audience.audienceWidgetFormatFn =  copyAudienceWidgetToClipboard;
            vm.penWidget.penWidgetFormatFn =  copyPenWidgetToClipboard;
            vm.perWidget.perWidgetFormatFn =  copyPerWidgetToClipboard;
            if(vm.selectedWave && vm.selectedWave.fullWave) {
                getGeneralAudienceData();
                getRankData();
                getAudienceData();
                getPenData();
                getPerData();
            }
        }

        init();

        function getGeneralAudienceData(){
            mainService.getAudienceData()
            .then(function(data) {
                vm.menuData = data;
            })
            .catch(radioError);
        }

        function getRankData()  {
            vm.ranking.loading = true;
            radioService.getRankData(vm.filters.w1[0].selected.id, vm.filters.w1[1].selected.id, vm.selectedWave.fullWave)
            .then(function(data) {
                vm.ranking.total = data.radioTotal ? data.radioTotal : null;
                vm.ranking.generalista.total = data.radioGeneralistaTotal ? data.radioGeneralistaTotal : null;
                vm.ranking.generalista.series = data.generalistaGraphic ? data.generalistaGraphic : null;
                vm.ranking.tematica.total = data.radioTematicaTotal ? data.radioTematicaTotal : null;
                vm.ranking.tematica.series = data.tematicaGraphic ? data.tematicaGraphic : null;
            })
            .catch(radioError)
            .finally(function(){ vm.ranking.loading = false; });
        }

        function getAudienceData() {
            vm.audience.loading = true;
            radioService.getAudienceTypeData(vm.filters.w2[0].selected.id, vm.selectedWave.fullWave)
            .then(function(data) {
                vm.audience.series = data.audienceType ? data.audienceType : null;
            })
            .catch(radioError)
            .finally(function() { vm.audience.loading = false; });
        }

        function getPenData() {
            vm.penWidget.loading = true;
            radioService.getPenData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.penWidget.sexo = data[0];
                vm.penWidget.edad = data[1];
                vm.penWidget.iso = data[2];
            })
            .catch(radioError)
            .finally(function(){ vm.penWidget.loading = false; });
        }

        function getPerData() {
            vm.perWidget.loading = true;
            radioService.getPerData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.perWidget.sexo = data[0];
                vm.perWidget.edad = data[1];
                vm.perWidget.iso = data[2];
            })
            .catch(radioError)
            .finally(function(){ vm.perWidget.loading = false; });
        }


        function radioError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyRankWidgetToClipboard(data) {
            var total = 'TOTAL RADIO' + '\t' + data.total;
            var title1 = 'TOTAL RADIO GENERALISTA' + '\t' + data.generalista.total;
            var title2 = 'TOTAL RADIO TEMÁTICA' + '\t' + data.tematica.total;
            var chart1Data = _.reduce(data.generalista.series, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.tematica.series, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(total, title1, chart1Data, title2, chart2Data);
            return formattedData.join('\n');
        }

        function copyAudienceWidgetToClipboard(data) {
            var title = 'RADIO TEMÁTICA POR CONTENIDOS';
            var chartData = _.reduce(data.series, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title, chartData);
            return formattedData.join('\n');
        }

        function copyPenWidgetToClipboard(data) {
            var title = 'PENETRACIÓN POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

        function copyPerWidgetToClipboard(data) {
            var title = 'PERFIL POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad.text, function(aggr, item, index) {
                var row = item + '\t' + data.edad.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso.text, function(aggr, item, index) {
                var row = item + '\t' + data.iso.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.politicaPrivacidad', {
                url: '/politicaPrivacidad',
                views: {
                    content: {
                        templateUrl: 'app/politicaPrivacidad/politicaPrivacidad.html',
                        controller: 'politicaPrivacidadController',
                        controllerAs: 'politicaPrivacidadController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function () {
  "use strict";

  angular
    .module("app")
    .controller("PoliticaPrivacidadController", PoliticaPrivacidadController);

  /** @ngInject */
  function PoliticaPrivacidadController(
    internetService,
    errorHandlerService,
    $http,
    configurationLoaderService,
    mainService,
    $rootScope,
    stateManagerService,
    $scope
  ) {}
})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('mainService', mainService);

  /** @ngInject */
  function mainService(configurationLoaderService, $http, stateManagerService) {

    var waveCollection = {
      data: [],
      selected: null
    };
    var audienceDataState = [];
    /** methods exposed */
    var service = {
      getAvailableWaves: getAvailableWaves,
      audienceDataState: audienceDataState,
      getAudienceData: getAudienceData
    };

    return service;

    /** private methods */

    function getAvailableWaves() {
      // TODO: /api/crosstab/v2/waves
      return $http({
        method: 'GET',
        //url:'./data/waves.json'
        url: './crosstab/metadata/AIMC/waves'
      }).then(transformAvailableWaves);
    }

    function transformAvailableWaves(data) {

      if (!data || !data.data || !data.data.data) {
        throw ('not waves');
      }
      waveCollection.data = _.reduce(data.data.data, function (aggr, item) {
        var waveObject = {
          wave: null,
          year: null,
          availableWaves: []
        };
        var year = item.toString().substr(0, 4);
        var wave = item.toString().substr(4, 2);
        var existingYear = _.find(aggr, { 'year': year });
        if (existingYear) {
          existingYear.availableWaves.push(wave);
        }
        else {
          waveObject.wave = wave;
          waveObject.year = year;
          waveObject.availableWaves.push(wave);
          aggr.push(waveObject);
        }
        return aggr;
      }, []);

      waveCollection.selected = _.first(waveCollection.data);
      waveCollection.selected.wave = _.first(waveCollection.selected.availableWaves);
      waveCollection.selected.fullWave = waveCollection.selected.year+waveCollection.selected.wave;
      stateManagerService.setState('waveCollection', waveCollection);
      return waveCollection;
    }


    function getAudienceData() {
      return $http({
        method: 'POST',
        url: './crosstab/operations/AIMC/extract',
        data: {
          "datasource": "ESTRUC",
          "query": "GENERAL",
          "parameters": {
            "$wave$": stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected && stateManagerService.getState('waveCollection').selected.fullWave
          },
          "transform": {
            "template": "Evolution",
            "parameters": {
              "categories": "Columns",
              "series": "Rows"
            }
          }
        }
      })
        .then(transformData);
    }

    function transformData(data) {
      var configData = configurationLoaderService.getConfig().moduleInfo;
      var transformedData = _.reduce(data.data.series, function (aggr, item) {
        //var configObject = _.find(configData, { 'id': item.id });
        var configObject = _.find(configData, function(config) {
          return _.includes(config.id, item.id);
        });
        if (configObject) {
          configObject = _.extend({}, configObject, { value: item && item.values && item.values.length > 0 && parseFloat(item.values[0]) });
          aggr.push(configObject);
        }
        return aggr;
      }, []);
      service.audienceDataState = _.orderBy(transformedData, 'value', 'desc');
      return service.audienceDataState;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];
  function routerConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        resolve: {
          configuration: getConfiguration,
          getAvailableWaves: getAvailableWaves,
          listenToResize: listenToResize,
          getAudienceData: getAudienceData
        },
        public:true
      });
  }

  getConfiguration.$inject = ['errorHandlerService', 'configurationLoaderService', '$q'];
  function getConfiguration(errorHandlerService, configurationLoaderService, $q) {
    return configurationLoaderService.getRemoteConfig()
      .catch(errorHandlerService.callbackError);
  }

  getAvailableWaves.$inject = ['mainService'];
  function getAvailableWaves(mainService) {
    return mainService.getAvailableWaves();
  }

  getAudienceData.$inject = ['mainService','getAvailableWaves'];
  function getAudienceData(mainService, getAvailableWaves) {
    return mainService.getAudienceData();
  }

  listenToResize.$inject = ['windowResizeManagerService'];
  function listenToResize(windowResizeManagerService) {
    return windowResizeManagerService.startListening();
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('MainController', MainController);

  MainController.$inject = ['$timeout','$scope','$state','configurationLoaderService','mainService','errorHandlerService', '$rootScope', 'stateManagerService'];
  function MainController($timeout, $scope, $state, configurationLoaderService, mainService, errorHandlerService, $rootScope, stateManagerService) {
    var vm = this;    
    vm.filterOpened = false;
    vm.waves = stateManagerService.getState('waveCollection');
    vm.changeWave = changeWave;
    vm.audienceData = mainService.audienceDataState;

    init();

    /** listeners */ 
    var changeWaveWatcher = $rootScope.$on('main:changeWave', function(event, args){
      changeWave(args);
    }); 

    $scope.$on('$destroy', function () { 
        changeWaveWatcher(); 
    });
      
    /** private methods */

    function init() {
        vm.puppeter = false; 
        $timeout(function() {
          vm.puppeter = true;
        },10000);
    }

    function changeWave( _wave ) {
      vm.filterOpened = false;
      vm.waves.selected.wave = _wave.wave;
      vm.waves.selected.year = _wave.year;
      vm.waves.selected.availableWaves = _wave.availableWaves;
      vm.waves.selected.fullWave = _wave.year+_wave.wave;
      stateManagerService.setState('waveCollection', vm.waves);
    }    
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('loginService', loginService);

    loginService.inject = ['$http', 'moment', 'storageService', 'errorHandlerService', 'configurationLoaderService', '$q', 'globalHelpersService', 'filterService', 'filterViewConfigurationService', 'userHelperService', 'filterHelperService'];
    function loginService($http, moment, storageService, errorHandlerService, configurationLoaderService, $q, globalHelpersService, filterService, filterViewConfigurationService, userHelperService, filterHelperService) {
        var service = {
            loginFullWorkflow: loginFullWorkflow,
            loginFullWorkflowWithToken:loginFullWorkflowWithToken,
            getUser: getUser,
            setUser: setUser,
            getToken: getToken,
            getUserLanguage: getUserLanguage,
            setMomentLocale: setMomentLocale,
            hasUserRole:hasUserRole,
            hasNetworkRole: hasNetworkRole,
            setDateFormat:setDateFormat,
            saveToStorage:saveToStorage
        };

        var user;

        return service;

        /** private methods */
        function loginFullWorkflow(username, password) {
            return $q.when(clearLocalstorage())
                .then(function () { return login(username, password); })
                .then(getUserInfo)
                .then(setLanguage)
                .then(getFilter)
                .then(postLoginOperations)
                .then(saveToStorage);
                //.catch(errorHandlerService.callbackError);

        }

        function loginFullWorkflowWithToken(token) {
            return $q.when(clearLocalstorage())
                .then(configurationLoaderService.getRemoteConfig)
                .then(function () { return loginWithToken(token); })
                .then(getUserInfo)
                .then(setLanguage)
                .then(getFilter)
                .then(postLoginOperations)
                .then(saveToStorage)
                .catch(errorHandlerService.callbackError);
        }


        // login error
        function login(user, password) {
            return $http({
                method: 'POST',
                url: './api/users/globalLogin',
                data: {
                    user: user,
                    password: password,
                    project: configurationLoaderService.getConfig().project,
                    context: configurationLoaderService.getConfig().context,
                    timezoneoffset: moment.parseZone(new Date()).utcOffset()
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                transformRequest: globalHelpersService.httpPostParamsPrepare,
                transformResponse: $http.defaults.transformResponse.concat([transformProperties])
            });
        }

        function loginWithToken(token) {
           return $http({
                method: 'GET',
                url: './api/users/globalLoginByToken',
                params: {
                    token:token
                },
                transformResponse: $http.defaults.transformResponse.concat([transformProperties])
            });
        }

        // transforms hashmap from backend to object
        function transformProperties(data, header, status) {
            if (status >= 400 && data.message) {
                return data;
            }

            data.profile = _.reduce(data.properties, function (aggr, item, index) {
                var key = item.name,
                    value = item.value;

                aggr[key] = value;
                return aggr;
            }, {});

            return data;
        }

        // operations to do on user object before saving
        function postLoginOperations(data) {
            var user = data.user;
            var filter = data.filter;

            user.networkRoles = [];
            
            //Is HQ?
            if(filterHelperService.isHQ(filter)){
                user.networkRoles.push('IS_HQ');
            }

            return user;
        }

        /**
         * clear localstorage
         * 
         * @returns
         */
        function clearLocalstorage() {
            return storageService.clear();
        }

        /**
         * save user to localStorage
         * 
         * @param {any} userData
         * @returns
         */
        function saveToStorage(userData) {
            user = userData;
            return storageService.save('user', user);
        }

        /**
         * getter user variable
         * 
         * @returns
         */
        function getUser() {
            return user;
        }

        function hasUserRole(role) {
            return _.chain(user.roles).find({code:role}).some().value();
        }

        function hasNetworkRole(role){
            return _.indexOf(user.networkRoles, role) > -1;
        }

        /**
         * setter user variable
         * 
         * @param {any} _user
         */
        function setUser(_user) {
            user = _user;
        }

        /**
         * getter for token
         * 
         * @returns
         */
        function getToken() {
            return ''; // user.value;
        }

        /**
         * getter for user language
         * 
         * @returns language
         */
        function getUserLanguage() {
            return 'es'; // user.profile.language;
        }

        /**
         * set momentjs locale
         * 
         * @param {any} localeCode
         * @returns
         */
        function setMomentLocale(localeCode) {
            return moment.locale(localeCode);
        }

        /**
         * Get userInfo
         * 
         * @param {any} user
         * @returns user
         */
        function getUserInfo(user) {
            return $http({
                method: 'get',
                url: './api/users/user',
                params: {
                    token: user.data.value,
                    user: user.data.profile.LOGIN,
                    projectCode: user.data.userListExternalProjectName
                },
                transformResponse: $http.defaults.transformResponse.concat([addUserInfo.bind(user.data)])
            });
        }

        /**
         * Get userInfo attributes and reformat from hashmap to object and include it in user to persist
         * 
         * @param {any} response from api
         * @returns user
         */
        function addUserInfo(data) {
            var user = this;
            var userInfoAttrObj = _.chain(data.attributes)
                .reduce(function (aggr, item, index) {
                    var key = item.userAttributeDefinition.attributeDefinition.name;
                    var value = item.value;
                    aggr[key] = value;
                    return aggr;
                }, {})
                .value();

            var userInfo = _.extend({}, data, { attrs: userInfoAttrObj });
            return _.extend({},user,{userInfo:userInfo});
        }


        function setDateFormat(user) {
            return $http({method:'GET',url:'./api/alerts/info/shortDateFormat',params:{token:user.value,languageCode:user.profile.language}})
                .then(function(data) {
                    if (!data.data || !data.data.response) {
                        return $q.when(user);    
                    }
                    user.profile.dateLocaleFormat = data.data.response.toUpperCase();                            
                    return $q.when(user);
                })
                .catch(function(){
                    return $q.when(user);
                });
        }

        /**
         * Uses userinfo attributes to get language+variant and set moment locale
         * 
         * @param {any} user
         * @returns user
         */
        function setLanguage(userdata) {
            var user = userdata.data,
                lang = user.userInfo.attrs.LANGUAGE,
                variant = user.userInfo.attrs.VARIANT;
            user.profile.language = variant ? lang.toLowerCase() + '_' + variant.toUpperCase() : lang.toLowerCase();

            // set moment.js locale to be able to format dates            
            setMomentLocale(user.profile.language);

            return user;
        }

        /**
         * Loading the filter to add 'position roles' to the
         * user (is HQ?, ...)
         */
        function getFilter(user){
            storageService.save('user', user);

            var loginFilter = filterViewConfigurationService.getFilterDefinition('loginFilter');
            return filterService.getData(loginFilter, false, true, false)
            .then(function(filter){ return {user: user, filter: filter};  });
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'login',
        resolve: {
          configuration: getConfiguration,
          transition: ['$timeout', function ($timeout) {
            return $timeout(function () { }, 3000);
          }]

        },
        public:true
      });
  }

  /* @ngInject */
  function getConfiguration(errorHandlerService, configurationLoaderService, $timeout, $q) {
    return $timeout(function () { errorHandlerService.log('log', 'Ended timeout'); }, 3000)
      .then(function () {
        return $q.all([configurationLoaderService.getRemoteConfig()]);
      })
      .then(function () {
        errorHandlerService.log('log', 'configuration loaded');
      })
      .catch(errorHandlerService.callbackError);
  }


})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['errorHandlerService','loginService','$state','configurationLoaderService','storageService','filterService'];
  function LoginController(errorHandlerService,loginService,$state,configurationLoaderService,storageService,filterService) {

    errorHandlerService.log('log','Enter login Controller');

    var vm = this;
    vm.login = login;
    vm.errorMessage = '';
    vm.loading= false;

    //forgot password url
    vm.config = configurationLoaderService.getConfig();
    vm.forgotpass = '../userManagement/?project='+vm.config.project+'&context='+vm.config.context+'&return=/';

    // login('total','odec');
    /** private methodes */
    function login(username,password) {
      vm.loading = true;

      // the same cleaning as in logout just in case 
      // the user arrives to login page without doing
      // logout
      storageService.clear();
      filterService.clearContext();

      // full login workflow
      return loginService.loginFullWorkflow(username,password)
              .then(moveOnLogin)
              .catch(onAuthenticationError)
              .finally(function(){
                vm.loading = false;
              });
    }

    function moveOnLogin() {
      $state.go.apply(null,[vm.config.onAuthenticationState.url,vm.config.onAuthenticationState.state]);
    }

    function onAuthenticationError(error) {
      errorHandlerService.log('error',error);
      vm.errorMessage = error.data && error.data.error || error.data && error.data.message || '';
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('internetService', internetService);

    /** @ngInject */
    function internetService($http, $q, errorHandlerService) {
        var service = {
            getRankData: getRankData,
            getPenData: getPenData,
            getPerData: getPerData,
            getEvoChartData: getEvoChartData
        };

        return service;

        ////////////////

        function getPenData(wave) {
            return $q.all([getInPenSex(wave), getInPenEdad(wave), getInPenNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPerData(wave) {
            return $q.all([getInPerSex(wave), getInPerEdad(wave), getInPerNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getEvoChartData(wave) {
            var absData;

            return getEvoChartDataAbs(wave)
                .then(function(data) {
                    absData = data;
                    return getEvoChartDataPercent(wave);
                })
                .then(function(percentData) {
                    return parseData([absData, percentData]);
                })
                .catch(errorHandlerService.callbackError);
        }


        function getRankData(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKINTER",
                  "query": "RANKINTER",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getInPenSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "INPENSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getInPenEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "INPENEDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getInPenNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "INPENNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getInPerSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "INPERSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getInPerEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "INPEREDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getInPerNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "INPERNISE",
                  "parameters": {"$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getEvoChartDataAbs(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "EVINTERNET",
                  "query": "EVINTERNET",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    categories: _.flatMap(data.categories, 'text'),
                    series: _.map(data.series[0].values, function(item){ return parseFloat(item);})
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getEvoChartDataPercent(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "EVINTERNET",
                  "query": "EVINTERNETP",
                  "parameters": {"$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    categories: _.flatMap(data.categories, 'text'),
                    series: _.map(data.series[0].values, function(item){ return parseFloat(item);})
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function transformData(data) {
            return data && data.data;
        }

        function parseData(data) {
            return data;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.internet', {
                url: '/internet',
                views: {
                    content: {
                        templateUrl: 'app/internet/internet.html',
                        controller: 'InternetController',
                        controllerAs: 'internetController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('InternetController', InternetController);

    /** @ngInject */
    function InternetController(internetService, errorHandlerService, $http, configurationLoaderService, mainService, $rootScope, stateManagerService, $scope) {
        var vm = this;
        vm.id = 'internet';
        vm.selectedWave = null;
        vm.menuData = mainService.audienceDataState;
        vm.penWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.perWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.rankWidget = {
            loading: false,            
            rankInter: []
        };
        vm.evoChartWidget = {
            loading: false,
            data: null,
            config: null
        };

        init();

        /** listeners */ 
        var changeWaveWatcher = $rootScope.$on('main:changeWave', init); 
 
        $scope.$on('$destroy', function () { 
            changeWaveWatcher(); 
        });

        ////////////////

        function init() {
            vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
            vm.rankWidget.rankWidgetFormatFn =  copyRankWidgetToClipboard;
            vm.evoChartWidget.evoChartWidgetFormatFn =  copyEvoChartWidgetToClipboard;
            vm.penWidget.penWidgetFormatFn =  copyPenWidgetToClipboard;
            vm.perWidget.perWidgetFormatFn =  copyPerWidgetToClipboard;
            if(vm.selectedWave && vm.selectedWave.fullWave) {
                getGeneralAudienceData();
                getRankData();
                getPenData();
                getPerData();
                vm.evoChartConfig = angular.copy(getConfigColumn());
                getEvoChart();
            }
        }

        function getGeneralAudienceData(){
            mainService.getAudienceData()
            .then(function(data) {
                vm.menuData = data;
            })
            .catch(internetError);
        }

        function getRankData() {
            vm.rankWidget.loading = true;
            internetService.getRankData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.rankWidget.rankInter = data;
            })
            .catch(internetError)
            .finally(function(){ vm.rankWidget.loading = false; });
        }

        function getPenData() {
            vm.penWidget.loading = true;
            internetService.getPenData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.penWidget.sexo = data[0];
                vm.penWidget.edad = data[1];
                vm.penWidget.iso = data[2];
            })
            .catch(internetError)
            .finally(function(){ vm.penWidget.loading = false; });
        }

        function getPerData() {
            vm.perWidget.loading = true;
            internetService.getPerData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.perWidget.sexo = data[0];
                vm.perWidget.edad = data[1];
                vm.perWidget.iso = data[2];
            })
            .catch(internetError)
            .finally(function(){ vm.perWidget.loading = false; });
        }

        function getEvoChart() {
            var collection = configurationLoaderService.getConfig().internetEvo;
            vm.evoChartWidget.loading = true;
            internetService.getEvoChartData(vm.selectedWave.fullWave)
            .then(function(data) {
                collection.categories =  data[0].categories;
                collection.series[0].data = data[0].series;
                collection.series[1].data = data[1].series;
                vm.evoChartWidget.data = collection;
            })
            .catch(internetError)
            .finally(function(){ vm.evoChartWidget.loading = false; });
        }

        function getConfigColumn() {

            return {
                chart: {
                    type: 'line',
                    spacingBottom: 20
                },
                title: null,
                yAxis: [{
                    min: 0,
                    ceiling: 100,
                    title: null,
                    labels: {
                        formatter: function () {
                            var vm = this;
                            return vm.value + ' %';
                        }/*,
                        format:'{point.y:,.1f} %'*/
                    }
                },{
                    min: 0,
                    ceiling: 40000,
                    title: null,
                    labels: {
                        formatter: function () {
                            var vm = this;
                            return vm.value/1000 + ' M';
                        }/*,
                        format:'{point.y:,.1f} %'*/
                    },
                    opposite: true
                }],
                xAxis: {
                    enableMouseTracking: true

                },
                tooltip: {
                    enabled: true,
                    backgroundColor: '#ffffff',
                    shared: true,
                    crosshairs: true,
                    useHTML: true,
                    headerFormat: '<div style="font-size: 18px; margin-left: 10px;"> Año {point.key} </div>',
                    pointFormat: '<span"> <a style="font-size: 13px; color:{series.color};">●</a> <b> {series.name}: {point.y}</b><br/>',
                    style: {
                        fontFamily: 'Montserrat'
                    }
                },

                plotOptions: {

                    series: {
                        borderRadius: 10,
                        point: {
                            events: {
                                mouseOut: function (e) {
                                    var vm = this;
                                    vm.dataLabel.css({
                                        fontSize: "0px"
                                    });
                                },
                                mouseOver: function (e) {
                                    var vm = this;
                                    vm.dataLabel.css({
                                        fontSize: "11px"
                                    });
                                }
                            }
                        },

                        dataLabels: {
                            enabled: true,
                            align: 'center',
                            style: { fontSize: '0px' },
                            states: {
                                hover: {
                                    enabled: true
                                }
                            }
                        }
                    },

                    line: {
                        marker: {
                            enabled: true,
                            symbol: 'circle',
                            radius: 0
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: true
                }

            };

        }

        function internetError(error) {
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyRankWidgetToClipboard(data) {
            var title = 'RANKING TIPOLOGÍA DE SOPORTES DE INTERNET' + '\t';
            var chartData = _.reduce(data.rankInter, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title, chartData);
            return formattedData.join('\n');
        }

        function copyEvoChartWidgetToClipboard(data) {
            var title = 'EVOLUCIÓN DEL USO DE INTERNET AYER';
            var columns = '\t';
            _.forEach(data.categories, function(item) { columns = columns + item + '\t';});
            var formattedData = _.reduce(data.series, function(aggr, item) {
                var row = item.name + '\t';
                _.forEach(item.data, function(item) { row = row + item.toLocaleString() + '\t';});
                aggr.push(row);
                return aggr;
                }, []);
            var totalData = [].concat(title,columns, formattedData);
            return totalData.join('\n');
        } 

        function copyPenWidgetToClipboard(data) {
            var title = 'PENETRACIÓN POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

        function copyPerWidgetToClipboard(data) {
            var title = 'PERFIL POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad.text, function(aggr, item, index) {
                var row = item + '\t' + data.edad.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso.text, function(aggr, item, index) {
                var row = item + '\t' + data.iso.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('waveFilterService', waveFilterService);

    /** @ngInject */
    function waveFilterService($http, userHelperService, $translate, filterHelperService,$filter,$q) {
        var service = {
            getFilter: getFilter,
            getWave:getWave,
            changeListener:function() {alert('wave');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(options) {
            context = this;
            if (!context.project) {
                return $q.when(null);
            }
            return getWave(options);
        }

        function getWave(options) {
            var params = {
                token: userHelperService.getToken(),
                project: filterHelperService.projectCodeManager(context.project, 'ESTU_NETWORK', 'ESTU_FRONT')
            };
            return $http({
                method: 'GET',
                url: './api/Entrevistas/getWaves',
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            return {
                type:'select2',
                name: 'Wave',
                label: 'Wave',
                viewLabel: 'FILTER_WAVE',
                datos: _.map(angular.fromJson(data).response, function (item) {
                    return {
                        id: item.toString(),
                        text: $filter('waveToDate')(item.toString())
                    };
                }),
                selectedNode: this && this.notPreselected && !context.wave? null :createPreselections(data, context.wave),
                notRemovable: true
            };
        }

        function createPreselections(data, preselection) {
            var lastItem;
            if (preselection) {
                return preselection;
            }

            lastItem = _.last(data.response).toString();
            context.wave = lastItem.toString();
            return lastItem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('questionFilterService', questionFilterService);

    /** @ngInject */
    function questionFilterService($http, $translate, filterHelperService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };

        var context;

        return service;

        /** private methods */

        function getFilter(options) {
            context = this;
            return getQuestion(options);
        }

        function getQuestion(options) {
            var file = (options && options.file) || 'questionFilter.json';
            return $http({
                method: 'GET',
                url:'./data/' + file,
                transformResponse: $http.defaults.transformResponse.concat([transformData])
            });
        }

        function transformData(data) {
                               
            return {
                type:'select2',
                name: 'Question',
                label: 'Question',
                viewLabel: 'FILTER_QUESTION',
                datos: getDataByCountryandSurvey(data),
                selectedNode: createPreselections(data, context.question)
            };
        }

        /**
        ** Questions are different by country and survey selected
        **/
       function getDataByCountryandSurvey(data){
            //survey selected
            var survey = filterHelperService.projectCodeManager(context.project, 'ESTU_NETWORK', 'ESTU_FRONT').toLowerCase();
            //country selected
            var country='';

           //if country or below is selected
            if(filterHelperService.isCountrySelected(context._tmp))
            {
                country = filterHelperService.getCountrySelectedExternalId(context._tmp);
            }
            

           var dataFiltered =
                _.chain(data)
                .map(function (item) {
                    var indexOfSurvey = _.chain(item.surveys).indexOf(survey).value();
                    var indexOfCountry = -1;
                    //if array of countries is greater than 0 is because this is a country specific question, other case is Global question
                    if(item.countries.length > 0) {
                       indexOfCountry = _.chain(item.countries).indexOf(country).value();
                    }
                    else
                    {
                        indexOfCountry = 0;
                    } 

                    //if the question exists for the survey, such as global or country specific, then, add item
                    if(indexOfSurvey >= 0 && indexOfCountry >= 0) {
                        return {
                            id: item.id,
                            text: $translate.instant(item.text+"_"+survey+"_"+"LABEL"),
                            visible:true
                        };
                    }
                    else {
                        return{
                            visible:false
                        };
                    }
                })
                .filter({visible: true}).value();
           
           //return only visible items
           return dataFiltered;
       }

        function createPreselections(data, preselection) {
            var first;
            if (preselection) {
                return preselection;
            }

            first = data[0].id;
            context.question = first;
            return first;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('projectFilterService', projectFilterService);

    /** @ngInject */
    function projectFilterService($http, userHelperService,$translate,configurationLoaderService,filterHelperService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo,
            changeListener:function() {alert('project');}
        };

        var context;

        return service;

        /** private methods */

        function getFilter(options) {
            context = this;
            return getProject(options);        
        }

        function getProject(options) {
            var params = {
                token: userHelperService.getToken(),
                context: context.context || configurationLoaderService.getConfig().context
            };
            return $http({
                method: 'GET',
                url: './api/Entrevistas/projectsByContext',
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            var that = this;
            
            var filteredProjects = data.response;

            if(that && that.filter)
            {
                filteredProjects = filterProjects(data, that.filter);
            }

            return {
                type:'select2',
                name: 'Project',
                label: 'Survey',
                viewLabel: 'FILTER_SURVEY',
                allowClear: this && this.allowClear || false,
                datos: _.map(filteredProjects, function (item) {
                    return {
                        id: item.globalNetworkName,
                        text: $translate.instant(item.label)
                    };
                }),
                selectedNode: this && this.notPreselected && !context.project? null:createPreselections(data,context.project)
            };
        }

        function createPreselections(data,preselection) {
            if (preselection) {
                return preselection;
            }

            context.project = data.response[0].globalNetworkName;
            return data.response[0].globalNetworkName;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected;

                if (item.selectedNode) {
                    nodeSelected = _.find(item.datos,{id:item.selectedNode.toString()});    
                } else {
                    return aggr;
                }

                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

        function filterProjects(projects, filter) {
            var filteredProjects = projects;
            if(filteredProjects && filteredProjects.response){
               filteredProjects= 
               _.chain(filteredProjects.response)
                .filter(function (item) {
                    var isProjectVisible = filterHelperService.projectCodeManager(item.globalNetworkName, 'ESTU_NETWORK', filter);
                    if(isProjectVisible) {
                        return true;
                    }
                    return false;
                })
                .value();
            }
            return filteredProjects;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('periodFilterService', periodFilterService);

    /** @ngInject */
    function periodFilterService($http, filterHelperService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };

        var context;

        return service;

        /** private methods */

        function getFilter(options) {
            context = this;
            return getPeriod(options);
        }

        function getPeriod(options) {
            var file = (options && options.file) || 'periodFilter.json';
            return $http({
                method: 'GET',
                url:'./data/' + file,
                transformResponse: $http.defaults.transformResponse.concat([transformData])
            });
        }

        function transformData(data) {
            return {
                type:'select2',
                name: 'Period',
                label: 'Period',
                viewLabel: 'FILTER_Period',
                datos: data,
                selectedNode: createPreselections(data, context.period)
            };
        }

        function createPreselections(data, preselection) {
            var first;
            if (preselection) {
                return preselection;
            }

            var estuPeriod = filterHelperService.projectCodeManager(context.project, 'ESTU_NETWORK', 'ESTU_PERIOD');
            var periodPreselected = _.chain(data).filter({id: estuPeriod}).value();

            first = periodPreselected[0].id;
            context.period = first;
            return first;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('networkFilterService', networkFilterService);

    /** @ngInject */
    function networkFilterService($http, userHelperService, $translate, filterHelperService, $filter, errorHandlerService,$q) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo,
            changeListener:function() {alert('network');}
        };

        var context;

        return service;

        /** private methods */

        /**
         * options
         * 
         * notPreselected: Avoid set a value by default
         * waveNullable: Allow to get data even when there is no wave selected
         */
        function getFilter(options) {
            context = this;
            return getNetwork(options);
        }

        function getNetwork(options) {
            var waveNullable =  options && options.waveNullable; 
            if (!context.project || (!context.wave && !waveNullable)) {
                return $q.when(null);
            }

            //If we have a context (user admin so far) we need to do an special 
            //call in order to get the data from other contexsts 
            var networkUrl = context.context ? './api/Entrevistas/getListContext/' : './api/Entrevistas/getList/'; 

            var params = {
                token: userHelperService.getToken(),
                referenceDate: context.wave && $filter('waveToFullDate')(context.wave.toString()),
                selectedIds: context.network,
                context: context.context ||  null 
            };
            
            return $http({
                method: 'GET',
                url: networkUrl + context.project,
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            var selectedId;
            if (data.error || !data.response || data.response.length < 1) {
                errorHandlerService.log('error', 'networkFilterService::transformData -> no response');
                return null;
            }
            
            selectedId = getLastSelected(data.response);
            
            if (selectedId) {
                context.network = selectedId;
            }

            return _.map(data.response, fnTransformation);
        }

        function fnTransformation(networkItem) {
            return {
                type: 'select2',
                name: networkItem.name,
                label: networkItem.name.toUpperCase(),
                viewLabel: networkItem.name,
                allowClear: true,
                hide: false,
                datos: _.map(networkItem.nodes, function (comboItem) {
                    return {
                        id: comboItem.id,
                        text: comboItem.label,
                        externalId: comboItem.externalId,
                        selected: comboItem.selected
                    };
                }),
                selectedNode: networkItem.selectedNode
            };
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data,function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = _.chain(data.selection)
                .filter(function (item) {
                    return item.id !== null;
                })
                .last()
                .value();
            return data;
        }

        function getLastSelected(data) {
            return _.chain(data)
                .map('selectedNode')
                .filter(function(item){ return item !== null;})
                .last()
                .value();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('levelFilterService', levelFilterService);

    /** @ngInject */
    function levelFilterService($http, userHelperService, $translate, $q, filterHelperService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };

        var context;

        return service;

        /** private methods */

        /**
         * options
         * 
         * notPreselected: Avoid set a value by default
         * waveNullable: Allow to get data even when there is no wave selected
         */
        function getFilter(options) {
            context = this;
            return getLevels(options);
        }

        function getLevels(options) {
            var waveNullable =  options && options.waveNullable; 
            if (!context.project || !context.network || (!context.wave && !waveNullable)) {
                return $q.when(null);
            }

            //If we have a context (user admin so far) we need to do an special 
            //call in order to get the data from other contexsts 
            var networkUrl = context.context ? './api/Entrevistas/getOwnLevelsContext' : './api/Entrevistas/getOwnLevels'; 

            var params = {
                token: userHelperService.getToken(),
                nodeId: context.network,
                project: filterHelperService.projectCodeManager(context.project, 'ESTU_NETWORK', 'ESTU_FRONT'),
                wave: context.wave || null,
                elements: 1,
                context: context.context || null

            };
            
            return $http({
                method: 'GET',
                url: networkUrl,
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData.bind(options)])
            });
        }

        function transformData(data) {
            return {
                type:'select2',
                name: 'Level',
                label: 'Level',
                viewLabel: 'FILTER_LEVEL',
                allowClear: true,
                datos: _.map(data.response, function (item) {
                    return {
                        id: item.name,
                        text: item.name
                    };
                }),
                selectedNode: this && this.notPreselected && !context.level ? null : createPreselections(data, context.level)
            };
        }

        function createPreselections(data, preselection) {
            if (preselection) {
                return preselection;
            }

            //Save the selection
            context.level = data.response[0].name;
            //We do not want to be preselected by default
            return null;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data, function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode});
                if(!nodeSelected) {
                    nodeSelected =  {
                        id:null,
                        text:null
                    };    
                }
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);
            
            //If all selection values are null we do not want to display the pill
            data.selection = _.every(selection, {id: null}) ? null : selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

    }
})();
(function () {
  'use strict';

  /** Module used to manage the configuration for the filter for each view */
  angular
    .module('app')
    .factory('filterViewConfigurationService', filterViewConfigurationService);

  filterViewConfigurationService.$inject = ['projectFilterService', 'waveFilterService', 'networkFilterService', 'contextFilterService', 'levelFilterService', 'periodFilterService','questionFilterService'];
  function filterViewConfigurationService (projectFilterService, waveFilterService, networkFilterService, contextFilterService, levelFilterService, periodFilterService, questionFilterService) {
    var service = {
      getFilterDefinition: getFilterDefinition
    };

    var configs = {
      interviewListFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
          { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network'] },
          { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]
      }, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]
      }],
      dashboardFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
          { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network','period'] },
          { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]
      }, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]
      }, {
        group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD_group', setSelection: periodFilterService.generateSelections, setFilterInfo: periodFilterService.generateFilterInfo },
        sources: [
          { eventId: 'period', method: periodFilterService, args: [], deps: ['project', 'wave','network']}
        ]
      }],      
      userManagementFilter: [{
        group: { id: 'context', label: 'FILTER_CONTEXT', viewLabel: 'FILTER_CONTEXT', setSelection: contextFilterService.generateSelections, setFilterInfo: contextFilterService.generateFilterInfo },
        sources: [
          { eventId: 'context', method: contextFilterService, args: [], deps: [], resetContext: ['project', 'network', 'level'] }
        ]
      },{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
          { eventId: 'project', method: projectFilterService, args: [{notPreselected:true, allowClear: true}], deps: ['context'] }
        ]
      }, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [{notPreselected:true, waveNullable: true}], deps: ['context','project'], alwaysReprocess: true }
        ]
      }, {
        group: { id: 'level', label: 'FILTER_LEVEL', viewLabel: 'FILTER_LEVEL', setSelection: levelFilterService.generateSelections, setFilterInfo: levelFilterService.generateFilterInfo },
        sources: [
          { eventId: 'level', method: levelFilterService, args: [{notPreselected:true, waveNullable: true}], deps: ['context', 'project', 'network'] }
        ]
      }],
      networkFilter: [ {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [{waveNullable: true}], deps: [], alwaysReprocess: true }
        ]
      }],
      trendingTopicsFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
            { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network','period'] },
            { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]}, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]}, {
        group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD_group', setSelection: periodFilterService.generateSelections, setFilterInfo: periodFilterService.generateFilterInfo },
        sources: [
          { eventId: 'period', method: periodFilterService, args: [{file: 'periodFilter_TextAnalytics.json'}], deps: ['project'] }
        ]}
      ],
      searchVerbatimsFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
            { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network','period','question'] },
            { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]}, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], resetContext: ['question'], alwaysReprocess: true }
        ]}, {
        group: { id: 'period', label: 'FILTER_PERIOD', viewLabel: 'FILTER_PERIOD_group', setSelection: periodFilterService.generateSelections, setFilterInfo: periodFilterService.generateFilterInfo },
        sources: [
          { eventId: 'period', method: periodFilterService, args: [{file: 'periodFilter_TextAnalytics.json'}], deps: ['project'] }
        ]}, {
        group: { id: 'question', label: 'FILTER_QUESTION', viewLabel: 'FILTER_QUESTION', setSelection: questionFilterService.generateSelections, setFilterInfo: questionFilterService.generateFilterInfo },
        sources: [
          { eventId: 'question', method: questionFilterService, args: [{file: 'questionFilter.json'}], deps: ['project', 'network'] }
        ]}
      ],
      //We use it only to get information about the user when login (loginService --> 'getFilter')
      loginFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
            { eventId: 'project', method: projectFilterService, args: [], deps: [], resetContext: ['wave','network'] },
            { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]}, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]}
      ],
      offlineReportsFilter: [{
        group: { id: 'project', label: 'FILTER_SURVEY', viewLabel: 'FILTER_SURVEY_WAVE', setSelection: projectFilterService.generateSelections, setFilterInfo: projectFilterService.generateFilterInfo },
        sources: [
            { eventId: 'project', method: projectFilterService, args: [{filter: 'ESTU_OFFLINE_REPORTS'}], deps: [], resetContext: ['wave','network'] },
            { eventId: 'wave', method: waveFilterService, args: [], deps: ['project'] }
        ]}, {
        group: { id: 'network', label: 'FILTER_NETWORK', viewLabel: 'FILTER_NETWORK', setSelection: networkFilterService.generateSelections, setFilterInfo: networkFilterService.generateFilterInfo },
        sources: [
          { eventId: 'network', method: networkFilterService, args: [], deps: ['project', 'wave'], alwaysReprocess: true }
        ]}
      ]
    };

    return service;

    /** private function */

    function getFilterDefinition(id) { 
        return configs[id];
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('contextFilterService', contextFilterService);

    /** @ngInject */
    function contextFilterService($http, userHelperService, $translate, configurationLoaderService) {
        var service = {
            getFilter: getFilter,
            generateSelections:generateSelections,
            generateFilterInfo:generateFilterInfo
        };

        var context;

        return service;

        /** private methods */

        function getFilter() {
            context = this;
            return getContext();
        }

        function getContext() {
            var params = {
                token: userHelperService.getToken()
            };
            return $http({
                method: 'GET',
                url:'./api/users/contextsListByAdmin',
                params: params,
                transformResponse: $http.defaults.transformResponse.concat([transformData])
            });
        }

        function transformData(data) {
            return {
                type:'select2',
                name: 'Context',
                label: 'Context',
                viewLabel: 'FILTER_CONTEXT',
                datos: _.map(data, function (item) {
                    return {
                        id: item.code,
                        text: $translate.instant(item.name)
                    };
                }),
                selectedNode: createPreselections(data, context.context)
            };
        }

        function createPreselections(data, preselection) {
            var first;
            if (preselection) {
                return preselection;
            }

            //We select by default the active context in the config.json
            context.context = configurationLoaderService.getConfig().context || data[0].code;

            return context.context;
        }

        function generateSelections(data) {
            var selection = _.reduce(data.data, function(aggr,item){
                var nodeSelected = _.find(item.datos,{id:item.selectedNode.toString()});
                nodeSelected.label = item.label;
                nodeSelected.viewLabel = item.viewLabel;
                nodeSelected.eventId = item.eventId;
                aggr.push(nodeSelected);
                return aggr;
            },[]);

            data.selection = selection;
            return data;
        }

        function generateFilterInfo(data) {
            data.filterInfo = data.selection;
            return data;
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('exteriorService', exteriorService);

    /** @ngInject */
    function exteriorService($http, $q, errorHandlerService) {
        var service = {
            getRankData: getRankData,
            getPenData: getPenData,
            getPerData: getPerData
        };

        return service;

        ////////////////

        function getRankData(wave) {
            return $q.all([getRankEx(wave), getRankTotal(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPenData(wave) {
            return $q.all([getExPenSex(wave), getExPenEdad(wave), getExPenNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPerData(wave) {
            return $q.all([getExPerSex(wave), getExPerEdad(wave), getExPerNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getRankEx(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKEXT",
                  "query": "RANKEXT",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankTotal(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKEXT",
                  "query": "TOTEXT",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getExPenSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "EXPENSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getExPenEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "EXPENEDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getExPenNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "EXPENNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getExPerSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "EXPERSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getExPerEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "EXPEREDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getExPerNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "EXPERNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function transformData(data) {
            return data && data.data;
        }

        function parseData(data) {
            return data;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.exterior', {
                url: '/exterior',
                views: {
                    content: {
                        templateUrl: 'app/exterior/exterior.html',
                        controller: 'ExteriorController',
                        controllerAs: 'exteriorController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('ExteriorController', ExteriorController);

    /** @ngInject */  
    function ExteriorController(exteriorService, errorHandlerService, mainService, $rootScope, stateManagerService, $scope) {
        var vm = this;
        vm.id = 'exterior';
        vm.selectedWave = null;
        vm.menuData = mainService.audienceDataState;
        vm.penWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.perWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.rankWidget = {
            loading: false,            
            rankEx: [],
            rankTotal: null
        };
        
        init();

        /** listeners */ 
        var changeWaveWatcher = $rootScope.$on('main:changeWave', init); 
 
        $scope.$on('$destroy', function () { 
            changeWaveWatcher(); 
        });


        ////////////////

        function init() {
            vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
            vm.rankWidget.rankWidgetFormatFn =  copyRankWidgetToClipboard;
            vm.penWidget.penWidgetFormatFn =  copyPenWidgetToClipboard;
            vm.perWidget.perWidgetFormatFn =  copyPerWidgetToClipboard;
            if(vm.selectedWave && vm.selectedWave.fullWave) {
                getGeneralAudienceData();
                getRankData();
                getPenData();
                getPerData();
            }
        }

        function getGeneralAudienceData(){
            mainService.getAudienceData()
            .then(function(data) {
                vm.menuData = data;
            })
            .catch(exteriorError);
        }

        function getRankData() {
            vm.rankWidget.loading = true;
            exteriorService.getRankData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.rankWidget.rankEx = data[0];
                vm.rankWidget.rankTotal = data[1];

            })
            .catch(exteriorError)
            .finally(function(){ vm.rankWidget.loading = false; });
        }

        function getPenData() {
            vm.penWidget.loading = true;
            exteriorService.getPenData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.penWidget.sexo = data[0];
                vm.penWidget.edad = data[1];
                vm.penWidget.iso = data[2];
            })
            .catch(exteriorError)
            .finally(function(){ vm.penWidget.loading = false; });
        }

        function getPerData() {
            vm.perWidget.loading = true;
            exteriorService.getPerData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.perWidget.sexo = data[0];
                vm.perWidget.edad = data[1];
                vm.perWidget.iso = data[2];
            })
            .catch(exteriorError)
            .finally(function(){ vm.perWidget.loading = false; });
        }


        function exteriorError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyRankWidgetToClipboard(data) {
            var total = 'TOTAL SEMANA' + '\t' + data.rankTotal;
            var chartData = _.reduce(data.rankEx, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(total, chartData);
            return formattedData.join('\n');
        }

        function copyPenWidgetToClipboard(data) {
            var title = 'PENETRACIÓN POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

        function copyPerWidgetToClipboard(data) {
            var title = 'PERFIL POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad.text, function(aggr, item, index) {
                var row = item + '\t' + data.edad.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso.text, function(aggr, item, index) {
                var row = item + '\t' + data.iso.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('diariosService', diariosService);

    /** @ngInject */
    function diariosService($http, $q, errorHandlerService, configurationLoaderService) {

        var freeNewspapers = configurationLoaderService.getConfig().freeNewspapers;

        var service = {
            getRankData: getRankData,
            getAudienceTypeData: getAudienceTypeData,
            getPenData: getPenData,
            getPerData: getPerData
        };

        return service;

        ////////////////


        function getRankData(wave) {
            return $q.all([getRankDiar(wave), getRankTotal(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPenData(wave) {
            return $q.all([getDiPenSex(wave), getDiPenEdad(wave), getDiPenNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPerData(wave) {
            return $q.all([getDiPerSex(wave), getDiPerEdad(wave), getDiPerNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getRankDiar(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKDIAR",
                  "query": "RANKDIAR",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    item.free = _.indexOf(freeNewspapers, item.id) > -1 ? true : false;
                    item.text = _.replace(item.text, '(7/5)','(**)');
                    item.text = _.replace(item.text, '(7/6)','(*)');

                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getRankTotal(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "RANKDIAR",
                  "query": "TOTDIAR",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return _.isNaN(parseFloat(data)) ? null : parseFloat(data);
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getAudienceTypeData(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUCDIAR",
                  "query": "ESTRUCDIAR",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.map(data.series, function(item) {
                    item.value = item.values && item.values.length > 0 && item.values[0];
                    item.value = parseFloat(item.value);
                    return item;
                }) : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getDiPenSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "DIPENSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getDiPenEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "DIPENEDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getDiPenNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "DIPENNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getDiPerSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "DIPERSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getDiPerEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "DIPEREDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getDiPerNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "DIPERNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function transformData(data) {
            return data && data.data;
        }

        function parseData(data) {
            return data;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.diarios', {
                url: '/diarios',
                views: {
                    content: {
                        templateUrl: 'app/diarios/diarios.html',
                        controller: 'DiariosController',
                        controllerAs: 'diariosController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('DiariosController', DiariosController);

    /** @ngInject */  
    function DiariosController(diariosService, errorHandlerService, mainService, $rootScope, stateManagerService, $scope) {
        var vm = this;
        vm.id = 'diarios';
        vm.selectedWave = null;
        vm.menuData = mainService.audienceDataState;
        vm.penWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.perWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.audienceWidget = {
            loading: false,
            data: []
        };
        vm.rankWidget = {
            loading: false,            
            rankDiar: null,
            rankTotal: null
        };

        
        init();

        /** listeners */ 
        var changeWaveWatcher = $rootScope.$on('main:changeWave', init); 
 
        $scope.$on('$destroy', function () { 
            changeWaveWatcher(); 
        });


        ////////////////

        function init() {
            vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
            vm.rankWidget.rankWidgetFormatFn = copyRankWidgetToClipboard;
            vm.audienceWidget.audienceWidgetFormatFn =  copyAudienceWidgetToClipboard;
            vm.penWidget.penWidgetFormatFn =  copyPenWidgetToClipboard;
            vm.perWidget.perWidgetFormatFn =  copyPerWidgetToClipboard;
            if(vm.selectedWave && vm.selectedWave.fullWave) {
                getGeneralAudienceData();
                getRankData();
                getAudienceData();
                getPenData();
                getPerData();
            }
        }

        function getGeneralAudienceData(){
            mainService.getAudienceData()
            .then(function(data) {
                vm.menuData = data;
            })
            .catch(diariosError);
        }

        function getRankData() {
            vm.rankWidget.loading = true;
            diariosService.getRankData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.rankWidget.rankDiar = data[0];
                vm.rankWidget.rankTotal = data[1];

            })
            .catch(diariosError)
            .finally(function(){ vm.rankWidget.loading = false; });
        }

        function getAudienceData() {
            vm.audienceWidget.loading = true;
            diariosService.getAudienceTypeData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.audienceWidget.data = data;
            })
            .catch(diariosError)
            .finally(function(){ vm.audienceWidget.loading = false; });
        }

        function getPenData() {
            vm.penWidget.loading = true;
            diariosService.getPenData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.penWidget.sexo = data[0];
                vm.penWidget.edad = data[1];
                vm.penWidget.iso = data[2];
            })
            .catch(diariosError)
            .finally(function(){ vm.penWidget.loading = false; });
        }

        function getPerData() {
            vm.perWidget.loading = true;
            diariosService.getPerData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.perWidget.sexo = data[0];
                vm.perWidget.edad = data[1];
                vm.perWidget.iso = data[2];
            })
            .catch(diariosError)
            .finally(function(){ vm.perWidget.loading = false; });
        }


        function diariosError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyRankWidgetToClipboard(data) {
            var total = 'TOTAL LECTORES DIARIOS' + '\t' + data.rankTotal;
            var chartData = _.reduce(data.rankDiar, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(total, chartData);
            return formattedData.join('\n');
        }

        function copyAudienceWidgetToClipboard(data) {
            var title = 'AUDIENCIA POR TIPO DE DIARIO';
            var chartData = _.reduce(data, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title, chartData);
            return formattedData.join('\n');
        }

        function copyPenWidgetToClipboard(data) {
            var title = 'PENETRACIÓN POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

        function copyPerWidgetToClipboard(data) {
            var title = 'PERFIL POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad.text, function(aggr, item, index) {
                var row = item + '\t' + data.edad.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso.text, function(aggr, item, index) {
                var row = item + '\t' + data.iso.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('windowResizeManagerService', windowResizeManagerService);

    windowResizeManagerService.$inject = ['$window','lodash','$rootScope','$log'];
    function windowResizeManagerService($window,lodash,$rootScope,$log) {
        var size = [];
        var service = {
            startListening: startListening,
            getWindowSize: getWindowSize
        };

        return service;

        /** private methods */
        function getWindowSize() {
            return size;
        }

        function onResize(event) {
            size[0] = $window.innerWidth;
            size[1] = $window.innerHeight;
            $log.log('resize',size);
            $rootScope.$emit('window.resize',{size:size});
        }

        function startListening() {
            size[0] = $window.innerWidth;
            size[1] = $window.innerHeight;

            angular.element($window).bind('resize', lodash.debounce(onResize,600));
            $log.log(size);
            return size;
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('widgetLoaderService', widgetLoaderService);

    widgetLoaderService.$inject = ['$http', '$q', 'propertybagHandlerService', 'errorHandlerService', 'stateManagerService', 'configurationLoaderService','globalHelpersService'];
    function widgetLoaderService($http, $q, propertybagHandlerService, errorHandlerService, stateManagerService, configurationLoaderService,globalHelpersService) {
        var service = {
            getData: getData
        };

        return service;

        // private methods

        // main entrance point
        function getData(stationSelected, programSelected, waveSelected) {
            return $q.all([getWidgetDefinition(programSelected), $q.when(stationSelected), $q.when(programSelected), $q.when(waveSelected)])
                .then(spread)
                .then(postOperations)
                .then(resolveBodyRequest)
                .catch(errorHandlerService.callbackError);

        }

        // get widget configuration
        function getWidgetDefinition(programSelected) {
            var fileNameExt = programSelected && programSelected.id !== 'TOTAL' ? programSelected.id : '';
            var fileName = 'widgetDefinitionAimc' + fileNameExt + '.json';
            return $http({
                method: 'GET',
                url: './data/' + fileName,
                params: {
                    cacheFix: new Date()
                }
            })
                .then(function (data) {
                    return data && data.data;
                });
        }

        function postOperations(data) {
            data.widgetDefinition = _
                .chain(data.widgetDefinition)
                .map(function (item) {
                    //Station selected
                    if (item.competence) {
                        item.stationSelected = globalHelpersService.getCompetence(configurationLoaderService.getConfig().competences,data.stationSelected.competence);
                    } else {
                        item.stationSelected = data.stationSelected;
                    }

                    //Program selected
                    item.programSelected = data.programSelected;
                    
                    //Needed to make the api reques
                    item.project = data.stationSelected.idMiddle;
                    item.program = data.programSelected && data.programSelected.id !== 'TOTAL' ? data.programSelected.id : null;
                    item.wave = data.waveSelected.wave;

                    return item;
                })
                .value();

            return data;
        }

        // get propertyBag
        function getPropertyBag() {
            return propertybagHandlerService.getData('widgetConfig')
                .then(function (data) {
                    return data && data.data;
                });
        }

        function spread(data) {
            return _.zipObject(['widgetDefinition', 'stationSelected', 'programSelected', 'waveSelected'], data);
        }

        // add node information to payload
        function setNodes(data) {
            var settingsNodes;

            settingsNodes = _.chain(stateManagerService.getState('userInfo'))
                .extend()
                .reduce(nodesReducer, {})
                .value();

            data.widgetDefinition = _.chain(data.widgetDefinition)
                .map(function (item) {

                    if (!settingsNodes[item.project.toUpperCase()]) {
                        return item;
                    }

                    if (data.propertyBag) {
                        item.attributes.visible = _.isUndefined(data.propertyBag[item.id]) ? item.attributes.visible : data.propertyBag[item.id];
                    }

                    // if widgetdefinition has concept level (HQ/COUNTRY) verify charge property on nodes in
                    // settings. Only if both are the same add node definition to the widget
                    if (item.level) {
                        if (item.level.toUpperCase() === settingsNodes[item.project.toUpperCase()].charge.toUpperCase()) {
                            item.nodeId = settingsNodes[item.project.toUpperCase()].id;
                            item.attributes.node = settingsNodes[item.project.toUpperCase()].code;
                        }
                        return item;
                    }


                    // if no level defined add node definition
                    item.nodeId = settingsNodes[item.project.toUpperCase()].id;
                    item.attributes.node = settingsNodes[item.project.toUpperCase()].externalID;

                    return item;
                })
                .value();

            return data;
        }

        function nodesReducer(aggr, item, index) {

            if (!item.selectedNode) {
                throw ('widgetLoaderService::nodesReducer -> No selected Node');
            }

            // get all node info
            var info = _.chain(item.nodes)
                .find({ externalID: item.selectedNode })
                .value();

            if (!info) {
                throw ('widgetLoaderService::nodesReducer -> Selectedid not found in nodes');
            }

            // add HQ or COUNTRY
            info.charge = _.chain(configurationLoaderService.getConfig().HQLevels)
                .intersection([info.level.toUpperCase()])
                .some()
                .value() ?
                'HQ' :
                'COUNTRY';

            // add project
            aggr[item.project] = info;

            return aggr;
        }

        //TODO --> FILTRADO VISIBILIDAD
        function resolveBodyRequest(data) {
            return _.chain(data.widgetDefinition)
                .filter(function (item) {
                    return true;
                    //return item.nodeId && item.widgetAvailable && item.attributes.visible;
                })
                .value();
        }

        function resolveSettingsData(data) {
            return _.chain(data.widgetDefinition)
                .filter(function (item) {
                    return item.nodeId && item.widgetAvailable;
                })
                .value();
        }

    }
})();
(function() {
'use strict';

    angular
        .module('app')
        .factory('userHelperService', userHelperService);

     /** @ngInject */
    function userHelperService(storageService) {
        var user;
        var service = {
            getToken: getToken,
            getUserLanguage: getUserLanguage,
            getUser: getUser
        };
        
        return service;

        ////////////////
        /**
         * Getting the user context
         */
        function getToken() {
            return service.getUser().value;
        }   

        /**
         * Gettint the user lenguage
         */
        function getUserLanguage() {
            return service.getUser().profile.language;
        }

        function getUser(){
            return storageService.retrieve('user');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('translationManagerService', translationManagerService);

    /* @ngInject */
    function translationManagerService() {
        var modules;
        
        var service = {
            getModules: getModules
        };

        modules = [
            { project: 'CEMAUDI', module: 'WEB_INTERVIEWLIST' },            
            { project: 'CEMAUDI', module: 'WEB_MAIN' },
            { project: 'CEMAUDI', module: 'WEB_INTERVIEW' },
            { project: 'CEMAUDI', module: 'WEB_FILTER' },
            { project: 'CEMAUDI', module: 'WEB_COCKPIT' },
            { project: 'CEMAUDI', module: 'WEB_SETTINGS' },
            { project: 'CEMAUDI', module: 'WEB_ADMIN' },
            { project: 'CEMAUDI', module: 'WEB_STANDARD_REPOSITORY' },
            { project: 'CEMAUDI', module: 'WEB_TEXT_ANALYTICS' },
            { project: 'CEMAUDI', module: 'WEB_DASHBOARD' },
            { project: 'CEMAUDI', module: 'WEB_SNAPSHOTS' },
            { project: 'CEMAUDI', module: 'WEB_NEWS' },
            { project: 'CEMAUDI', module: 'WEB_OFFLINE_REPORTS'},
            { project: 'CEMAUDI', module: 'WEB_ALERTS'},
            { project: 'CEMAUDI', module: 'WEB_HOTLINE'}
        ];

        return service;

        /* private methods */

        function getModules() { 
            return modules;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('storageService', storageService);

    storageService.$inject = ['$cookies'];
    function storageService($cookies) {
        
        /** public methods */

        this.save = save;
        this.retrieve = retrieve;
        this.remove = remove;
        this.clear = clear;

        /** private methods */

        function save(property, data) {
            if (localStorage) {
                localStorage.setItem(property, angular.toJson(data));
            } else {
                $cookies.put(property, angular.toJson(data));
            }
        }

        function retrieve(property) {
            if (localStorage) {
                return angular.fromJson(localStorage.getItem(property));
            } else {
                return angular.fromJson($cookies.get(property));
            }
        }

        function remove(property) {
            if (localStorage) {
                localStorage.removeItem(property);
            } else {
                $cookies.remove(property);
            }
        }

        function clear() {
            if (localStorage) {
                localStorage.clear();
            } else {
                var cookies = $cookies.getAll();
                angular.forEach(cookies, function (v, k) {
                    $cookies.remove(k);
                });
            }
        }

    }
})();
(function() {
'use strict';

    angular
        .module('app.core')
        .factory('stateManagerService', stateManagerService);

    //stateManagerService.$inject = [''];
    function stateManagerService() {
        var service = {
            getState:getState,
            setState:setState
        };

        var atomicState = {};

        return service;

        /** private methods */
        function getState(key) {
            if (!key) {
                throw('stateManagerService::setState -> No key provided');
            }

            return angular.copy(atomicState[key]);
        }

        function setState(key,state) {
            var _key,_state;
            // context parameters (state)
            if (this && this.prop) {
                _key = this.prop;
                _state = key;
            } else {
                _key = key;
                _state = state;
            }

            if (!_key) {
                throw('stateManagerService::setState -> No key provided');
            }

            return atomicState[_key] = _state;
        }
    }
})();

/*eslint angular/on-watch:0 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .service('routingService', routingService);

    routingService.$inject = ['$rootScope', '$log', 'storageService', 'loginService', '$state', '$window', '$q', '$urlRouter','$timeout'];
    function routingService($rootScope, $log, storageService, loginService, $state, $window, $q, $urlRouter,$timeout) {

        this.registerCallbacks = registerCallbacks;
        this.startTransitionHook = startTransitionHook;
        this.getLastState = getLastState;

        var lastState = null;
            

        /** private methods */

        function registerCallbacks() {
            $rootScope.$on('$stateChangeStart', startTransitionHook);
            $rootScope.$on('$stateChangeSuccess', successTransitionHook);
            $rootScope.$on('$stateChangeError', changeErroTransitionHook);
            $rootScope.$on('$stateNotFound', stateNotFoundTransitionHook);
            $rootScope.$on('core:timeIdleError', onTimeIdleError);
        }

        function startTransitionHook(event, toState, toParams, fromState, fromParams) {
            $rootScope.$emit('transition:start');
            
            var urlHash = $window.location.hash.match(/[\?\&]token.*$/);
            var token, tokenInspection;
            var destinyUrl;


            var user, userStored;

            // there are two posibilities:
            // - has a token at the end of the urls -> means it's a loginByToken
            // - has no token at the end of the urls -> it's a refresh or an url change
            if (!urlHash) {
                // has no token, try to retrieve user info from localstorage
                user = loginService.getUser();

                // login state is always public...
                if (toState.public || toState.name === 'login') {
                    return;
                }

                if (!user) {
                    // if not auth restore from localstorage
                    userStored = storageService.retrieve('user');
                } else {
                    // if is authenticated then go on
                    return;
                }

                if (userStored) {
                    loginService.setUser(userStored);
                    loginService.setMomentLocale(userStored.profile.language);
                    // proceed
                } else {
                    // go to login
                    if (fromState.name === 'login') {
                        // do nothing, let it go...
                    } else {
                        event.preventDefault();
                        $state.go('login');
                    }

                    
                }
            } else {
                event.preventDefault();

                destinyUrl = $window.location.hash.replace(/[\?\&]token.*$/, '');
                tokenInspection = urlHash[0].match(/\=.*$/);

                if (!tokenInspection || tokenInspection.length === 0) {
                    $state.go('login');
                    return;
                }

                token = tokenInspection[0].replace('=', '');

                return loginService.loginFullWorkflowWithToken(token)
                    .then(function () {
                        $timeout(function() {
                            $window.location.replace(destinyUrl);    
                        }, 0);
                        
                    })
                    .catch(function () {
                        $log.error('User invalid');
                        $timeout(function() {
                            $window.location.replace('#/login');    
                            $window.location.reload();
                        }, 0);
                    });
            }





        }
        function successTransitionHook(event, toState, toParams, fromState, fromParams) {
            $rootScope.$emit('transition:end');
            
            $rootScope.$emit('breadcrumb:toState', { toState: toState, toParams: toParams });
            lastState = { state: fromState, params: fromParams };
            storageService.save('lastState', lastState);
            //$log.warn('Succeded transitioning to:', event, toState, toParams, fromState, fromParams);
        }
        function changeErroTransitionHook(event, toState, toParams, fromState, fromParams, error) {
            $rootScope.$emit('transition:end');
            $log.warn('Error transitioning to:', event, toState, toParams, fromState, fromParams, error);
        }
        function stateNotFoundTransitionHook(event, unfoundState, fromState, fromParams) {
            $rootScope.$emit('transition:end');
            $log.warn('State not found:', event, unfoundState, fromState, fromParams);
        }

        function getLastState() {
            if (!lastState) {
                lastState = storageService.retrieve('lastState');
            }

            if (!lastState || !lastState.state.name) {
                return { state: 'main.cockpit', params: null };
            }

            return lastState;
        }

        function onTimeIdleError() {
            $log.error('TIMED_OUT');
            storageService.clear();  
            $state.go('login');  
            $window.location.reload();       
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('propertybagHandlerService', propertybagHandlerService);

    propertybagHandlerService.$inject = ['loginService', 'configurationLoaderService', '$http', 'errorHandlerService', '$q', 'globalHelpersService'];
    function propertybagHandlerService(loginService, configurationLoaderService, $http, errorHandlerService, $q, globalHelpersService) {
        var service = {
            getData: getData,
            setData: setData,
            restoreDefault:restoreDefault
        };

        return service;

        // private methodes

        function getData(storeName) {
            return $http({
                method: 'GET',
                url: './api/propertiesBag',
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: storeName
                },
                transformResponse: [transformProperties].concat($http.defaults.transformResponse)
            })
                .then(fnAccept)
                .catch(fnError);
        }

        function setData(store, value) {
            return $http({
                method: 'POST',
                url: './api/propertiesBag',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: store
                },
                data: {
                    content:angular.toJson(value)
                },
                transformRequest: globalHelpersService.httpPostParamsPrepare
            });
        }

        function restoreDefault(store) {
            return $http({
                method: 'DELETE',
                url: './api/propertiesBag',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                params: {
                    token: loginService.getToken(),
                    project: configurationLoaderService.getConfig().project,
                    storeName: store
                }
            });
        }

        function fnAccept(data) {
            return $q.resolve(data);
        }

        function fnError(error) {
            //errorHandlerService.warn(error);
            return $q.resolve(null);
        }

        function transformProperties(data, header, status) {
            if (status >= 400) {
                return { error: data };
            }

            return data;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('i18nService', i18nService);

    i18nService.inject = ['loginService', '$http', '$q', 'translationManagerService'];

    function i18nService(loginService, $http, $q, translationManagerService) {
        var lang, variante;
        return translationHelper;

        function translationHelper(options) {
            var deferred = $q.defer();

            /* Obtenemos la lista de modulos a cargar */
            var seccion =translationManagerService.getModules();

            if (options.key.indexOf('_') !== -1) {
                lang = options.key.split('_')[0];
                variante = options.key.split('_')[1];
            } else {
                lang = options.key;
                variante = null;
            }

            $http({
                method: 'POST',
                url: './api/msgs2/messages/multipleModuleRequest',
                params: { token: loginService.getToken() },
                data: { modules: seccion, languageCode: lang, countryCode: variante, prefixType: 'None' }
            }).success(function (data) {
                deferred.resolve(data);
            }).error(function () {
                deferred.reject(options.key);
            });

            return deferred.promise;
        }
    }
} ());
/*global window*/
(function () {
  'use strict';

  angular
    .module('app')
    .provider('tokenInterceptor', tokenInterceptor);

  function tokenInterceptor() {
    var config = this;
    config.idleTimeout = 1800;

    this.$get = ['$injector', '$q', 'storageService', '$rootScope', '$log',
      function ($injector, $q, storageService, $rootScope, $log) {
        return {
          request: function (request) {
            var actualTimeStamp,
              timeDiff;
            // podemos añadir un parametro mas a la configuracion del $http para que no pase por aqui
            if (request.skipAuthorization) {
              return request;
            }

            // vamos a guardar una fecha en el localstorage
            var lastResource = storageService.retrieve('lastResource');
            if (!lastResource) {
              actualTimeStamp = new Date();
              storageService.save('lastResource', actualTimeStamp.valueOf());
            } else {
              // verificamos que el tiempo pasado desde la ultima peticion no supera el tiempo del idle
              actualTimeStamp = new Date();
              timeDiff = (actualTimeStamp.valueOf() - lastResource) / 1000;
              if (timeDiff > config.idleTimeout) {
                $log.log('core:timeIdleError::', timeDiff);
                $rootScope.$emit('core:timeIdleError');
                return $q.reject();
              }
              storageService.save('lastResource', actualTimeStamp.valueOf());
            }



            //obtenemos el token
            var _usuario = storageService.retrieve('user');
            if (_usuario && _usuario.value) {
              request.headers = request.headers || {};
              request.headers['X-Authentication'] = _usuario.value;
            }

            return request;
          },
          requestError: function (error) {
            return $q.reject(error);
          },
          response: function (response) {
            return response;
          },
          responseError: function (error) {
            return $q.reject(error);
          }
        };
      }
    ];
  }
}());

(function () {
    'use strict';

    angular
        .module('app')
        .factory('globalHelpersService', globalHelpersService);

    globalHelpersService.$inject = ['errorHandlerService','exportService','d3'];
    function globalHelpersService(errorHandlerService,exportService,d3) {
        var service = {
            httpPostParamsPrepare: httpPostParamsPrepare,
            exportXLSCallback:exportXLSCallback,
            exportPDFCallback:exportPDFCallback,
            getFileExtension:getFileExtension,
            getCompetence:getCompetence,
            getLighterColor: getLighterColor,
            getDarkerColor: getDarkerColor,
            frontFixedDecimal: frontFixedDecimal
        };

        return service;

        // private methods
        function httpPostParamsPrepare(obj) {
            var str = [];
            for (var p in obj) {
                if (obj[p]) {
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                }
            }
            return str.join('&');
        }

        function exportXLSCallback(data) {
            if (!data.data.response || data.data.error) {
                errorHandlerService.callbackError('SERVICE_UNAVAILABLE');
            }
            exportService.downloadUrl('./api/xlsx/res/' + data.data.response);
        }

        function exportPDFCallback(data) {
            if (!data.data.response || data.data.error) {
                errorHandlerService.callbackError('SERVICE_UNAVAILABLE');
            }
            exportService.downloadUrl('./api/pdf/res/' + data.data.response);
        }

        function getFileExtension(file) {
            var extensionMatch = file.match(/\.[^\.]+$/g);

            if (extensionMatch.length !== 1) {
                return null;
            }
            
            return extensionMatch[0];
        }

        function getCompetence(competences,competenceId) {
            var competence = _.chain(competences).find({id:competenceId}).value();

            if (!competence) { return null; }

            return competence;
        }

        function getLighterColor(originalColor, _step){
            var step = _step || 1;
            var brighterColor = d3.rgb(d3.rgb(originalColor).brighter(step).toString(16));
            var r = brighterColor.r.toString(16) === '0' ? '00' : brighterColor.r.toString(16);
            var g = brighterColor.g.toString(16) === '0' ? '00' : brighterColor.g.toString(16);
            var b = brighterColor.b.toString(16) === '0' ? '00' : brighterColor.b.toString(16);
            var hexColor = '#' + r + g + b;
            return hexColor;
        }

        function getDarkerColor(originalColor, _step){
            var step = _step || 1;
            var brighterColor = d3.rgb(d3.rgb(originalColor).darker(step).toString(16));
            var r = brighterColor.r.toString(16) === '0' ? '00' : brighterColor.r.toString(16);
            var g = brighterColor.g.toString(16) === '0' ? '00' : brighterColor.g.toString(16);
            var b = brighterColor.b.toString(16) === '0' ? '00' : brighterColor.b.toString(16);
            var hexColor = '#' + r + g + b;
            return hexColor;
        }

        function frontFixedDecimal(number){
            return parseFloat(number.toFixed(1));
        }
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('filterHelperService', filterHelperService);

    /* ngInject */
    function filterHelperService($q, configurationLoaderService, errorHandlerService, $translate) {
        var service = {
            projectCodeManager: projectCodeManager,
            getFilterElementSelected: getFilterElementSelected,
            getFilterElementSelectedExternalId:getFilterElementSelectedExternalId,
            getPillsToArray: getPillsToArray,
            getProjectFrontEnd: getProjectFrontEnd,
            isCountrySelected: isCountrySelected,
            projectsAllowed: projectsAllowed,
            getComboElements: getComboElements,
            getLevelSelected: getLevelSelected,
            getOwnLevels: getOwnLevels,
            isHQ: isHQ,
            isBelowCountry: isBelowCountry,
            getFilterElementSelectedText: getFilterElementSelectedText,
            getCountrySelected: getCountrySelected,
            getCountrySelectedExternalId: getCountrySelectedExternalId,
            isDealerSelected: isDealerSelected
        };

        return service;

        /** private method */
        function projectCodeManager(value, origin, target) {
            var targetValue = _.chain(configurationLoaderService.getConfig().studyDefinition)
                .find(function (item) {
                    return item[origin] === value;
                })
                .value();

            if (!targetValue) {
                errorHandlerService.log('error', 'filterHelperService::projectCodeManager -> value not in origin');
                return null;
            }

            if (!targetValue[target]) {
                errorHandlerService.log('error', 'filterHelperService::projectCodeManager -> target invalid');
                return null;
            }

            return targetValue[target];
        }

        function getProjectFrontEnd(filterCollection) {
            return projectCodeManager(getFilterElementSelected(filterCollection, 'project'), 'ESTU_NETWORK', 'ESTU_FRONT').toLowerCase();
        }

        function getFilterElementSelected(filterCollection, eventId) {
            var item = getFilterElement(filterCollection, eventId);

            if (!item) { return null; }

            return item.id;
        }

        function getFilterElementSelectedExternalId(filterCollection, eventId) {
            var item = getFilterElement(filterCollection, eventId);

            if (!item) { return null; }

            return item.externalId;
        }

        function getFilterElementSelectedText(filterCollection, eventId) {
            var item = getFilterElement(filterCollection, eventId);

            if (!item) { return null; }

            return item.text;
        }

        function getComboElements(filterCollection, eventId) {
            return _.chain(filterCollection)
                .flatMap('data')
                .filter({ eventId: eventId })
                .value();
        }

        function getFilterElement(filterCollection, eventId) {
            return _.chain(filterCollection)
                .map('filterInfo')
                .flatten()
                .find({ eventId: eventId })
                .value();
        }

        function getPillsToArray(filterCollection) {
            return _.chain(filterCollection)
                .flatMap('filterInfo')
                .omitBy(_.isNil)
                .map(function (item) {
                    return $translate.instant(item.viewLabel) + ': ' + $translate.instant(item.text);
                })
                .value();
        }

        function projectsAllowed(sessionNetworkLinks) {
            return _.chain(sessionNetworkLinks)
                .map('project')
                .value();
        }


        /**
        * Check if node of country is selected in filters
        *
        * @param {array} filterCollection
        */
        function isCountrySelected(filterCollection) {

            var countryNode = _.chain(filterCollection).flatMap('data').filter({ 'name': 'COUNTRY' }).value();

            if (countryNode && countryNode.length > 0 && countryNode[0].selectedNode) {
                return true;
            }
            else {
                return false;
            }
        }

        function getLevels(filterCollection) {
            return _.chain(getComboElements(filterCollection, 'network'))
                .map('name')
                .value();
        }

        function getOwnLevels(filterCollection, includeOwn) {
            var levels = getLevels(filterCollection);
            var activeLevel = getLevelSelected(filterCollection);
            var indexActiveLevel = _.chain(levels).indexOf(activeLevel).value();

            if (indexActiveLevel < 0) {
                errorHandlerService.log('error', 'getOwnLevel::Level not found');
                return 0;
            }

            if (angular.isDefined(includeOwn) && !includeOwn) {
                if (indexActiveLevel === levels.length) {
                    return [activeLevel];
                }
                return _.slice(levels, indexActiveLevel + 1);
            }

            return _.slice(levels, indexActiveLevel);
        }

        function getLevelSelected(filterCollection) {
            var elementSelected = getFilterElement(filterCollection, 'network');
            return elementSelected ? elementSelected.label : null;
        }

        function isHQ(filterCollection) {
            return _.chain(configurationLoaderService.getConfig().HQLevels)
                .intersection([].concat(getLevelSelected((filterCollection))))
                .some()
                .value();
        }

        function isBelowCountry(filterCollection) {
            return !_.chain([].concat(configurationLoaderService.getConfig().HQLevels, configurationLoaderService.getConfig().countryName))
                .intersection([].concat(getLevelSelected((filterCollection))))
                .some()
                .value();
        }

        function getCountrySelected(filterCollection) {
            var countrySelected = _.chain(filterCollection).flatMap('selection').filter({ 'label': 'COUNTRY' }).value();
            
            return countrySelected ? countrySelected[0].id : null;
        }

        function getCountrySelectedExternalId(filterCollection) {
            var countrySelected = _.chain(filterCollection).flatMap('selection').filter({ 'label': 'COUNTRY' }).value();
            
            return countrySelected ? countrySelected[0].externalId : null;
        }

        function isDealerSelected(filterCollection) {
            var levelSelected = getLevelSelected(filterCollection);
            if(levelSelected == 'DEALER') {
                return true;
            }
            else {
                return false;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('filterService', filterService);

    /* @ngInject */
    function filterService($rootScope, $http, $q, storageService, $filter) {
        var mainDeferred,
            mainFilters = [],
            waterfallResponse = [],
            processing = false,
            DEFAULT_PERSISTENT = true,
            DEFAULT_USE_CACHE = true;

        var waterfallContext = {
            _tmp:[],
            filterCache: []
        };

        /** public methods */

        var service = {
            getData: getData,
            onChangeCallback: onChangeCallback,
            clearContext: clearContext,
            getContext: getContext,
            setContext: setContext,
            getFromCache:getFromCache,
            saveToLocalstorage:saveToLocalstorage
        };



        return service;

        /** private methods */

        function clearContext() {
            waterfallContext = {
                _tmp:[],
                filterCache: []
            };
        }

        function getContext() {
            return waterfallContext;
        }

        function setContext(obj) {
            return angular.extend(waterfallContext,obj);
        }

        // main entrance point
        // cancelable (return null on cancel)
        // waterfall register
        function getData(filterDefinition, useCache, persistent, clearContext) {
            /*if (processing) {
                console.error('Multiple filter processes running is not permited');
                return $q.reject('Multiple filter processes running is not permited');
            }

            processing = true;

            if(angular.isDefined(clearContext) && clearContext){ 
                service.clearContext(); 
            }

            mainFilters = filterDefinition;
            waterfallContext.persistent = angular.isDefined(persistent)? persistent : DEFAULT_PERSISTENT;
            mainDeferred = $q.defer();
            // storageService.save('filter', waterfallContext);
            waterfallResponse = [];
            getFromCache(useCache)
                .then(function () {
                    return getFilterGroupMultiple(mainFilters);
                })
                .then(persistFilter)
                .then(function (response) {
                    return mainDeferred.resolve(response);
                })
                .catch(function (error) {
                    return mainDeferred.reject('filterService::getData ->', error);
                })
                .finally(function(){
                    processing = false;
                });*/


            return $q.when();
        }

        function persistFilter(filter) {
            // as tmp is temporal during tree computations, on end of all computations clean update
            waterfallContext._tmp = [];            
            waterfallContext.filterCache = filter;

            if (waterfallContext.persistent) {
                storageService.save('filter', waterfallContext);
            }

            return filter;
        }

        function saveToLocalstorage() {
            storageService.save('filter', waterfallContext);
        }

        // main entry point to interpret json statement
        // first part is for each group make all request and 
        // wrap them within the gruop
        function getFilterGroupMultiple(itemCollection) {
            return _.reduce(itemCollection, function (aggr, item) {
                return aggr
                    .then(function (o) {
                        var acumula = o || [];
                        return getFilterGroup.apply(waterfallContext, [item])
                            .then(function (response) {
                                if (!response) { return acumula; }
                                acumula.push(response);
                                // add to tmp so it can be accesible from other sources
                                waterfallContext._tmp.push(response);
                                return acumula;
                            });
                    });
            }, $q.when(null));
        }

        // foe each group make requests and extend info from command tree for
        // that group with the info returned by request
        function getFilterGroup(item) {
            return getMainFilters(item.sources)
                .then(function (response) {
                    // one request can return an array, but at the end 
                    // we want it to be flat
                    // add requests to group data
                    return _.extend({}, item.group, { data: _.flatten(response) });
                })
                .then(item.group.setSelection)
                .then(item.group.setFilterInfo);
        }

        // main entry point to make an array of requests
        function getMainFilters(filters) {
            return _.reduce(filters, filterWaterfallReducer, $q.when(null));
        }

        // reducer used to make sequencial requests
        // each request is called using as a context 
        // waterfallContext. We assume each filter logic
        // has access to this context and can be modified
        // from within them. So if we need to share info between
        // filters this context can be used.
        // ex: we update the context with the info of project and
        // wave so we can use it to get the right network
        // ex: we use it in case we want to get the filter from 
        // cache/localStorage, to pass this args to the filters contructor        
        function filterWaterfallReducer(aggr, item) {
            return aggr
                .then(function (o) {
                    var acumula = o || [];
                    return getMethod(item)
                        .then(function (response) {
                            if (!response) { return acumula; }
                            // each filter can return an array or a unic element
                            // we need to inject the eventId to the data structure
                            // as we use it to emit events from within the component
                            // in case it's an array we pass the same event to each
                            // element.
                            // ex: network has one only method but it return an array
                            // of elements, all will have the same eventId as this eventId
                            // is linked to the method used to request data
                            // ex: in case of project and wave each method returns one element
                            // each, so each one has its own event.
                            if (_.isArray(response.data)) {
                                response.data = _.map(response.data, function (subitem) {
                                    subitem.eventId = item.eventId;
                                    return subitem;
                                });
                            } else {
                                response.data.eventId = item.eventId;
                            }

                            acumula.push(response.data);
                            return acumula;
                        });
                });
        }

        function getMethod(item) {
            if (item.state === 'cache') {
                return $q.when(getComboData(item.eventId));
            } else {
                return item.method['getFilter'].apply(waterfallContext, item.args);
            }
        }

        function getComboData(eventId) {
            var combo;
            combo = _.chain(waterfallContext.filterCache)
                .map('data')
                .flatten()
                .filter({ eventId: eventId })
                .value();

            return { data: combo };
        }

        // method used to restore filters from localStorage, it should only update 
        // waterfallContext each filter will make use of it as needed
        function getFromCache(useCache) {
            var storedFilter = storageService.retrieve('filter');
            if (angular.isUndefined(useCache)) {
                useCache = DEFAULT_USE_CACHE;
            }
            
            if (!useCache || !storedFilter) { 
                return $q.resolve(null); 
            } else {
                waterfallContext = storedFilter;
                return $q.resolve(null);
            }


            /*return decodeSelectedId(storedFilter.selectedId, storedFilter.wave)
                .then(function (data) {
                    return data.data.response;
                });
            */
        }

        // transform id to hash
        /*function decodeSelectedId(node, wave) {
            var params = {
                token: loginService.getToken(),
                networkName: node.network,
                nodeExternalId: node.node,
                referenceDate: $filter('waveToFullDate')(wave)
            };

            return $http({
                method: 'GET',
                url: './api/networks/networkLinkToNodeId',
                params: params
            });
        }*/

        function onChangeCallback(event, object, eventId,emit) {
            
            if (!emit) {emit = true;}

            return $q.when(updateChangedItem(eventId, object))
                .then(function (nodes) {
                    return resolveDependencies(nodes, eventId);
                })
                .then(updateNodeTree)
                .then(persistFilter)
                .then(function (data) {
                    if (emit) {
                        $rootScope.$emit('filter:update', { data: data });
                    }
                    return data;
                });

        }

        function updateChangedItem(eventId, object) {
            var event = _.chain(mainFilters).flatMap('sources').find({eventId:eventId}).value();
            var resetEventObj;

            // when updating by an event could happen need to clear some selections from context, 
            // that can be done using resetContext in sources (it's an array with the names of the
            // eventids to clear')
            if (event && event.resetContext) {
                
                resetEventObj = _.reduce(event.resetContext,function(aggr,item) { 
                    aggr[item]=null;return aggr;}
                ,{});

                waterfallContext = _.extend({},waterfallContext,resetEventObj);
            }

            var nodes = _.map(waterfallContext['filterCache'], function (node) {
                var datos = _.map(node.data, function (subnode) {
                    if (subnode.eventId === eventId) {
                        subnode.selectedNode = object.id;
                    }
                    return subnode;
                });

                node.data = datos;
                return node;
            });

            if (!nodes) {
                throw ('filterService::updateChangedItem -> On update node does not exist');
            }

            waterfallContext[eventId] = object.id;
            return nodes;
        }

        function resolveDependencies(nodes, eventId) {
            var actionTree = angular.copy(mainFilters);

            actionTree = _.map(actionTree, function (parent) {
                parent.sources = _.map(parent.sources, function (child) {
                    if (child.deps && child.deps.indexOf(eventId) != -1) {
                        if (child.alwaysReprocess) {
                            waterfallContext[child.eventId] = null;
                        }
                        child.state = 'pending';
                    } else {
                        child.state = 'cache';
                    }

                    if (child.alwaysReprocess && child.eventId === eventId) {
                        child.state = 'pending';
                    }

                    return child;
                });

                return parent;
            });

            return actionTree;
        }

        function updateNodeTree(actionTree) {
            return getFilterGroupMultiple(actionTree);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('exportService', exportService);

    exportService.$inject = ['$q','$timeout', '$http','$log','$document'];
    function exportService($q, $timeout, $http, $log,$document) {
        var service = {
            downloadUrl: downloadVfsUrl
        };

        return service;

        /** private methods */
        function downloadVfsUrl(url) {
            var deferred = $q.defer(); 
            $log.log('downloading', url); 
 
            var hiddenIFrameID = new Date().toDateString(); 
            var iframe = $document && $document[0] && $document[0].createElement('iframe'); 
            iframe.id = hiddenIFrameID; 
            iframe.style.display = 'none'; 
            $document[0].body.appendChild(iframe); 
            iframe.src = url; 
            $timeout(function () { 
                if (iframe.remove) { 
                    iframe.remove(); 
                } else { 
                    iframe.removeNode(true); 
                } 
                $log.log('download succesful'); 
                deferred.resolve(); 
            }, 3000); 
            return deferred.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('errorHandlerService', errorHandlerService);

    errorHandlerService.$inject = ['$log', 'toastr', '$translate'];
    function errorHandlerService($log, toastr, $translate) {
        var service = {};
        service.log = log;
        service.callbackError = callbackError;
        service.callbackSuccess = callbackSuccess;
        service.callbackWarning = callbackWarning;

        return service;

        /** private methods */

        function log(type, message) {
            if (type === 'log') {
                $log.log(message);
            }
            else if (type === 'warn') {
                $log.warn(message);
            }
            else if (type === 'error') {
                $log.error(message);
            }
        }

        function callbackSuccess() {
            var text = this && this.text;
            var options = this && this.options;
            toastr.success($translate.instant(text),null,options);
        }

        function callbackWarning() {
            var text = this && this.text;
            var options = this && this.options; 
            toastr.warning($translate.instant(text),null,options);
        }

        function callbackError(error) {
            var _error;

            var options = this && this.options;

            if (error.data && error.data.error) {
                _error = error.data.error;
            } else if (error.data === null) {
                throw (_error);
            } else {
                _error = error;
            }

            toastr.error($translate.instant(_error), options);
            throw (_error);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('waveToFullDate', waveToFullDate)
        .filter('waveToOla', waveToOla)
        .filter('lodashRange', lodashRange)
        .filter('trustAsHTML', trustAsHTML)
        .filter('projectFormat', projectFormat)
        .filter('decodeUri',decodeUri)
        .filter('toLocaleDate',toLocaleDate)
        .filter('calcTo100',calcTo100)
        .filter('nullToString',nullToString)
        .filter('htmlToString',htmlToString)
        .filter('cubeTitleGetTranslation',cubeTitleGetTranslation)
        .filter('quarterWave', quarterWave)
        .filter('separateCamelCase', separateCamelCase)
        .filter('fixedDecimal', fixedDecimal)
        .filter('filterToString', filterToString)
        .filter('formatThousands', formatThousands)
        .filter('boldWords',boldWords);


    /* @ngInject */
    function waveToFullDate() {
        return function (wave) {

            var year = wave.substr(0, 4),
                month = wave.substr(4, 2),
                day = '02';

            return year + '-' + month + '-' + day;

        };
    }

    /* @ngInject */
    function waveToOla() {
        return function (wave) {

            switch (wave) {
                case '01':
                    return '1ª Ola';
                case '02':
                    return '2ª Ola';
                case '03':
                    return '3ª Ola';
            }
        };
    }

    lodashRange.$inject = ['errorHandlerService'];
    function lodashRange(errorHandlerService) {
        return function(value) {
            try {
                if (!value) {return [];}
                
                var num = parseInt(value);
                
                return _.range(num);    
            } catch (error) {
                errorHandlerService.log('error','lodashRange --> Not valid number');
                return [];
            }
        };
    }

    trustAsHTML.$inject = ['$sce'];
    function trustAsHTML($sce) {
        return function(value) {
            return $sce.trustAsHtml(value);
        };
    }

    projectFormat.$inject = ['filterHelperService'];
    function projectFormat(filterHelperService) {
        return function(value, origin, target) {
            return filterHelperService.projectCodeManager(value, origin, target);
        };
    }

    function decodeUri() {
        return function(value) {
            return decodeURIComponent(value); 
        };
    }

    toLocaleDate.$inject = ['moment'];
    function toLocaleDate(moment) {
        return function(value) {
            return moment(value).format('lll'); 
        };
    }
    
    function htmlToString() {
        return function(value) {
            // clone element so the mutations don't affect the element origin
            var width = value.clientWidth;
            var _element = angular.element(value).clone();
            // remove elements specified with no-snapshot 
            _element.find('.no-snapshot').remove();
            //also the highcharts tooltips
            _element.find('.highcharts-tooltip').remove();

            // put it on the middle
            _element = _element.css({'width': width+'px'});

            // return the node stringified             
            return _element.get(0).outerHTML;
        };
    }

    calcTo100.$inject = ['errorHandlerService'];
    function calcTo100(errorHandlerService) {
        return function(value,max,min) {
            var _total,_value;

            _total = max-min;
            _value = value-min;

            if (_value > 0 && min < 0) {
                _value -= min;
            }

            if (_total === 0) {
                errorHandlerService.log('error','calcTo100::Error 0 divisor');
                return 0;
            }
            
            return  (_value*100)/_total;
        };
    }

    function nullToString() {
        return function(value,outputString) {
            return  angular.isUndefined(value) || value === null || value === ''? outputString:value;
        };
    }

    function cubeTitleGetTranslation() {
        return function(value) {
            var output;
            if (angular.isUndefined(value) || value === null) {
                return '';
            }

            output = value.match(/\^.*$/);

            if (!output) {
                return '';
            }

            return output[0].replace('^','');
        };
    }

    function quarterWave(){
        return function(value) {
            var year = value.toString().substring(0, 4);
            var quarter = parseInt(value.toString().substring(4, 6));

            return quarter + 'ª Ola ' + (year === 'xxxx' ? '' : year);
        };
    }

    function separateCamelCase(){
        return function(value){
            return value
            // insert a space before all caps
            .replace(/([A-Z])/g, ' $1')
            // uppercase the first character
            .replace(/^./, function(str){ return str.toUpperCase(); });
        };
    }

    fixedDecimal.$inject = ['globalHelpersService'];
    function fixedDecimal(globalHelpersService){
        return function(value){
            return globalHelpersService.frontFixedDecimal(value);
        };
    }

    function filterToString(){
        return function(wave, station, program){
            var newWave = quarterWave()(wave);
            var newStation = station.label;
            var newProgram = program && program.id !== 'TOTAL' ? ', ' + program.label : '';

            return newWave + ', ' + newStation + newProgram;
        };
    }

    /**
     * Ponemos los puntos a los miles.
     * Ej: 25000 --> 25.000
     */
    function formatThousands(){
        return function(value){
            return parseInt(value).toLocaleString('es');
        };
    }

    function boldWords(){
        return function(value, wordsToBold){
            var input = value.split(' ');
            var finalTexT = '<p>';
            _.chain(input).each(function(item,index){
                if(_.includes(wordsToBold, input[index])){
                    finalTexT += ' <span class="bold--700"> '+ (item && item.toUpperCase()) +' </span> ';
                }
                else{
                    finalTexT += ' '+(item && item.toUpperCase()) +' ';
                }
            }).value();
            finalTexT += '</p>';
            return finalTexT;
        };
    }

})();
(function() {
'use strict';

  angular
    .module('app.core')
    .factory('configurationLoaderService', configurationLoaderService);

  /* ngInject */
  function configurationLoaderService($http,errorHandlerService) {
    var service = {
      getRemoteConfig:getRemoteConfig,
      getConfig:getConfig,
      getMenu: getMenu
    };

    var config;
    
    return service;

    /** private methods */
    function getRemoteConfig() {
      return $http({
        method:'GET',
        url:'./data/config.json'
      })
      .then(function(data) {
        config = data.data;
        errorHandlerService.log('log','configurationLoaderService OK');
      });
    }

    function getConfig() {
      return config;
    }

    function getMenu(menuCollection, roles){
      var visibleMenuCollection = _.map(menuCollection, function(item){
        item.visible = item.allowedRoles && item.allowedRoles.length > 0 && _.intersection(item.allowedRoles, roles).length === 0 ? false : true;
        return item; 
      });
      
      return angular.copy(visibleMenuCollection);
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('cineService', cineService);

    /** @ngInject */
    function cineService($http, $q, errorHandlerService) {
        var service = {
            getDobleDonutData: getDobleDonutData,
            getPenData: getPenData,
            getPerData: getPerData
        };

        return service;

        ////////////////

        function getDobleDonutData(wave) {
            return $q.all([getCineOuterDonut(wave), getCineInnerDonut(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPenData(wave) {
            return $q.all([getCinePenSex(wave), getCinePenEdad(wave), getCinePenNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getPerData(wave) {
            return $q.all([getCinePerSex(wave), getCinePerEdad(wave), getCinePerNise(wave)])
                .then(parseData)
                .catch(errorHandlerService.callbackError);
        }

        function getCineOuterDonut(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "CINE2",
                  "query": "CINE2",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                if(!data.series || data.series.length < 0 || !data.categories | data.categories.length < 0){return null;}
                else {
                    return {
                        legend: _.flatMap(data.series, 'text'),
                        data: _.chain(data.series).map(function(item){return parseFloat(_.first(item.values));}).value()
                    };
                }
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getCineInnerDonut(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "CINE1",
                  "query": "CINE1",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                if(!data.series || data.series.length < 0 || !data.categories | data.categories.length < 0){return null;}
                else {
                    return  _.chain(data.series).map(function(item){return parseFloat(_.first(item.values));}).value();
                    }
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getCinePenSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "CIPENSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getCinePenEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "CIPENEDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getCinePenNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "CIPENNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    item.value = item.value/100;
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getCinePerSex(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "CIPERSEX",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? _.chain(data.categories).reduce(function(aggr,item, index){
                    item.value = data.series[0].values[index] && parseFloat(data.series[0].values[index]);
                    aggr.push(item);
                    return aggr;
                },[]).value() : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getCinePerEdad(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "CIPEREDAD",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function getCinePerNise(wave) {
            return $http({
                method:'POST',
                url:'./crosstab/operations/AIMC/extract',
                data: {
                  "datasource": "ESTRUC",
                  "query": "CIPERNISE",
                  "parameters": { "$wave$": wave},
                  "transform": {
                    "template": "Evolution",
                    "parameters": {
                      "categories": "Columns",
                      "series": "Rows"
                    }
                  }
                }
            })
            .then(transformData)
            .then(function(data){
                return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
                    values: _.flatMap(data.series, 'values') && _.flatMap(data.series, 'values').length > 0 && _.flatMap(data.series, 'values').map(function(item){return parseFloat(item);}),
                    text: _.flatMap(data.categories, 'text')
                } : null;
            })
            .catch(function(){
                return $q.when(null);
            });
        }

        function transformData(data) {
            return data && data.data;
        }

        function parseData(data) {
            return data;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.cine', {
                url: '/cine',
                views: {
                    content: {
                        templateUrl: 'app/cine/cine.html',
                        controller: 'CineController',
                        controllerAs: 'cineController'
                    }
                },
                resolve: {                    
                    transition: ['$timeout','configurationLoaderService','configuration', function ($timeout,configurationLoaderService,configuration) {
                        return $timeout(function () { }, configurationLoaderService.getConfig().configurationTimeout);
                    }]
                },
                public:true
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('CineController', CineController);

    /** @ngInject */  
    function CineController(cineService, errorHandlerService, mainService, $rootScope, stateManagerService, $scope) {
        var vm = this;
        vm.id = 'cine';
        vm.selectedWave = null;
        vm.menuData = mainService.audienceDataState;
        vm.penWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.perWidget = {
            loading: false,
            sexo: [],
            edad: [],
            iso: []
        };
        vm.dobleDonutWidget = {
            loading: false,
            outer: {
                data: null,
                legend: null
            },
            inner: []
        };
       
        init();

        /** listeners */ 
        var changeWaveWatcher = $rootScope.$on('main:changeWave', init); 
 
        $scope.$on('$destroy', function () { 
            changeWaveWatcher(); 
        });


        ////////////////

        function init() {            
            vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
            vm.dobleDonutWidget.dobleDonutWidgetFormatFn = copyDobleDonutWidgetToClipboard;
            vm.penWidget.penWidgetFormatFn =  copyPenWidgetToClipboard;
            vm.perWidget.perWidgetFormatFn =  copyPerWidgetToClipboard;
            if(vm.selectedWave && vm.selectedWave.fullWave) {
                getGeneralAudienceData();
                getDobleDonutData();
                getPenData();
                getPerData();
            }           
        }

        function getGeneralAudienceData(){
            mainService.getAudienceData()
            .then(function(data) {
                vm.menuData = data;
            })
            .catch(cineError);
        }

        function getDobleDonutData() {
            vm.dobleDonutWidget.loading = true;
            cineService.getDobleDonutData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.dobleDonutWidget.outer = data[0];
                vm.dobleDonutWidget.inner = data[1];
            })
            .catch(cineError)
            .finally(function(){ vm.dobleDonutWidget.loading = false; });
        }

        function getPenData() {
            vm.penWidget.loading = true;
            cineService.getPenData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.penWidget.sexo = data[0];
                vm.penWidget.edad = data[1];
                vm.penWidget.iso = data[2];
            })
            .catch(cineError)
            .finally(function(){ vm.penWidget.loading = false; });
        }

        function getPerData() {
            vm.perWidget.loading = true;
            cineService.getPerData(vm.selectedWave.fullWave)
            .then(function(data) {
                vm.perWidget.sexo = data[0];
                vm.perWidget.edad = data[1];
                vm.perWidget.iso = data[2];
            })
            .catch(cineError)
            .finally(function(){ vm.perWidget.loading = false; });
        }


        function cineError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyDobleDonutWidgetToClipboard(data) {
            var title = 'HÁBITO DE ASISTENCIA';
            var nunca = 'Nunca o casi nunca' + '\t' + data.inner[1].toLocaleString();
            var alguna = 'Alguna vez' + '\t' + data.inner[0].toLocaleString();
            var chartData = _.reduce(data.outer.legend, function(aggr, item, index) {
                var row = item + '\t' + data.outer.data[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title, nunca, alguna, chartData);
            return formattedData.join('\n');
        }

        function copyPenWidgetToClipboard(data) {
            var title = 'PENETRACIÓN POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso, function(aggr, item) {
                var row = item.text + '\t' + (item.value*100).toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }

        function copyPerWidgetToClipboard(data) {
            var title = 'PERFIL POR TARGETS';
            var title1 = 'POR SEXO';
            var title2 = 'POR EDAD';
            var title3 = 'POR ÍNDICE SOCIOECONÓMICO';
            var chart1Data = _.reduce(data.sexo, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart2Data = _.reduce(data.edad.text, function(aggr, item, index) {
                var row = item + '\t' + data.edad.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var chart3Data = _.reduce(data.iso.text, function(aggr, item, index) {
                var row = item + '\t' + data.iso.values[index].toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            var formattedData = [].concat(title,title1, chart1Data, title2, chart2Data, title3, chart3Data);
            return formattedData.join('\n');
        }
        
    }
})();
(function() {
  'use strict';

  angular
      .module('app')
      .factory('cockpitService', cockpitService);

  /** @ngInject */
  function cockpitService($http, mainService,$q) {
      var service = {
        getEvoPenData: getEvoPenData
      };

      return service;

      ////////////////
      function getEvoPenData(wave) {
        return $http({
            method:'POST',
            url:'./crosstab/operations/AIMC/extract',
            data: {
              "datasource": "EVMEDIOS",
              "query": "EVMEDIOS",
              "statistic": "pcol",
              "parameters": { "$wave$": wave},
              "transform": {
                "template": "Evolution",
                "parameters": {
                  "categories": "Columns",
                  "series": "Rows"
                }
              }
            }
        })
        .then(transformData)
        .then(function(data){
          var audience = mainService.audienceDataState;
          var collection = [];
          return data.series && data.series.length > 0 && data.categories && data.categories.length > 0 ? {
            categories: _.flatMap(data.categories, 'text'),
            series: _.reduce(audience, function (aggr, item, index) {
              var object = {
                color: null,
                name: null,
                data: []
              };
            var found = _.find(data.series, function(seriesItem) {
                return _.includes(item.id, seriesItem.id);
            });
              if(found){
                object.color = item.colors.front;
                object.name = item.text;
                object.data = _.map(found.values, function(item){ return parseFloat(item);});
                aggr.push(object);
              }
              return aggr;
            }, [])
        } : null;
        })
        .catch(function(){
            return $q.when(null);
        });
    }

    function transformData(data) {
      return data && data.data;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.cockpit', {
                url: '/cockpit',
                breadcrumb: {icon: 'icon-home',parentlabel: 'MAIN_HOME',label: 'MAIN_HOME_COCKPIT'},
                views: {
                    content: {
                        templateUrl: 'app/cockpit/cockpit.html',
                        controller: 'CockpitController',
                        controllerAs: 'cockpit'
                    }
                },
                resolve: {
                    transition: ['$timeout', function ($timeout) {
                        return $timeout(function () { }, 3000);
                    }],
                    availableWaves: ['cockpitService', function (cockpitService){
                        return {};
                    }]
                },
                public:true

            });
    }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .controller('CockpitController', CockpitController);

  /** @ngInject */  
  function CockpitController(cockpitService, errorHandlerService, $rootScope, mainService, stateManagerService, $scope, globalHelpersService) {
      var vm = this;
      vm.audience = {
          data: null,
          loading: false
      };
      vm.evoPenWidget = {
        data: null,
        loading: false,
        title: 'evolución penetración audiencia general de medios (F<span class="lowercase">uente: </span>A<span class="lowercase">cumulados anuales)</span>'
    };
      
      init();

      /** listeners */ 
      var changeWaveWatcher = $rootScope.$on('main:changeWave', init);

      $scope.$on('$destroy', function () { 
          changeWaveWatcher(); 
      });


      ////////////////

      function init() {
        vm.evoPenWidget.data = null;
        vm.audience.data = null;
        vm.audience.loading = true; 
        vm.audience.formatFn =  copyAudienceToClipboard;
        vm.evoPenWidget.formatFn =  copyEvoPenToClipboard;
        vm.evoPenWidget.loading = true;  
        vm.selectedWave = stateManagerService.getState('waveCollection') && stateManagerService.getState('waveCollection').selected;
        if(vm.selectedWave && vm.selectedWave.fullWave) {
            getAudience();
            getEvoPen(vm.selectedWave.fullWave);
        }                
      }

        function getAudience() {
            mainService.getAudienceData()
            .then(function(data) {
                if(data && data.length > 0 ) {
                    vm.audience.data = data;   
                }
                else {
                    vm.audience.data = null;
                }
            })
            .finally(function() {
                vm.audience.loading = false;
            });
        }

        function getEvoPen(wave) {
            cockpitService.getEvoPenData(wave)
            .then(function(data) {
                if(data) {
                    vm.evoPenWidget.data = data;
                }
                else {
                    vm.evoPenWidget.data = null;
                }
            })
            .catch(cockpitError)
            .finally(function(){ vm.evoPenWidget.loading = false; });
        }

        function cockpitError(error){
            errorHandlerService.callbackError('Error recuperando los datos');
        }

        function copyAudienceToClipboard(data) {
            var formattedData = _.reduce(data, function(aggr, item) {
                var row = item.text + '\t' + item.value.toLocaleString();
                aggr.push(row);
                return aggr;
                }, []);
            return formattedData.join('\n');
        }

        function copyEvoPenToClipboard(data) {
            var columns = '\t';
            _.forEach(data.categories, function(item) { columns = columns + item + '\t';});
            var formattedData = _.reduce(data.series, function(aggr, item) {
                var row = item.name + '\t';
                _.forEach(item.data, function(item) { row = row + item.toLocaleString() + '\t';});
                aggr.push(row);
                return aggr;
                }, []);
            var totalData = [].concat(columns, formattedData);
            return totalData.join('\n');
        } 
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($state, errorHandlerService, configurationLoaderService, routingService, $rootScope, $window, storageService, Highcharts) {
    errorHandlerService.log('log', 'Enter run block');

    // register callbacks on route change
    routingService.registerCallbacks();

    Highcharts.setOptions({
      lang: {
        thousandsSep: '.',
        decimalPoint: ','
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        public:true
      });

    $urlRouterProvider.otherwise('/main/cockpit');
  }

})();

/* global moment:false, _:false, d3:false, Highcharts:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('moment', moment)
    .constant('lodash', _)
    .constant('Highcharts', Highcharts)
    .constant('d3',d3);
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig,$translateProvider,$httpProvider, tokenInterceptorProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // translations
    //$translateProvider.useLoader('i18nService', {});
    //$translateProvider.preferredLanguage('en');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-bottom-full-width';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = false;

    $httpProvider.interceptors.push('tokenInterceptor');

    
  }

})();
